export const data = [
  {
    id: 663858,
    value: {
      vegetarian: true,
      vegan: true,
      glutenFree: true,
      dairyFree: true,
      veryHealthy: false,
      cheap: false,
      veryPopular: false,
      sustainable: false,
      weightWatcherSmartPoints: 3,
      gaps: "no",
      lowFodmap: false,
      aggregateLikes: 11,
      spoonacularScore: 63.0,
      healthScore: 13.0,
      creditsText: "Foodista.com – The Cooking Encyclopedia Everyone Can Edit",
      license: "CC BY 3.0",
      sourceName: "Foodista",
      pricePerServing: 89.87,
      extendedIngredients: [
        {
          id: 99001,
          aisle: "Milk, Eggs, Other Dairy",
          image: "coconut-milk.png",
          consistency: "liquid",
          name: "coconut milk beverage",
          nameClean: "coconut milk beverage",
          original: "1 cup unsweetened coconut beverage, divided",
          originalName: "unsweetened coconut beverage, divided",
          amount: 1.0,
          unit: "cup",
          meta: ["unsweetened", "divided"],
          measures: {
            us: { amount: 1.0, unitShort: "cup", unitLong: "cup" },
            metric: {
              amount: 236.588,
              unitShort: "ml",
              unitLong: "milliliters",
            },
          },
        },
        {
          id: 99009,
          aisle: "Canned and Jarred",
          image: "coconut-milk.jpg",
          consistency: "liquid",
          name: "light coconut milk",
          nameClean: "light coconut milk",
          original: "1 cup light coconut milk",
          originalName: "light coconut milk",
          amount: 1.0,
          unit: "cup",
          meta: ["light"],
          measures: {
            us: { amount: 1.0, unitShort: "cup", unitLong: "cup" },
            metric: {
              amount: 236.588,
              unitShort: "ml",
              unitLong: "milliliters",
            },
          },
        },
        {
          id: 9176,
          aisle: "Produce",
          image: "mango.jpg",
          consistency: "solid",
          name: "mango",
          nameClean: "mango",
          original: "1 cup mango, fresh or frozen",
          originalName: "mango, fresh or frozen",
          amount: 1.0,
          unit: "cup",
          meta: ["fresh"],
          measures: {
            us: { amount: 1.0, unitShort: "cup", unitLong: "cup" },
            metric: {
              amount: 236.588,
              unitShort: "ml",
              unitLong: "milliliters",
            },
          },
        },
        {
          id: 19911,
          aisle: "Cereal",
          image: "maple-syrup.png",
          consistency: "liquid",
          name: "maple syrup",
          nameClean: "maple syrup",
          original:
            "3 1/2 to 4 1/2 Tbs maple syrup, divided (add more if necessary)",
          originalName: "maple syrup, divided (add more if necessary)",
          amount: 3.5,
          unit: "Tbs",
          meta: ["divided", "(add more if necessary)"],
          measures: {
            us: { amount: 3.5, unitShort: "Tbs", unitLong: "Tbs" },
            metric: { amount: 3.5, unitShort: "Tbs", unitLong: "Tbs" },
          },
        },
        {
          id: 9266,
          aisle: "Produce",
          image: "pineapple.jpg",
          consistency: "solid",
          name: "pineapple",
          nameClean: "pineapple",
          original: "3/4 cup pineapple, fresh or frozen",
          originalName: "pineapple, fresh or frozen",
          amount: 0.75,
          unit: "cup",
          meta: ["fresh"],
          measures: {
            us: { amount: 0.75, unitShort: "cups", unitLong: "cups" },
            metric: {
              amount: 177.441,
              unitShort: "ml",
              unitLong: "milliliters",
            },
          },
        },
        {
          id: null,
          aisle: "?",
          image: null,
          consistency: null,
          name: "popsicle moulds",
          nameClean: null,
          original: "6 popsicle moulds",
          originalName: "popsicle moulds",
          amount: 6.0,
          unit: "",
          meta: [],
          measures: {
            us: { amount: 6.0, unitShort: "", unitLong: "" },
            metric: { amount: 6.0, unitShort: "", unitLong: "" },
          },
        },
      ],
      id: 663858,
      title: "Tropical Ice Pops",
      readyInMinutes: 45,
      servings: 6,
      sourceUrl: "http://www.foodista.com/recipe/KCTN2T42/tropical-ice-pops",
      image: "https://spoonacular.com/recipeImages/663858-556x370.jpg",
      imageType: "jpg",
      summary:
        'Tropical Ice Pops might be just the dessert you are searching for. This recipe serves 6 and costs 93 cents per serving. Watching your figure? This gluten free and vegan recipe has <b>101 calories</b>, <b>0g of protein</b>, and <b>3g of fat</b> per serving. A mixture of pineapple, popsicle moulds, mango, and a handful of other ingredients are all it takes to make this recipe so delicious. This recipe is liked by 11 foodies and cooks. From preparation to the plate, this recipe takes about <b>45 minutes</b>. All things considered, we decided this recipe <b>deserves a spoonacular score of 64%</b>. This score is good. Try <a href="https://spoonacular.com/recipes/how-to-make-a-tropical-ice-cream-sandwich-908115">How to make a Tropical Ice Cream Sandwich</a>, <a href="https://spoonacular.com/recipes/cold-brew-coffee-latte-ice-pops-912354">Cold Brew Coffee Latte Ice Pops</a>, and <a href="https://spoonacular.com/recipes/tropical-strawberry-pops-450382">Tropical Strawberry Pops</a> for similar recipes.',
      cuisines: [],
      dishTypes: ["side dish"],
      diets: ["gluten free", "dairy free", "lacto ovo vegetarian", "vegan"],
      occasions: [],
      winePairing: {},
      instructions:
        "<ol><li>Pure the mango, pineapple, 3/4 cup coconut beverage and 1 1/2 tablespoon maple syrup in a blender.</li><li>Pour equal amounts of the mixture into each mould.</li><li>In a small bowl, mix the coconut milk, 1/4 cup of coconut beverage, and 2-3 TBS of maple syrup (adjust the sweetness to your taste).</li><li>Pour equal amounts of the coconut mixture on top of the fruit pure.</li><li>Insert a popsicle stick into each of the moulds, leaving about a quarter of the stick above the mould.</li><li>Freeze the popsicles for about 2 to 3 hours.</li><li>To remove the ice pops from the moulds, run them under warm to hot water for about 5 to 10 seconds before pulling them out.</li></ol>",
      analyzedInstructions: [
        {
          name: "",
          steps: [
            {
              number: 1,
              step: "Pure the mango, pineapple, 3/4 cup coconut beverage and 1 1/2 tablespoon maple syrup in a blender.",
              ingredients: [
                {
                  id: 19911,
                  name: "maple syrup",
                  localizedName: "maple syrup",
                  image: "maple-syrup.png",
                },
                {
                  id: 9266,
                  name: "pineapple",
                  localizedName: "pineapple",
                  image: "pineapple.jpg",
                },
                { id: 0, name: "drink", localizedName: "drink", image: "" },
                {
                  id: 12104,
                  name: "coconut",
                  localizedName: "coconut",
                  image: "coconut.jpg",
                },
                {
                  id: 9176,
                  name: "mango",
                  localizedName: "mango",
                  image: "mango.jpg",
                },
              ],
              equipment: [
                {
                  id: 404726,
                  name: "blender",
                  localizedName: "blender",
                  image: "blender.png",
                },
              ],
            },
            {
              number: 2,
              step: "Pour equal amounts of the mixture into each mould.In a small bowl, mix the coconut milk, 1/4 cup of coconut beverage, and 2-3 TBS of maple syrup (adjust the sweetness to your taste).",
              ingredients: [
                {
                  id: 12118,
                  name: "coconut milk",
                  localizedName: "coconut milk",
                  image: "coconut-milk.png",
                },
                {
                  id: 19911,
                  name: "maple syrup",
                  localizedName: "maple syrup",
                  image: "maple-syrup.png",
                },
                { id: 0, name: "drink", localizedName: "drink", image: "" },
                {
                  id: 12104,
                  name: "coconut",
                  localizedName: "coconut",
                  image: "coconut.jpg",
                },
              ],
              equipment: [
                {
                  id: 404783,
                  name: "bowl",
                  localizedName: "bowl",
                  image: "bowl.jpg",
                },
              ],
            },
            {
              number: 3,
              step: "Pour equal amounts of the coconut mixture on top of the fruit pure.Insert a popsicle stick into each of the moulds, leaving about a quarter of the stick above the mould.Freeze the popsicles for about 2 to 3 hours.To remove the ice pops from the moulds, run them under warm to hot water for about 5 to 10 seconds before pulling them out.",
              ingredients: [
                {
                  id: 12104,
                  name: "coconut",
                  localizedName: "coconut",
                  image: "coconut.jpg",
                },
                {
                  id: 9431,
                  name: "fruit",
                  localizedName: "fruit",
                  image: "mixed-fresh-fruit.jpg",
                },
                {
                  id: 14412,
                  name: "water",
                  localizedName: "water",
                  image: "water.png",
                },
                {
                  id: 10014412,
                  name: "ice",
                  localizedName: "ice",
                  image: "ice-cubes.png",
                },
              ],
              equipment: [
                {
                  id: 408704,
                  name: "popsicle sticks",
                  localizedName: "popsicle sticks",
                  image: "popsicle-sticks.jpg",
                },
              ],
              length: { number: 180, unit: "minutes" },
            },
          ],
        },
      ],
      originalId: null,
      spoonacularSourceUrl: "https://spoonacular.com/tropical-ice-pops-663858",
    },
  },
  {
    id: 652976,
    value: {
      vegetarian: true,
      vegan: false,
      glutenFree: false,
      dairyFree: false,
      veryHealthy: false,
      cheap: false,
      veryPopular: false,
      sustainable: false,
      weightWatcherSmartPoints: 7,
      gaps: "no",
      lowFodmap: false,
      aggregateLikes: 17,
      spoonacularScore: 19.0,
      healthScore: 1.0,
      creditsText: "Foodista.com – The Cooking Encyclopedia Everyone Can Edit",
      license: "CC BY 3.0",
      sourceName: "Foodista",
      pricePerServing: 55.35,
      extendedIngredients: [
        {
          id: 9003,
          aisle: "Produce",
          image: "apple.jpg",
          consistency: "solid",
          name: "apples",
          nameClean: "apple",
          original: "2 large apples, peeled and diced",
          originalName: "apples, peeled and diced",
          amount: 2.0,
          unit: "large",
          meta: ["diced", "peeled"],
          measures: {
            us: { amount: 2.0, unitShort: "large", unitLong: "larges" },
            metric: { amount: 2.0, unitShort: "large", unitLong: "larges" },
          },
        },
        {
          id: 19334,
          aisle: "Baking",
          image: "dark-brown-sugar.png",
          consistency: "solid",
          name: "brown sugar",
          nameClean: "golden brown sugar",
          original: "1 tablespoon brown sugar",
          originalName: "brown sugar",
          amount: 1.0,
          unit: "tablespoon",
          meta: [],
          measures: {
            us: { amount: 1.0, unitShort: "Tbsp", unitLong: "Tbsp" },
            metric: { amount: 1.0, unitShort: "Tbsp", unitLong: "Tbsp" },
          },
        },
        {
          id: 1017,
          aisle: "Cheese",
          image: "cream-cheese.jpg",
          consistency: "solid",
          name: "cream cheese",
          nameClean: "cream cheese",
          original: "4 ounces cream cheese, very cold and cubed",
          originalName: "cream cheese, very cold and cubed",
          amount: 4.0,
          unit: "ounces",
          meta: ["very cold", "cubed"],
          measures: {
            us: { amount: 4.0, unitShort: "oz", unitLong: "ounces" },
            metric: { amount: 113.398, unitShort: "g", unitLong: "grams" },
          },
        },
        {
          id: 1125,
          aisle: "Milk, Eggs, Other Dairy",
          image: "egg-yolk.jpg",
          consistency: "solid",
          name: "egg yolk",
          nameClean: "egg yolk",
          original: "1 egg yolk",
          originalName: "egg yolk",
          amount: 1.0,
          unit: "",
          meta: [],
          measures: {
            us: { amount: 1.0, unitShort: "", unitLong: "" },
            metric: { amount: 1.0, unitShort: "", unitLong: "" },
          },
        },
        {
          id: 18338,
          aisle: "Refrigerated;Frozen",
          image: "filo-dough.png",
          consistency: "solid",
          name: "filo dough",
          nameClean: "filo pastry",
          original: "Dough",
          originalName: "Dough",
          amount: 16.0,
          unit: "servings",
          meta: [],
          measures: {
            us: { amount: 16.0, unitShort: "servings", unitLong: "servings" },
            metric: {
              amount: 16.0,
              unitShort: "servings",
              unitLong: "servings",
            },
          },
        },
        {
          id: 20081,
          aisle: "Baking",
          image: "flour.png",
          consistency: "solid",
          name: "flour",
          nameClean: "wheat flour",
          original: "cups flour",
          originalName: "flour",
          amount: 1.0,
          unit: "cups",
          meta: [],
          measures: {
            us: { amount: 1.0, unitShort: "cup", unitLong: "cup" },
            metric: {
              amount: 236.588,
              unitShort: "ml",
              unitLong: "milliliters",
            },
          },
        },
        {
          id: 2001,
          aisle: "Spices and Seasonings",
          image: "allspice-ground.jpg",
          consistency: "solid",
          name: "ground allspice",
          nameClean: "allspice",
          original: "1/4 teaspoon ground allspice",
          originalName: "ground allspice",
          amount: 0.25,
          unit: "teaspoon",
          meta: [],
          measures: {
            us: { amount: 0.25, unitShort: "tsps", unitLong: "teaspoons" },
            metric: { amount: 0.25, unitShort: "tsps", unitLong: "teaspoons" },
          },
        },
        {
          id: 2006,
          aisle: "Spices and Seasonings",
          image: "cardamom.jpg",
          consistency: "solid",
          name: "ground cardamom",
          nameClean: "cardamom",
          original: "1/8 teaspoon ground cardamom",
          originalName: "ground cardamom",
          amount: 0.125,
          unit: "teaspoon",
          meta: [],
          measures: {
            us: { amount: 0.125, unitShort: "tsps", unitLong: "teaspoons" },
            metric: { amount: 0.125, unitShort: "tsps", unitLong: "teaspoons" },
          },
        },
        {
          id: 1012010,
          aisle: "Spices and Seasonings",
          image: "cinnamon.jpg",
          consistency: "solid",
          name: "ground cinnamon",
          nameClean: "ground cinnamon",
          original: "1/2 teaspoon ground cinnamon",
          originalName: "ground cinnamon",
          amount: 0.5,
          unit: "teaspoon",
          meta: [],
          measures: {
            us: { amount: 0.5, unitShort: "tsps", unitLong: "teaspoons" },
            metric: { amount: 0.5, unitShort: "tsps", unitLong: "teaspoons" },
          },
        },
        {
          id: 2021,
          aisle: "Spices and Seasonings",
          image: "ginger.png",
          consistency: "solid",
          name: "ground ginger",
          nameClean: "ginger powder",
          original: "1/2 teaspoon ground ginger",
          originalName: "ground ginger",
          amount: 0.5,
          unit: "teaspoon",
          meta: [],
          measures: {
            us: { amount: 0.5, unitShort: "tsps", unitLong: "teaspoons" },
            metric: { amount: 0.5, unitShort: "tsps", unitLong: "teaspoons" },
          },
        },
        {
          id: 9152,
          aisle: "Produce",
          image: "lemon-juice.jpg",
          consistency: "liquid",
          name: "juice of lemon",
          nameClean: "lemon juice",
          original: "Juice of 1/2 lemon",
          originalName: "Juice lemon",
          amount: 0.5,
          unit: "",
          meta: [],
          measures: {
            us: { amount: 0.5, unitShort: "", unitLong: "" },
            metric: { amount: 0.5, unitShort: "", unitLong: "" },
          },
        },
        {
          id: 1082047,
          aisle: "Spices and Seasonings",
          image: "salt.jpg",
          consistency: "solid",
          name: "kosher salt",
          nameClean: "kosher salt",
          original: "1/4 teaspoon kosher salt",
          originalName: "kosher salt",
          amount: 0.25,
          unit: "teaspoon",
          meta: [],
          measures: {
            us: { amount: 0.25, unitShort: "tsps", unitLong: "teaspoons" },
            metric: { amount: 0.25, unitShort: "tsps", unitLong: "teaspoons" },
          },
        },
        {
          id: 19911,
          aisle: "Cereal",
          image: "maple-syrup.png",
          consistency: "liquid",
          name: "maple syrup",
          nameClean: "maple syrup",
          original: "2 tablespoons maple syrup",
          originalName: "maple syrup",
          amount: 2.0,
          unit: "tablespoons",
          meta: [],
          measures: {
            us: { amount: 2.0, unitShort: "Tbsps", unitLong: "Tbsps" },
            metric: { amount: 2.0, unitShort: "Tbsps", unitLong: "Tbsps" },
          },
        },
        {
          id: 1077,
          aisle: "Milk, Eggs, Other Dairy",
          image: "milk.png",
          consistency: "liquid",
          name: "milk",
          nameClean: "milk",
          original: "2 tablespoons milk",
          originalName: "milk",
          amount: 2.0,
          unit: "tablespoons",
          meta: [],
          measures: {
            us: { amount: 2.0, unitShort: "Tbsps", unitLong: "Tbsps" },
            metric: { amount: 2.0, unitShort: "Tbsps", unitLong: "Tbsps" },
          },
        },
        {
          id: 19336,
          aisle: "Baking",
          image: "powdered-sugar.jpg",
          consistency: "solid",
          name: "powdered sugar",
          nameClean: "powdered sugar",
          original: "1/8 cup powdered sugar",
          originalName: "powdered sugar",
          amount: 0.125,
          unit: "cup",
          meta: [],
          measures: {
            us: { amount: 0.125, unitShort: "cups", unitLong: "cups" },
            metric: {
              amount: 29.574,
              unitShort: "ml",
              unitLong: "milliliters",
            },
          },
        },
        {
          id: 19335,
          aisle: "Baking",
          image: "sugar-in-bowl.png",
          consistency: "solid",
          name: "sugar",
          nameClean: "sugar",
          original: "3 tablespoons Sugar",
          originalName: "Sugar",
          amount: 3.0,
          unit: "tablespoons",
          meta: [],
          measures: {
            us: { amount: 3.0, unitShort: "Tbsps", unitLong: "Tbsps" },
            metric: { amount: 3.0, unitShort: "Tbsps", unitLong: "Tbsps" },
          },
        },
        {
          id: 1145,
          aisle: "Milk, Eggs, Other Dairy",
          image: "butter-sliced.jpg",
          consistency: "solid",
          name: "unsalted butter",
          nameClean: "unsalted butter",
          original: "1/2 cup unsalted butter, very cold and cubed",
          originalName: "unsalted butter, very cold and cubed",
          amount: 0.5,
          unit: "cup",
          meta: ["unsalted", "very cold", "cubed"],
          measures: {
            us: { amount: 0.5, unitShort: "cups", unitLong: "cups" },
            metric: {
              amount: 118.294,
              unitShort: "ml",
              unitLong: "milliliters",
            },
          },
        },
        {
          id: null,
          aisle: "?",
          image: null,
          consistency: null,
          name: "frangelico",
          nameClean: null,
          original: "1 teaspoon Frangelico (or vanilla or rum)",
          originalName: "Frangelico (or vanilla or rum)",
          amount: 1.0,
          unit: "teaspoon",
          meta: ["(or vanilla or rum)"],
          measures: {
            us: { amount: 1.0, unitShort: "tsp", unitLong: "teaspoon" },
            metric: { amount: 1.0, unitShort: "tsp", unitLong: "teaspoon" },
          },
        },
      ],
      id: 652976,
      title: "Naturally Sweet Apple Turnovers",
      readyInMinutes: 45,
      servings: 16,
      sourceUrl:
        "http://www.foodista.com/recipe/TYW8P8Z5/naturally-sweet-apple-turnovers",
      image: "https://spoonacular.com/recipeImages/652976-556x370.jpg",
      imageType: "jpg",
      summary:
        'This recipe makes 16 servings with <b>200 calories</b>, <b>3g of protein</b>, and <b>10g of fat</b> each. For <b>54 cents per serving</b>, this recipe <b>covers 4%</b> of your daily requirements of vitamins and minerals. From preparation to the plate, this recipe takes around <b>45 minutes</b>. 17 people were impressed by this recipe. A mixture of frangelico, ground allspice, powdered sugar, and a handful of other ingredients are all it takes to make this recipe so tasty. It is a good option if you\'re following a <b>vegetarian</b> diet. All things considered, we decided this recipe <b>deserves a spoonacular score of 20%</b>. This score is rather bad. Similar recipes include <a href="https://spoonacular.com/recipes/naturally-sweet-honey-blondies-909220">Naturally Sweet Honey Blondies</a>, <a href="https://spoonacular.com/recipes/yam-or-sweet-potato-casserole-naturally-gluten-free-692138">Yam or Sweet Potato Casserole (Naturally Gluten Free)</a>, and <a href="https://spoonacular.com/recipes/sweet-potato-turnovers-with-sweet-kraut-188944">Sweet Potato Turnovers with Sweet Kraut</a>.',
      cuisines: [],
      dishTypes: [
        "antipasti",
        "starter",
        "snack",
        "appetizer",
        "antipasto",
        "hor d'oeuvre",
      ],
      diets: ["lacto ovo vegetarian"],
      occasions: [],
      winePairing: {},
      instructions:
        "<ol><li>Start dough by whisking dry ingredients in a medium sized bowl. Add butter and incorporate with a pastry blender until coarse crumbs develop. Add cream cheese and incorporate well.</li><li>Plop in egg yolk and stir with a fork until dough comes together into a ball.</li><li>Turn dough out onto a floured surface and roll into a uniform ball. Slightly press flat with the palm of your hand and wrap in plastic wrap. Chill at least one hour.</li><li>Once dough has chilled, set it on a floured surface and roll it out to about 10 x 12. Cut into sixten even squares. Lay the dough squares on a parchment paper covered baking sheet and set in the freezer to chill.</li><li>In a separate bowl, toss the apples with the lemon juice, maple syrup, spices and brown sugar. Make sure to cover all of the apple pieces.</li><li>Take dough out of freezer. Drop about 1 tablespoon of filling into the center of each piece of dough. Fold one pointed edge towards its opposite corner to form a triangle.  Crimp edges with a fork along the seams. Repeat with all of the dough.</li><li>Brush a little milk over the top of each turnover and sprinkle with extra sugar if desired. (Pop back into the freezer for a quick chill if the dough is soft.). Bake in a preheated oven at 400 degrees for 20 minutes or until browned.</li></ol>",
      analyzedInstructions: [
        {
          name: "",
          steps: [
            {
              number: 1,
              step: "Start dough by whisking dry ingredients in a medium sized bowl.",
              ingredients: [
                {
                  id: 0,
                  name: "dough",
                  localizedName: "dough",
                  image: "pizza-dough",
                },
              ],
              equipment: [
                {
                  id: 404661,
                  name: "whisk",
                  localizedName: "whisk",
                  image: "whisk.png",
                },
                {
                  id: 404783,
                  name: "bowl",
                  localizedName: "bowl",
                  image: "bowl.jpg",
                },
              ],
            },
            {
              number: 2,
              step: "Add butter and incorporate with a pastry blender until coarse crumbs develop.",
              ingredients: [
                {
                  id: 1001,
                  name: "butter",
                  localizedName: "butter",
                  image: "butter-sliced.jpg",
                },
              ],
              equipment: [
                {
                  id: 404726,
                  name: "blender",
                  localizedName: "blender",
                  image: "blender.png",
                },
              ],
            },
            {
              number: 3,
              step: "Add cream cheese and incorporate well.Plop in egg yolk and stir with a fork until dough comes together into a ball.Turn dough out onto a floured surface and roll into a uniform ball. Slightly press flat with the palm of your hand and wrap in plastic wrap. Chill at least one hour.Once dough has chilled, set it on a floured surface and roll it out to about 10 x 1",
              ingredients: [
                {
                  id: 1017,
                  name: "cream cheese",
                  localizedName: "cream cheese",
                  image: "cream-cheese.jpg",
                },
                {
                  id: 1125,
                  name: "egg yolk",
                  localizedName: "egg yolk",
                  image: "egg-yolk.jpg",
                },
                {
                  id: 0,
                  name: "dough",
                  localizedName: "dough",
                  image: "pizza-dough",
                },
                {
                  id: 0,
                  name: "roll",
                  localizedName: "roll",
                  image: "dinner-yeast-rolls.jpg",
                },
                {
                  id: 10018364,
                  name: "wrap",
                  localizedName: "wrap",
                  image: "flour-tortilla.jpg",
                },
              ],
              equipment: [
                {
                  id: 404730,
                  name: "plastic wrap",
                  localizedName: "plastic wrap",
                  image: "plastic-wrap.jpg",
                },
              ],
              length: { number: 60, unit: "minutes" },
            },
            {
              number: 4,
              step: "Cut into sixten even squares.",
              ingredients: [],
              equipment: [],
            },
            {
              number: 5,
              step: "Lay the dough squares on a parchment paper covered baking sheet and set in the freezer to chill.In a separate bowl, toss the apples with the lemon juice, maple syrup, spices and brown sugar. Make sure to cover all of the apple pieces.Take dough out of freezer. Drop about 1 tablespoon of filling into the center of each piece of dough. Fold one pointed edge towards its opposite corner to form a triangle.  Crimp edges with a fork along the seams. Repeat with all of the dough.",
              ingredients: [
                {
                  id: 19334,
                  name: "brown sugar",
                  localizedName: "brown sugar",
                  image: "dark-brown-sugar.png",
                },
                {
                  id: 9152,
                  name: "lemon juice",
                  localizedName: "lemon juice",
                  image: "lemon-juice.jpg",
                },
                {
                  id: 19911,
                  name: "maple syrup",
                  localizedName: "maple syrup",
                  image: "maple-syrup.png",
                },
                {
                  id: 9003,
                  name: "apple",
                  localizedName: "apple",
                  image: "apple.jpg",
                },
                {
                  id: 2035,
                  name: "spices",
                  localizedName: "spices",
                  image: "spices.png",
                },
                {
                  id: 0,
                  name: "dough",
                  localizedName: "dough",
                  image: "pizza-dough",
                },
              ],
              equipment: [
                {
                  id: 404770,
                  name: "baking paper",
                  localizedName: "baking paper",
                  image: "baking-paper.jpg",
                },
                {
                  id: 404727,
                  name: "baking sheet",
                  localizedName: "baking sheet",
                  image: "baking-sheet.jpg",
                },
                {
                  id: 404783,
                  name: "bowl",
                  localizedName: "bowl",
                  image: "bowl.jpg",
                },
              ],
            },
            {
              number: 6,
              step: "Brush a little milk over the top of each turnover and sprinkle with extra sugar if desired. (Pop back into the freezer for a quick chill if the dough is soft.).",
              ingredients: [
                {
                  id: 0,
                  name: "dough",
                  localizedName: "dough",
                  image: "pizza-dough",
                },
                {
                  id: 19335,
                  name: "sugar",
                  localizedName: "sugar",
                  image: "sugar-in-bowl.png",
                },
                {
                  id: 1077,
                  name: "milk",
                  localizedName: "milk",
                  image: "milk.png",
                },
                { id: 0, name: "pop", localizedName: "soft drink", image: "" },
              ],
              equipment: [],
            },
            {
              number: 7,
              step: "Bake in a preheated oven at 400 degrees for 20 minutes or until browned.",
              ingredients: [],
              equipment: [
                {
                  id: 404784,
                  name: "oven",
                  localizedName: "oven",
                  image: "oven.jpg",
                },
              ],
              length: { number: 20, unit: "minutes" },
            },
          ],
        },
      ],
      originalId: null,
      spoonacularSourceUrl:
        "https://spoonacular.com/naturally-sweet-apple-turnovers-652976",
    },
  },
  {
    id: 639644,
    value: {
      vegetarian: true,
      vegan: false,
      glutenFree: false,
      dairyFree: false,
      veryHealthy: false,
      cheap: false,
      veryPopular: false,
      sustainable: false,
      weightWatcherSmartPoints: 9,
      gaps: "no",
      lowFodmap: false,
      aggregateLikes: 7,
      spoonacularScore: 17.0,
      healthScore: 1.0,
      creditsText: "Foodista.com – The Cooking Encyclopedia Everyone Can Edit",
      license: "CC BY 3.0",
      sourceName: "Foodista",
      pricePerServing: 38.95,
      extendedIngredients: [
        {
          id: 20081,
          aisle: "Baking",
          image: "flour.png",
          consistency: "solid",
          name: "AP flour",
          nameClean: "wheat flour",
          original: "3 ¼ cups AP flour",
          originalName: "AP flour",
          amount: 3.25,
          unit: "cups",
          meta: [],
          measures: {
            us: { amount: 3.25, unitShort: "cups", unitLong: "cups" },
            metric: {
              amount: 768.911,
              unitShort: "ml",
              unitLong: "milliliters",
            },
          },
        },
        {
          id: 19904,
          aisle: "Sweet Snacks",
          image: "dark-chocolate-pieces.jpg",
          consistency: "solid",
          name: "dark chocolate",
          nameClean: "dark chocolate",
          original: "5-6 oz dark chocolate",
          originalName: "dark chocolate",
          amount: 5.0,
          unit: "oz",
          meta: ["dark"],
          measures: {
            us: { amount: 5.0, unitShort: "oz", unitLong: "ounces" },
            metric: { amount: 141.748, unitShort: "g", unitLong: "grams" },
          },
        },
        {
          id: 1123,
          aisle: "Milk, Eggs, Other Dairy",
          image: "egg.png",
          consistency: "solid",
          name: "egg",
          nameClean: "egg",
          original: "1 large egg",
          originalName: "egg",
          amount: 1.0,
          unit: "large",
          meta: [],
          measures: {
            us: { amount: 1.0, unitShort: "large", unitLong: "large" },
            metric: { amount: 1.0, unitShort: "large", unitLong: "large" },
          },
        },
        {
          id: 1125,
          aisle: "Milk, Eggs, Other Dairy",
          image: "egg-yolk.jpg",
          consistency: "solid",
          name: "egg yolk",
          nameClean: "egg yolk",
          original: "1 large egg yolk",
          originalName: "egg yolk",
          amount: 1.0,
          unit: "large",
          meta: [],
          measures: {
            us: { amount: 1.0, unitShort: "large", unitLong: "large" },
            metric: { amount: 1.0, unitShort: "large", unitLong: "large" },
          },
        },
        {
          id: 19335,
          aisle: "Baking",
          image: "sugar-in-bowl.png",
          consistency: "solid",
          name: "granulated sugar",
          nameClean: "sugar",
          original: "1 cup granulated sugar",
          originalName: "granulated sugar",
          amount: 1.0,
          unit: "cup",
          meta: [],
          measures: {
            us: { amount: 1.0, unitShort: "cup", unitLong: "cup" },
            metric: {
              amount: 236.588,
              unitShort: "ml",
              unitLong: "milliliters",
            },
          },
        },
        {
          id: 1077,
          aisle: "Milk, Eggs, Other Dairy",
          image: "milk.png",
          consistency: "liquid",
          name: "milk",
          nameClean: "milk",
          original: "1-2 tablespoons milk",
          originalName: "milk",
          amount: 1.0,
          unit: "tablespoons",
          meta: [],
          measures: {
            us: { amount: 1.0, unitShort: "Tbsp", unitLong: "Tbsp" },
            metric: { amount: 1.0, unitShort: "Tbsp", unitLong: "Tbsp" },
          },
        },
        {
          id: 9216,
          aisle: "Produce",
          image: "orange-zest.png",
          consistency: "solid",
          name: "orange zest",
          nameClean: "orange zest",
          original: "3 tablespoons grated orange zest",
          originalName: "grated orange zest",
          amount: 3.0,
          unit: "tablespoons",
          meta: ["grated"],
          measures: {
            us: { amount: 3.0, unitShort: "Tbsps", unitLong: "Tbsps" },
            metric: { amount: 3.0, unitShort: "Tbsps", unitLong: "Tbsps" },
          },
        },
        {
          id: 2047,
          aisle: "Spices and Seasonings",
          image: "salt.jpg",
          consistency: "solid",
          name: "salt",
          nameClean: "table salt",
          original: "1 teaspoon salt",
          originalName: "salt",
          amount: 1.0,
          unit: "teaspoon",
          meta: [],
          measures: {
            us: { amount: 1.0, unitShort: "tsp", unitLong: "teaspoon" },
            metric: { amount: 1.0, unitShort: "tsp", unitLong: "teaspoon" },
          },
        },
        {
          id: 1145,
          aisle: "Milk, Eggs, Other Dairy",
          image: "butter-sliced.jpg",
          consistency: "solid",
          name: "unsalted butter",
          nameClean: "unsalted butter",
          original: "1 ¼ cups unsalted butter, at room temp",
          originalName: "unsalted butter, at room temp",
          amount: 1.25,
          unit: "cups",
          meta: ["unsalted"],
          measures: {
            us: { amount: 1.25, unitShort: "cups", unitLong: "cups" },
            metric: {
              amount: 295.735,
              unitShort: "ml",
              unitLong: "milliliters",
            },
          },
        },
        {
          id: 2050,
          aisle: "Baking",
          image: "vanilla-extract.jpg",
          consistency: "liquid",
          name: "vanilla extract",
          nameClean: "vanilla extract",
          original: "2 teaspoons vanilla extract",
          originalName: "vanilla extract",
          amount: 2.0,
          unit: "teaspoons",
          meta: [],
          measures: {
            us: { amount: 2.0, unitShort: "tsps", unitLong: "teaspoons" },
            metric: { amount: 2.0, unitShort: "tsps", unitLong: "teaspoons" },
          },
        },
      ],
      id: 639644,
      title: "Classic Vanilla-Orange Sugar Cookies",
      readyInMinutes: 45,
      servings: 24,
      sourceUrl:
        "http://www.foodista.com/recipe/MTC5387V/classic-vanilla-orange-sugar-cookies",
      image: "https://spoonacular.com/recipeImages/639644-556x370.jpg",
      imageType: "jpg",
      summary:
        'Classic Vanilla-Orange Sugar Cookies might be just the dessert you are searching for. This vegetarian recipe serves 24 and costs <b>39 cents per serving</b>. One serving contains <b>221 calories</b>, <b>3g of protein</b>, and <b>13g of fat</b>. It can be enjoyed any time, but it is especially good for <b>Christmas</b>. This recipe is liked by 7 foodies and cooks. If you have ap flour, orange zest, vanillan extract, and a few other ingredients on hand, you can make it. From preparation to the plate, this recipe takes about <b>45 minutes</b>. All things considered, we decided this recipe <b>deserves a spoonacular score of 18%</b>. This score is rather bad. Try <a href="https://spoonacular.com/recipes/classic-sugar-cookies-738947">Classic Sugar Cookies</a>, <a href="https://spoonacular.com/recipes/classic-sugar-cookies-144316">Classic Sugar Cookies</a>, and <a href="https://spoonacular.com/recipes/classic-sugar-cookies-595721">Classic Sugar Cookies</a> for similar recipes.',
      cuisines: [],
      dishTypes: [
        "antipasti",
        "starter",
        "snack",
        "appetizer",
        "antipasto",
        "hor d'oeuvre",
      ],
      diets: ["lacto ovo vegetarian"],
      occasions: ["christmas"],
      winePairing: {},
      instructions:
        "<ol><li>In a medium bowl, whisk together flour and salt.</li><li>In bowl of stand mixer, beat sugar and butter on medium speed until light and fluffy, about 3 minutes.  Beat in egg, egg yolk, orange zest and vanilla until well combined.</li><li>With the mixer on low speed, gradually add flour mixture to bowl, mixing until combined.</li><li>Turn dough out onto a work surface and divide into three equal pieces. Shape each piece into a flat disk.  Wrap each disk tightly in plastic wrap.  Refrigerate for at least 1 hour, until cold, or for up to 3 days.</li><li>Preheat oven to 350 degrees F, placing racks in the upper and lower thirds.</li><li>On a lightly floured work surface, roll out one disk of dough to a thickness of  inch.  Using cookie cutter, cut out shapes and carefully transfer them to 2 prepared cookie sheets, spacing them about 1 inch apart.  Reroll scraps as necessary.  Repeat process with more dough until both cookie sheets are full.</li><li>Bake for 11  15 minutes, switching positions of cookie sheets halfway through, until cookies are set and very lightly browned.  Let cookies cool on cookie sheet for 10 minutes, then carefully transfer them to wire racks to cool completely before decorating.</li><li>Repeat steps 6 and 7 with the remaining dough.</li><li>Melt chocolate and milk in a double broiler.  When cookies are cool, drizzle over the cookies and allow to set.</li></ol>",
      analyzedInstructions: [
        {
          name: "",
          steps: [
            {
              number: 1,
              step: "In a medium bowl, whisk together flour and salt.In bowl of stand mixer, beat sugar and butter on medium speed until light and fluffy, about 3 minutes.  Beat in egg, egg yolk, orange zest and vanilla until well combined.With the mixer on low speed, gradually add flour mixture to bowl, mixing until combined.Turn dough out onto a work surface and divide into three equal pieces. Shape each piece into a flat disk.  Wrap each disk tightly in plastic wrap.  Refrigerate for at least 1 hour, until cold, or for up to 3 days.Preheat oven to 350 degrees F, placing racks in the upper and lower thirds.On a lightly floured work surface, roll out one disk of dough to a thickness of  inch.  Using cookie cutter, cut out shapes and carefully transfer them to 2 prepared cookie sheets, spacing them about 1 inch apart.  Reroll scraps as necessary.  Repeat process with more dough until both cookie sheets are full.",
              ingredients: [
                {
                  id: 9216,
                  name: "orange zest",
                  localizedName: "orange zest",
                  image: "orange-zest.png",
                },
                {
                  id: 1125,
                  name: "egg yolk",
                  localizedName: "egg yolk",
                  image: "egg-yolk.jpg",
                },
                {
                  id: 1052050,
                  name: "vanilla",
                  localizedName: "vanilla",
                  image: "vanilla.jpg",
                },
                {
                  id: 1001,
                  name: "butter",
                  localizedName: "butter",
                  image: "butter-sliced.jpg",
                },
                {
                  id: 10118192,
                  name: "cookies",
                  localizedName: "cookies",
                  image: "shortbread-cookies.jpg",
                },
                {
                  id: 0,
                  name: "dough",
                  localizedName: "dough",
                  image: "pizza-dough",
                },
                {
                  id: 20081,
                  name: "all purpose flour",
                  localizedName: "all purpose flour",
                  image: "flour.png",
                },
                {
                  id: 19335,
                  name: "sugar",
                  localizedName: "sugar",
                  image: "sugar-in-bowl.png",
                },
                {
                  id: 0,
                  name: "roll",
                  localizedName: "roll",
                  image: "dinner-yeast-rolls.jpg",
                },
                {
                  id: 2047,
                  name: "salt",
                  localizedName: "salt",
                  image: "salt.jpg",
                },
                {
                  id: 10018364,
                  name: "wrap",
                  localizedName: "wrap",
                  image: "flour-tortilla.jpg",
                },
                {
                  id: 1123,
                  name: "egg",
                  localizedName: "egg",
                  image: "egg.png",
                },
              ],
              equipment: [
                {
                  id: 221429,
                  name: "cookie cutter",
                  localizedName: "cookie cutter",
                  image: "cookie-cutters.jpg",
                },
                {
                  id: 404727,
                  name: "baking sheet",
                  localizedName: "baking sheet",
                  image: "baking-sheet.jpg",
                },
                {
                  id: 404730,
                  name: "plastic wrap",
                  localizedName: "plastic wrap",
                  image: "plastic-wrap.jpg",
                },
                {
                  id: 404665,
                  name: "stand mixer",
                  localizedName: "stand mixer",
                  image: "stand-mixer.jpg",
                },
                {
                  id: 404661,
                  name: "whisk",
                  localizedName: "whisk",
                  image: "whisk.png",
                },
                {
                  id: 404783,
                  name: "bowl",
                  localizedName: "bowl",
                  image: "bowl.jpg",
                },
                {
                  id: 404784,
                  name: "oven",
                  localizedName: "oven",
                  image: "oven.jpg",
                  temperature: { number: 350.0, unit: "Fahrenheit" },
                },
              ],
              length: { number: 63, unit: "minutes" },
            },
            {
              number: 2,
              step: "Bake for 11  15 minutes, switching positions of cookie sheets halfway through, until cookies are set and very lightly browned.",
              ingredients: [
                {
                  id: 10118192,
                  name: "cookies",
                  localizedName: "cookies",
                  image: "shortbread-cookies.jpg",
                },
              ],
              equipment: [
                {
                  id: 404727,
                  name: "baking sheet",
                  localizedName: "baking sheet",
                  image: "baking-sheet.jpg",
                },
                {
                  id: 404784,
                  name: "oven",
                  localizedName: "oven",
                  image: "oven.jpg",
                },
              ],
              length: { number: 15, unit: "minutes" },
            },
            {
              number: 3,
              step: "Let cookies cool on cookie sheet for 10 minutes, then carefully transfer them to wire racks to cool completely before decorating.Repeat steps 6 and 7 with the remaining dough.Melt chocolate and milk in a double broiler.  When cookies are cool, drizzle over the cookies and allow to set.",
              ingredients: [
                {
                  id: 19081,
                  name: "chocolate",
                  localizedName: "chocolate",
                  image: "milk-chocolate.jpg",
                },
                {
                  id: 10118192,
                  name: "cookies",
                  localizedName: "cookies",
                  image: "shortbread-cookies.jpg",
                },
                {
                  id: 0,
                  name: "dough",
                  localizedName: "dough",
                  image: "pizza-dough",
                },
                {
                  id: 1077,
                  name: "milk",
                  localizedName: "milk",
                  image: "milk.png",
                },
              ],
              equipment: [
                {
                  id: 404727,
                  name: "baking sheet",
                  localizedName: "baking sheet",
                  image: "baking-sheet.jpg",
                },
                {
                  id: 405914,
                  name: "broiler",
                  localizedName: "broiler",
                  image: "oven.jpg",
                },
              ],
              length: { number: 10, unit: "minutes" },
            },
          ],
        },
      ],
      originalId: null,
      spoonacularSourceUrl:
        "https://spoonacular.com/classic-vanilla-orange-sugar-cookies-639644",
    },
  },
  {
    id: 645416,
    value: {
      vegetarian: true,
      vegan: false,
      glutenFree: true,
      dairyFree: false,
      veryHealthy: false,
      cheap: false,
      veryPopular: false,
      sustainable: false,
      weightWatcherSmartPoints: 5,
      gaps: "no",
      lowFodmap: false,
      aggregateLikes: 7,
      spoonacularScore: 42.0,
      healthScore: 6.0,
      creditsText: "Foodista.com – The Cooking Encyclopedia Everyone Can Edit",
      license: "CC BY 3.0",
      sourceName: "Foodista",
      pricePerServing: 83.9,
      extendedIngredients: [
        {
          id: 2048,
          aisle: "Oil, Vinegar, Salad Dressing",
          image: "apple-cider-vinegar.jpg",
          consistency: "liquid",
          name: "apple cider vinegar",
          nameClean: "apple cider vinegar",
          original: "1 tablespoon apple cider vinegar",
          originalName: "apple cider vinegar",
          amount: 1.0,
          unit: "tablespoon",
          meta: [],
          measures: {
            us: { amount: 1.0, unitShort: "Tbsp", unitLong: "Tbsp" },
            metric: { amount: 1.0, unitShort: "Tbsp", unitLong: "Tbsp" },
          },
        },
        {
          id: 11215,
          aisle: "Produce",
          image: "garlic.png",
          consistency: "solid",
          name: "garlic cloves",
          nameClean: "garlic",
          original: "3 garlic cloves thinly sliced",
          originalName: "garlic cloves thinly sliced",
          amount: 3.0,
          unit: "",
          meta: ["thinly sliced"],
          measures: {
            us: { amount: 3.0, unitShort: "", unitLong: "" },
            metric: { amount: 3.0, unitShort: "", unitLong: "" },
          },
        },
        {
          id: 11052,
          aisle: "Produce",
          image: "green-beans-or-string-beans.jpg",
          consistency: "solid",
          name: "green beans",
          nameClean: "green beans",
          original: "1 1/2 pounds green beans, trimmed",
          originalName: "green beans, trimmed",
          amount: 1.5,
          unit: "pounds",
          meta: ["trimmed"],
          measures: {
            us: { amount: 1.5, unitShort: "lb", unitLong: "pounds" },
            metric: { amount: 680.389, unitShort: "g", unitLong: "grams" },
          },
        },
        {
          id: 4053,
          aisle: "Oil, Vinegar, Salad Dressing",
          image: "olive-oil.jpg",
          consistency: "liquid",
          name: "olive oil",
          nameClean: "olive oil",
          original: "2 tablespoons extra-virgin olive oil",
          originalName: "extra-virgin olive oil",
          amount: 2.0,
          unit: "tablespoons",
          meta: ["extra-virgin"],
          measures: {
            us: { amount: 2.0, unitShort: "Tbsps", unitLong: "Tbsps" },
            metric: { amount: 2.0, unitShort: "Tbsps", unitLong: "Tbsps" },
          },
        },
        {
          id: 1102047,
          aisle: "Spices and Seasonings",
          image: "salt-and-pepper.jpg",
          consistency: "solid",
          name: "salt and pepper",
          nameClean: "salt and pepper",
          original: "Slavosalt seasoning – or salt and pepper",
          originalName: "Slavosalt seasoning – or salt and pepper",
          amount: 4.0,
          unit: "servings",
          meta: [],
          measures: {
            us: { amount: 4.0, unitShort: "servings", unitLong: "servings" },
            metric: {
              amount: 4.0,
              unitShort: "servings",
              unitLong: "servings",
            },
          },
        },
        {
          id: 1145,
          aisle: "Milk, Eggs, Other Dairy",
          image: "butter-sliced.jpg",
          consistency: "solid",
          name: "unsalted butter",
          nameClean: "unsalted butter",
          original: "2 tablespoon unsalted butter + ½ teaspoon",
          originalName: "unsalted butter + ½ teaspoon",
          amount: 2.0,
          unit: "tablespoon",
          meta: ["unsalted"],
          measures: {
            us: { amount: 2.0, unitShort: "Tbsps", unitLong: "Tbsps" },
            metric: { amount: 2.0, unitShort: "Tbsps", unitLong: "Tbsps" },
          },
        },
        {
          id: 1012069,
          aisle: "Oil, Vinegar, Salad Dressing",
          image: "vinegar-(white).jpg",
          consistency: "liquid",
          name: "white balsamic vinegar",
          nameClean: "white balsamic vinegar",
          original: "1 tablespoon white balsamic vinegar",
          originalName: "white balsamic vinegar",
          amount: 1.0,
          unit: "tablespoon",
          meta: ["white"],
          measures: {
            us: { amount: 1.0, unitShort: "Tbsp", unitLong: "Tbsp" },
            metric: { amount: 1.0, unitShort: "Tbsp", unitLong: "Tbsp" },
          },
        },
        {
          id: 10511282,
          aisle: "Produce",
          image: "brown-onion.png",
          consistency: "solid",
          name: "yellow onion",
          nameClean: "yellow onion",
          original: "½ yellow onion, sliced",
          originalName: "yellow onion, sliced",
          amount: 0.5,
          unit: "",
          meta: ["yellow", "sliced"],
          measures: {
            us: { amount: 0.5, unitShort: "", unitLong: "" },
            metric: { amount: 0.5, unitShort: "", unitLong: "" },
          },
        },
      ],
      id: 645416,
      title: "Green Beans with Garlic Chips",
      readyInMinutes: 45,
      servings: 4,
      sourceUrl:
        "http://www.foodista.com/recipe/4D3H7QM3/green-beans-with-garlic-chips",
      image: "https://spoonacular.com/recipeImages/645416-556x370.jpg",
      imageType: "jpg",
      summary:
        'Green Beans with Garlic Chips might be just the side dish you are searching for. One serving contains <b>178 calories</b>, <b>3g of protein</b>, and <b>13g of fat</b>. This gluten free, primal, and vegetarian recipe serves 4 and costs <b>84 cents per serving</b>. 7 people have tried and liked this recipe. If you have apple cider vinegar, garlic cloves, olive oil, and a few other ingredients on hand, you can make it. From preparation to the plate, this recipe takes roughly <b>45 minutes</b>. All things considered, we decided this recipe <b>deserves a spoonacular score of 45%</b>. This score is solid. Try <a href="https://spoonacular.com/recipes/sauteed-green-beans-with-garlic-chips-395227">Sauteed Green Beans with Garlic Chips</a>, <a href="https://spoonacular.com/recipes/garlic-green-beans-644285">Garlic Green Beans</a>, and <a href="https://spoonacular.com/recipes/garlic-green-beans-433417">Garlic Green Beans</a> for similar recipes.',
      cuisines: [],
      dishTypes: ["side dish"],
      diets: ["gluten free", "lacto ovo vegetarian", "primal"],
      occasions: [],
      winePairing: {},
      instructions:
        "<ol><li>Heat the oil with the garlic in a heavy skillet over medium heat. Cook stirring occasionally, until the garlic is golden. Remove the garlic from the skillet with a slotted spoon and transfer to a paper towel.</li><li>Add the butter to the oil in the skillet and heat over medium heat. Add the onions, salt and pepper and saut, until the onions are translucent and starting to turn golden.</li><li>Add the beans and continue cooking stirring occasionally. Stir in both vinegars and season with salt and pepper to taste.</li><li>Transfer the beans to a serving dish and sprinkle with the garlic chips.</li></ol>",
      analyzedInstructions: [
        {
          name: "",
          steps: [
            {
              number: 1,
              step: "Heat the oil with the garlic in a heavy skillet over medium heat. Cook stirring occasionally, until the garlic is golden.",
              ingredients: [
                {
                  id: 11215,
                  name: "garlic",
                  localizedName: "garlic",
                  image: "garlic.png",
                },
                {
                  id: 4582,
                  name: "cooking oil",
                  localizedName: "cooking oil",
                  image: "vegetable-oil.jpg",
                },
              ],
              equipment: [
                {
                  id: 404645,
                  name: "frying pan",
                  localizedName: "frying pan",
                  image: "pan.png",
                },
              ],
            },
            {
              number: 2,
              step: "Remove the garlic from the skillet with a slotted spoon and transfer to a paper towel.",
              ingredients: [
                {
                  id: 11215,
                  name: "garlic",
                  localizedName: "garlic",
                  image: "garlic.png",
                },
              ],
              equipment: [
                {
                  id: 404636,
                  name: "slotted spoon",
                  localizedName: "slotted spoon",
                  image: "slotted-spoon.jpg",
                },
                {
                  id: 405895,
                  name: "paper towels",
                  localizedName: "paper towels",
                  image: "paper-towels.jpg",
                },
                {
                  id: 404645,
                  name: "frying pan",
                  localizedName: "frying pan",
                  image: "pan.png",
                },
              ],
            },
            {
              number: 3,
              step: "Add the butter to the oil in the skillet and heat over medium heat.",
              ingredients: [
                {
                  id: 1001,
                  name: "butter",
                  localizedName: "butter",
                  image: "butter-sliced.jpg",
                },
                {
                  id: 4582,
                  name: "cooking oil",
                  localizedName: "cooking oil",
                  image: "vegetable-oil.jpg",
                },
              ],
              equipment: [
                {
                  id: 404645,
                  name: "frying pan",
                  localizedName: "frying pan",
                  image: "pan.png",
                },
              ],
            },
            {
              number: 4,
              step: "Add the onions, salt and pepper and saut, until the onions are translucent and starting to turn golden.",
              ingredients: [
                {
                  id: 1102047,
                  name: "salt and pepper",
                  localizedName: "salt and pepper",
                  image: "salt-and-pepper.jpg",
                },
                {
                  id: 11282,
                  name: "onion",
                  localizedName: "onion",
                  image: "brown-onion.png",
                },
              ],
              equipment: [],
            },
            {
              number: 5,
              step: "Add the beans and continue cooking stirring occasionally. Stir in both vinegars and season with salt and pepper to taste.",
              ingredients: [
                {
                  id: 1102047,
                  name: "salt and pepper",
                  localizedName: "salt and pepper",
                  image: "salt-and-pepper.jpg",
                },
                {
                  id: 0,
                  name: "beans",
                  localizedName: "beans",
                  image: "kidney-beans.jpg",
                },
              ],
              equipment: [],
            },
            {
              number: 6,
              step: "Transfer the beans to a serving dish and sprinkle with the garlic chips.",
              ingredients: [
                {
                  id: 11215,
                  name: "garlic",
                  localizedName: "garlic",
                  image: "garlic.png",
                },
                {
                  id: 0,
                  name: "beans",
                  localizedName: "beans",
                  image: "kidney-beans.jpg",
                },
                {
                  id: 11408,
                  name: "french fries",
                  localizedName: "french fries",
                  image: "french-fries-isolated.jpg",
                },
              ],
              equipment: [],
            },
          ],
        },
      ],
      originalId: null,
      spoonacularSourceUrl:
        "https://spoonacular.com/green-beans-with-garlic-chips-645416",
    },
  },
  {
    id: 633091,
    value: {
      vegetarian: true,
      vegan: false,
      glutenFree: false,
      dairyFree: false,
      veryHealthy: false,
      cheap: false,
      veryPopular: false,
      sustainable: false,
      weightWatcherSmartPoints: 12,
      gaps: "no",
      lowFodmap: false,
      aggregateLikes: 34,
      spoonacularScore: 24.0,
      healthScore: 1.0,
      creditsText: "Foodista.com – The Cooking Encyclopedia Everyone Can Edit",
      license: "CC BY 3.0",
      sourceName: "Foodista",
      pricePerServing: 110.25,
      extendedIngredients: [
        {
          id: 9003,
          aisle: "Produce",
          image: "apple.jpg",
          consistency: "solid",
          name: "apples",
          nameClean: "apple",
          original: "7-8 baking apples (ie: Granny Smith)",
          originalName: "baking apples (ie: Granny Smith)",
          amount: 7.0,
          unit: "",
          meta: ["(ie: Granny Smith)"],
          measures: {
            us: { amount: 7.0, unitShort: "", unitLong: "" },
            metric: { amount: 7.0, unitShort: "", unitLong: "" },
          },
        },
        {
          id: 9021,
          aisle: "Produce",
          image: "apricot.jpg",
          consistency: "solid",
          name: "apricot",
          nameClean: "apricot",
          original: "4-5 Tbs apricot preserve melted",
          originalName: "apricot preserve melted",
          amount: 4.0,
          unit: "Tbs",
          meta: ["melted"],
          measures: {
            us: { amount: 4.0, unitShort: "Tbs", unitLong: "Tbs" },
            metric: { amount: 4.0, unitShort: "Tbs", unitLong: "Tbs" },
          },
        },
        {
          id: 1001,
          aisle: "Milk, Eggs, Other Dairy",
          image: "butter-sliced.jpg",
          consistency: "solid",
          name: "butter",
          nameClean: "butter",
          original: "1 stick butter, softened",
          originalName: "butter, softened",
          amount: 1.0,
          unit: "stick",
          meta: ["softened"],
          measures: {
            us: { amount: 1.0, unitShort: "stick", unitLong: "stick" },
            metric: { amount: 1.0, unitShort: "stick", unitLong: "stick" },
          },
        },
        {
          id: 2010,
          aisle: "Spices and Seasonings",
          image: "cinnamon.jpg",
          consistency: "solid",
          name: "cinnamon",
          nameClean: "cinnamon",
          original: "1/2 teaspoon Cinnamon",
          originalName: "Cinnamon",
          amount: 0.5,
          unit: "teaspoon",
          meta: [],
          measures: {
            us: { amount: 0.5, unitShort: "tsps", unitLong: "teaspoons" },
            metric: { amount: 0.5, unitShort: "tsps", unitLong: "teaspoons" },
          },
        },
        {
          id: 1017,
          aisle: "Cheese",
          image: "cream-cheese.jpg",
          consistency: "solid",
          name: "cream cheese",
          nameClean: "cream cheese",
          original: "2 -8oz packages cream cheese softened",
          originalName: "packages cream cheese softened",
          amount: 2.0,
          unit: "oz",
          meta: ["softened"],
          measures: {
            us: { amount: 2.0, unitShort: "oz", unitLong: "ounces" },
            metric: { amount: 56.699, unitShort: "g", unitLong: "grams" },
          },
        },
        {
          id: 1123,
          aisle: "Milk, Eggs, Other Dairy",
          image: "egg.png",
          consistency: "solid",
          name: "eggs",
          nameClean: "egg",
          original: "2 eggs",
          originalName: "eggs",
          amount: 2.0,
          unit: "",
          meta: [],
          measures: {
            us: { amount: 2.0, unitShort: "", unitLong: "" },
            metric: { amount: 2.0, unitShort: "", unitLong: "" },
          },
        },
        {
          id: 18617,
          aisle: "Sweet Snacks",
          image: "graham-crackers.jpg",
          consistency: "solid",
          name: "graham crackers",
          nameClean: "graham crackers",
          original: "8-9 Graham crackers finely chopped to crumbs = 1+ cups",
          originalName: "Graham crackers finely chopped to crumbs = 1+ cups",
          amount: 8.0,
          unit: "",
          meta: ["finely chopped"],
          measures: {
            us: { amount: 8.0, unitShort: "", unitLong: "" },
            metric: { amount: 8.0, unitShort: "", unitLong: "" },
          },
        },
        {
          id: 12142,
          aisle: "Nuts;Baking",
          image: "pecans.jpg",
          consistency: "solid",
          name: "pecans",
          nameClean: "pecans",
          original: "1/4 cup chopped pecans",
          originalName: "chopped pecans",
          amount: 0.25,
          unit: "cup",
          meta: ["chopped"],
          measures: {
            us: { amount: 0.25, unitShort: "cups", unitLong: "cups" },
            metric: {
              amount: 59.147,
              unitShort: "ml",
              unitLong: "milliliters",
            },
          },
        },
        {
          id: 19335,
          aisle: "Baking",
          image: "sugar-in-bowl.png",
          consistency: "solid",
          name: "sugar",
          nameClean: "sugar",
          original: "1/2 cup sugar",
          originalName: "sugar",
          amount: 0.5,
          unit: "cup",
          meta: [],
          measures: {
            us: { amount: 0.5, unitShort: "cups", unitLong: "cups" },
            metric: {
              amount: 118.294,
              unitShort: "ml",
              unitLong: "milliliters",
            },
          },
        },
        {
          id: 2050,
          aisle: "Baking",
          image: "vanilla-extract.jpg",
          consistency: "liquid",
          name: "vanilla",
          nameClean: "vanilla extract",
          original: "1/2 tsp vanilla",
          originalName: "vanilla",
          amount: 0.5,
          unit: "tsp",
          meta: [],
          measures: {
            us: { amount: 0.5, unitShort: "tsps", unitLong: "teaspoons" },
            metric: { amount: 0.5, unitShort: "tsps", unitLong: "teaspoons" },
          },
        },
      ],
      id: 633091,
      title: "Autumn Cheesecake",
      readyInMinutes: 45,
      servings: 8,
      sourceUrl: "http://www.foodista.com/recipe/2HQGVX53/autumn-cheesecake",
      image: "https://spoonacular.com/recipeImages/633091-556x370.jpg",
      imageType: "jpg",
      summary:
        'Watching your figure? This vegetarian recipe has <b>358 calories</b>, <b>4g of protein</b>, and <b>19g of fat</b> per serving. For <b>$1.1 per serving</b>, this recipe <b>covers 6%</b> of your daily requirements of vitamins and minerals. A couple people made this recipe, and 34 would say it hit the spot. From preparation to the plate, this recipe takes approximately <b>45 minutes</b>. Head to the store and pick up cream cheese, pecans, butter, and a few other things to make it today. All things considered, we decided this recipe <b>deserves a spoonacular score of 26%</b>. This score is not so great. Try <a href="https://spoonacular.com/recipes/autumn-apple-cheesecake-760758">Autumn Apple Cheesecake</a>, <a href="https://spoonacular.com/recipes/caramel-apple-butter-cheesecake-dip-for-sundaysupper-autumn-apple-party-554054">Caramel Apple Butter Cheesecake Dip for #SundaySupper Autumn Apple Party</a>, and <a href="https://spoonacular.com/recipes/california-pizza-kitchen-pumpkin-cheesecake-this-is-a-perfect-cheesecake-for-the-fall-holidays-their-cheesecake-isnt-a-secret-anymore-600275">California Pizza Kitchen Pumpkin Cheesecake – this is a perfect cheesecake for the fall holidays, their cheesecake isn’t a secret anymore</a> for similar recipes.',
      cuisines: [],
      dishTypes: ["side dish"],
      diets: ["lacto ovo vegetarian"],
      occasions: [],
      winePairing: { pairedWines: [], pairingText: "", productMatches: [] },
      instructions:
        "<ol><li>FOR THE APPLE LAYER:</li><li>Peel and core the apples and slice thinly add to the sugar and cinnamon and mix well until all the apples are coated.  Set aside.</li><li>FOR THE CRUST:</li><li>Preheat oven to 350</li><li>In a small sauce pan melt the butter</li><li>In the food processor add the pecans and chop until very fine, add the Graham crackers and pulse until finely chopped and put mixture into a bowl.  Add the butter and with a fork stir to combine, until all the cracker is wet with butter and no dry parts are still visible.</li><li>Place the mixture into the bottom of a 9 inch springform pan and press down to form a solid bottom crust.  Place into the center of the oven and bake for about 10 minutes, remove to a wire rack to cool..</li><li>FOR THE BATTER:</li><li>In the bowl of the mixer place the softened cream cheese and the sugar and on medium speed cream until well  combined, scrape down the sides of the bowl and the blades of the mixer add the vanilla and on medium low add the eggs one at a time and continue to beat until each is well incorporated.  Pour into the cooled springform pan and smooth the mixture level.</li><li>APPLES:</li><li>Arrange the apples in decorative layer over the batter and then place the pan into the oven and bake for about 70 minutes.</li><li>Remove to a wire rack to cool.</li><li>In the mean time melt the preserve and once the apples a lightly cooled brush the preserve over apples to coat all and give a nice sheen to the top.  Sprinkle the pecans over the apples.  Now carefully run a knife around the edges of the cake to loosen from the sides of the pan and then cover and refrigerate for at least 5 hours, overnight even better.</li><li>Remove from the refrigerator about an hour before serving and remove the sides of the springform  pan.</li></ol>",
      analyzedInstructions: [
        {
          name: "",
          steps: [
            {
              number: 1,
              step: "FOR THE APPLE LAYER:Peel and core the apples and slice thinly add to the sugar and cinnamon and mix well until all the apples are coated.  Set aside.FOR THE CRUST:Preheat oven to 350In a small sauce pan melt the butter",
              ingredients: [
                {
                  id: 2010,
                  name: "cinnamon",
                  localizedName: "cinnamon",
                  image: "cinnamon.jpg",
                },
                {
                  id: 9003,
                  name: "apple",
                  localizedName: "apple",
                  image: "apple.jpg",
                },
                {
                  id: 1001,
                  name: "butter",
                  localizedName: "butter",
                  image: "butter-sliced.jpg",
                },
                { id: 0, name: "crust", localizedName: "crust", image: "" },
                { id: 0, name: "sauce", localizedName: "sauce", image: "" },
                {
                  id: 19335,
                  name: "sugar",
                  localizedName: "sugar",
                  image: "sugar-in-bowl.png",
                },
              ],
              equipment: [
                {
                  id: 404669,
                  name: "sauce pan",
                  localizedName: "sauce pan",
                  image: "sauce-pan.jpg",
                },
                {
                  id: 404784,
                  name: "oven",
                  localizedName: "oven",
                  image: "oven.jpg",
                },
              ],
            },
            {
              number: 2,
              step: "In the food processor add the pecans and chop until very fine, add the Graham crackers and pulse until finely chopped and put mixture into a bowl.",
              ingredients: [
                {
                  id: 18617,
                  name: "graham crackers",
                  localizedName: "graham crackers",
                  image: "graham-crackers.jpg",
                },
                {
                  id: 12142,
                  name: "pecans",
                  localizedName: "pecans",
                  image: "pecans.jpg",
                },
              ],
              equipment: [
                {
                  id: 404771,
                  name: "food processor",
                  localizedName: "food processor",
                  image: "food-processor.png",
                },
                {
                  id: 404783,
                  name: "bowl",
                  localizedName: "bowl",
                  image: "bowl.jpg",
                },
              ],
            },
            {
              number: 3,
              step: "Add the butter and with a fork stir to combine, until all the cracker is wet with butter and no dry parts are still visible.",
              ingredients: [
                {
                  id: 18621,
                  name: "crackers",
                  localizedName: "crackers",
                  image: "crackers.jpg",
                },
                {
                  id: 1001,
                  name: "butter",
                  localizedName: "butter",
                  image: "butter-sliced.jpg",
                },
              ],
              equipment: [],
            },
            {
              number: 4,
              step: "Place the mixture into the bottom of a 9 inch springform pan and press down to form a solid bottom crust.",
              ingredients: [
                { id: 0, name: "crust", localizedName: "crust", image: "" },
              ],
              equipment: [
                {
                  id: 404650,
                  name: "springform pan",
                  localizedName: "springform pan",
                  image: "cake-pan.png",
                },
              ],
            },
            {
              number: 5,
              step: "Place into the center of the oven and bake for about 10 minutes, remove to a wire rack to cool..FOR THE BATTER:In the bowl of the mixer place the softened cream cheese and the sugar and on medium speed cream until well  combined, scrape down the sides of the bowl and the blades of the mixer add the vanilla and on medium low add the eggs one at a time and continue to beat until each is well incorporated.",
              ingredients: [
                {
                  id: 1017,
                  name: "cream cheese",
                  localizedName: "cream cheese",
                  image: "cream-cheese.jpg",
                },
                {
                  id: 1052050,
                  name: "vanilla",
                  localizedName: "vanilla",
                  image: "vanilla.jpg",
                },
                {
                  id: 1053,
                  name: "cream",
                  localizedName: "cream",
                  image: "fluid-cream.jpg",
                },
                {
                  id: 19335,
                  name: "sugar",
                  localizedName: "sugar",
                  image: "sugar-in-bowl.png",
                },
                {
                  id: 1123,
                  name: "egg",
                  localizedName: "egg",
                  image: "egg.png",
                },
              ],
              equipment: [
                {
                  id: 405900,
                  name: "wire rack",
                  localizedName: "wire rack",
                  image: "wire-rack.jpg",
                },
                {
                  id: 404784,
                  name: "oven",
                  localizedName: "oven",
                  image: "oven.jpg",
                },
                {
                  id: 404726,
                  name: "blender",
                  localizedName: "blender",
                  image: "blender.png",
                },
                {
                  id: 404783,
                  name: "bowl",
                  localizedName: "bowl",
                  image: "bowl.jpg",
                },
              ],
              length: { number: 10, unit: "minutes" },
            },
            {
              number: 6,
              step: "Pour into the cooled springform pan and smooth the mixture level.APPLES:Arrange the apples in decorative layer over the batter and then place the pan into the oven and bake for about 70 minutes.",
              ingredients: [
                {
                  id: 9003,
                  name: "apple",
                  localizedName: "apple",
                  image: "apple.jpg",
                },
              ],
              equipment: [
                {
                  id: 404650,
                  name: "springform pan",
                  localizedName: "springform pan",
                  image: "cake-pan.png",
                },
                {
                  id: 404784,
                  name: "oven",
                  localizedName: "oven",
                  image: "oven.jpg",
                },
              ],
              length: { number: 70, unit: "minutes" },
            },
            {
              number: 7,
              step: "Remove to a wire rack to cool.In the mean time melt the preserve and once the apples a lightly cooled brush the preserve over apples to coat all and give a nice sheen to the top.",
              ingredients: [
                {
                  id: 9003,
                  name: "apple",
                  localizedName: "apple",
                  image: "apple.jpg",
                },
              ],
              equipment: [
                {
                  id: 405900,
                  name: "wire rack",
                  localizedName: "wire rack",
                  image: "wire-rack.jpg",
                },
              ],
            },
            {
              number: 8,
              step: "Sprinkle the pecans over the apples.  Now carefully run a knife around the edges of the cake to loosen from the sides of the pan and then cover and refrigerate for at least 5 hours, overnight even better.",
              ingredients: [
                {
                  id: 9003,
                  name: "apple",
                  localizedName: "apple",
                  image: "apple.jpg",
                },
                {
                  id: 12142,
                  name: "pecans",
                  localizedName: "pecans",
                  image: "pecans.jpg",
                },
              ],
              equipment: [
                {
                  id: 404745,
                  name: "knife",
                  localizedName: "knife",
                  image: "chefs-knife.jpg",
                },
                {
                  id: 404645,
                  name: "frying pan",
                  localizedName: "frying pan",
                  image: "pan.png",
                },
              ],
              length: { number: 300, unit: "minutes" },
            },
            {
              number: 9,
              step: "Remove from the refrigerator about an hour before serving and remove the sides of the springform  pan.",
              ingredients: [],
              equipment: [
                {
                  id: 404645,
                  name: "frying pan",
                  localizedName: "frying pan",
                  image: "pan.png",
                },
              ],
            },
          ],
        },
      ],
      originalId: null,
      spoonacularSourceUrl: "https://spoonacular.com/autumn-cheesecake-633091",
    },
  },
  {
    id: 715602,
    value: {
      vegetarian: true,
      vegan: false,
      glutenFree: true,
      dairyFree: false,
      veryHealthy: false,
      cheap: false,
      veryPopular: false,
      sustainable: false,
      weightWatcherSmartPoints: 26,
      gaps: "no",
      lowFodmap: false,
      aggregateLikes: 122,
      spoonacularScore: 57.0,
      healthScore: 6.0,
      creditsText: "Jen West",
      sourceName: "Pink When",
      pricePerServing: 205.62,
      extendedIngredients: [
        {
          id: 1017,
          aisle: "Cheese",
          image: "cream-cheese.jpg",
          consistency: "solid",
          name: "cream cheese",
          nameClean: "cream cheese",
          original: "8 oz Cream Cheese",
          originalName: "Cream Cheese",
          amount: 8.0,
          unit: "oz",
          meta: [],
          measures: {
            us: { amount: 8.0, unitShort: "oz", unitLong: "ounces" },
            metric: { amount: 226.796, unitShort: "g", unitLong: "grams" },
          },
        },
        {
          id: 1022020,
          aisle: "Spices and Seasonings",
          image: "garlic-powder.png",
          consistency: "solid",
          name: "garlic powder",
          nameClean: "garlic powder",
          original: "grated ½ tsp Garlic Powder",
          originalName: "grated Garlic Powder",
          amount: 0.5,
          unit: "tsp",
          meta: ["grated"],
          measures: {
            us: { amount: 0.5, unitShort: "tsps", unitLong: "teaspoons" },
            metric: { amount: 0.5, unitShort: "tsps", unitLong: "teaspoons" },
          },
        },
        {
          id: 31015,
          aisle: "Produce",
          image: "chili-peppers-green.jpg",
          consistency: "solid",
          name: "green chilis",
          nameClean: "green chili pepper",
          original: "4 oz Green Chilis (1 small can)",
          originalName: "Green Chilis (1 small can)",
          amount: 4.0,
          unit: "oz",
          meta: ["green", "(1 small can)"],
          measures: {
            us: { amount: 4.0, unitShort: "oz", unitLong: "ounces" },
            metric: { amount: 113.398, unitShort: "g", unitLong: "grams" },
          },
        },
        {
          id: 1031009,
          aisle: "Cheese",
          image: "cheddar-cheese.png",
          consistency: "solid",
          name: "sharp cheddar cheese",
          nameClean: "sharp cheddar cheese",
          original: "4 oz Sharp Cheddar Cheese",
          originalName: "Sharp Cheddar Cheese",
          amount: 4.0,
          unit: "oz",
          meta: [],
          measures: {
            us: { amount: 4.0, unitShort: "oz", unitLong: "ounces" },
            metric: { amount: 113.398, unitShort: "g", unitLong: "grams" },
          },
        },
      ],
      id: 715602,
      title: "Green Chili Cheddar Dip (Guest Post)",
      readyInMinutes: 45,
      servings: 2,
      sourceUrl: "http://www.pinkwhen.com/green-chili-cheddar-dip-guest-post/",
      image: "https://spoonacular.com/recipeImages/715602-556x370.png",
      imageType: "png",
      summary:
        'The recipe Green Chili Cheddar Dip (Guest Post) could satisfy your American craving in roughly <b>45 minutes</b>. This recipe serves 2 and costs $2.06 per serving. One serving contains <b>634 calories</b>, <b>21g of protein</b>, and <b>58g of fat</b>. Plenty of people really liked this hor d\'oeuvre. It can be enjoyed any time, but it is especially good for <b>The Super Bowl</b>. A mixture of cream cheese, garlic powder, chilis, and a handful of other ingredients are all it takes to make this recipe so yummy. It is a good option if you\'re following a <b>gluten free, primal, and vegetarian</b> diet. 122 people were impressed by this recipe. All things considered, we decided this recipe <b>deserves a spoonacular score of 60%</b>. This score is good. Try <a href="https://spoonacular.com/recipes/guest-post-from-diethood-garlic-and-cheddar-drop-biscuits-515122">Guest Post from Diethood – Garlic and Cheddar Drop Biscuits</a>, <a href="https://spoonacular.com/recipes/turkey-picadillo-quinoa-chili-guest-post-505017">Turkey Picadillo Quinoa Chili {guest post}</a>, and <a href="https://spoonacular.com/recipes/guest-post-slow-cooker-veggie-chili-582423">Guest Post: Slow Cooker Veggie Chili</a> for similar recipes.',
      cuisines: ["American"],
      dishTypes: ["condiment", "dip", "spread"],
      diets: ["gluten free", "lacto ovo vegetarian", "primal"],
      occasions: ["super bowl"],
      winePairing: {
        pairedWines: ["cava", "grenache", "shiraz"],
        pairingText:
          "Cava, Grenache, and Shiraz are my top picks for Chili. These juicy reds don't have too much tannin (important for spicy foods), but a sparkling wine like cava can tame the heat even better. You could try Mont-Marcal Cava Brut Reserva. Reviewers quite like it with a 4.4 out of 5 star rating and a price of about 13 dollars per bottle.",
        productMatches: [
          {
            id: 442645,
            title: "Mont-Marcal Cava Brut Reserva",
            description:
              "Estate bottled and disgorged upon order following minimum of 18 months aging on lees. Produced from Xarel-lo, Macabeo, & Chardonnay grapes in a classically dry style. Finely beaded texture with doughy complexity and excellent fruit on the dry finish. Zesty aromas of citrus and ripe yellow fruit -like a gently spiced pear set in pastry.",
            price: "$12.99",
            imageUrl:
              "https://spoonacular.com/productImages/442645-312x231.jpg",
            averageRating: 0.8800000000000001,
            ratingCount: 14.0,
            score: 0.8567441860465117,
            link: "https://click.linksynergy.com/deeplink?id=*QCiIS6t4gA&mid=2025&murl=https%3A%2F%2Fwww.wine.com%2Fproduct%2Fmont-marcal-cava-brut-reserva-2000%2F43068",
          },
        ],
      },
      instructions:
        "In a medium bowl microwave the cream cheese for 30-60 seconds or until it is softened.Mix in the green chilis, cheddar, and garlic. Mix well.Microwave the dip for 45 seconds, stir and then an additional 45 seconds or until it is heated through.Alternately, you can spread the mixture in a baking dish and bake at 350 degrees F for 20-30 min or until heated through.Serve with tortilla chips and enjoy the game (or the food!)",
      analyzedInstructions: [
        {
          name: "",
          steps: [
            {
              number: 1,
              step: "In a medium bowl microwave the cream cheese for 30-60 seconds or until it is softened.",
              ingredients: [
                {
                  id: 1017,
                  name: "cream cheese",
                  localizedName: "cream cheese",
                  image: "cream-cheese.jpg",
                },
              ],
              equipment: [
                {
                  id: 404762,
                  name: "microwave",
                  localizedName: "microwave",
                  image: "microwave.jpg",
                },
                {
                  id: 404783,
                  name: "bowl",
                  localizedName: "bowl",
                  image: "bowl.jpg",
                },
              ],
            },
            {
              number: 2,
              step: "Mix in the green chilis, cheddar, and garlic.",
              ingredients: [
                {
                  id: 31015,
                  name: "green chili pepper",
                  localizedName: "green chili pepper",
                  image: "chili-peppers-green.jpg",
                },
                {
                  id: 1009,
                  name: "cheddar cheese",
                  localizedName: "cheddar cheese",
                  image: "cheddar-cheese.png",
                },
                {
                  id: 11215,
                  name: "garlic",
                  localizedName: "garlic",
                  image: "garlic.png",
                },
              ],
              equipment: [],
            },
            {
              number: 3,
              step: "Mix well.Microwave the dip for 45 seconds, stir and then an additional 45 seconds or until it is heated through.Alternately, you can spread the mixture in a baking dish and bake at 350 degrees F for 20-30 min or until heated through.",
              ingredients: [
                { id: 0, name: "spread", localizedName: "spread", image: "" },
                { id: 0, name: "dip", localizedName: "dip", image: "" },
              ],
              equipment: [
                {
                  id: 404646,
                  name: "baking pan",
                  localizedName: "baking pan",
                  image: "roasting-pan.jpg",
                },
                {
                  id: 404762,
                  name: "microwave",
                  localizedName: "microwave",
                  image: "microwave.jpg",
                },
                {
                  id: 404784,
                  name: "oven",
                  localizedName: "oven",
                  image: "oven.jpg",
                  temperature: { number: 350.0, unit: "Fahrenheit" },
                },
              ],
              length: { number: 30, unit: "minutes" },
            },
            {
              number: 4,
              step: "Serve with tortilla chips and enjoy the game (or the food!)",
              ingredients: [
                {
                  id: 19056,
                  name: "tortilla chips",
                  localizedName: "tortilla chips",
                  image: "tortilla-chips.jpg",
                },
                {
                  id: 0,
                  name: "game meat",
                  localizedName: "game meat",
                  image: "whole-chicken.jpg",
                },
              ],
              equipment: [],
            },
          ],
        },
      ],
      originalId: null,
      spoonacularSourceUrl:
        "https://spoonacular.com/green-chili-cheddar-dip-guest-post-715602",
    },
  },
  {
    id: 650939,
    value: {
      vegetarian: true,
      vegan: false,
      glutenFree: false,
      dairyFree: false,
      veryHealthy: false,
      cheap: false,
      veryPopular: false,
      sustainable: false,
      weightWatcherSmartPoints: 8,
      gaps: "no",
      lowFodmap: false,
      aggregateLikes: 130,
      spoonacularScore: 15.0,
      healthScore: 0.0,
      creditsText: "Foodista.com – The Cooking Encyclopedia Everyone Can Edit",
      license: "CC BY 3.0",
      sourceName: "Foodista",
      pricePerServing: 21.14,
      extendedIngredients: [
        {
          id: 9003,
          aisle: "Produce",
          image: "apple.jpg",
          consistency: "solid",
          name: "apple",
          nameClean: "apple",
          original: "2 cups chopped apple",
          originalName: "chopped apple",
          amount: 2.0,
          unit: "cups",
          meta: ["chopped"],
          measures: {
            us: { amount: 2.0, unitShort: "cups", unitLong: "cups" },
            metric: {
              amount: 473.176,
              unitShort: "ml",
              unitLong: "milliliters",
            },
          },
        },
        {
          id: 18372,
          aisle: "Baking",
          image: "white-powder.jpg",
          consistency: "solid",
          name: "baking soda",
          nameClean: "baking soda",
          original: "1 teaspoon baking soda",
          originalName: "baking soda",
          amount: 1.0,
          unit: "teaspoon",
          meta: [],
          measures: {
            us: { amount: 1.0, unitShort: "tsp", unitLong: "teaspoon" },
            metric: { amount: 1.0, unitShort: "tsp", unitLong: "teaspoon" },
          },
        },
        {
          id: 19334,
          aisle: "Baking",
          image: "dark-brown-sugar.png",
          consistency: "solid",
          name: "brown sugar",
          nameClean: "golden brown sugar",
          original: "1 cup brown sugar",
          originalName: "brown sugar",
          amount: 1.0,
          unit: "cup",
          meta: [],
          measures: {
            us: { amount: 1.0, unitShort: "cup", unitLong: "cup" },
            metric: {
              amount: 236.588,
              unitShort: "ml",
              unitLong: "milliliters",
            },
          },
        },
        {
          id: 1001,
          aisle: "Milk, Eggs, Other Dairy",
          image: "butter-sliced.jpg",
          consistency: "solid",
          name: "butter",
          nameClean: "butter",
          original: "1/2 cup butter",
          originalName: "butter",
          amount: 0.5,
          unit: "cup",
          meta: [],
          measures: {
            us: { amount: 0.5, unitShort: "cups", unitLong: "cups" },
            metric: {
              amount: 118.294,
              unitShort: "ml",
              unitLong: "milliliters",
            },
          },
        },
        {
          id: 2010,
          aisle: "Spices and Seasonings",
          image: "cinnamon.jpg",
          consistency: "solid",
          name: "cinnamon",
          nameClean: "cinnamon",
          original: "1 teaspoon cinnamon",
          originalName: "cinnamon",
          amount: 1.0,
          unit: "teaspoon",
          meta: [],
          measures: {
            us: { amount: 1.0, unitShort: "tsp", unitLong: "teaspoon" },
            metric: { amount: 1.0, unitShort: "tsp", unitLong: "teaspoon" },
          },
        },
        {
          id: 1123,
          aisle: "Milk, Eggs, Other Dairy",
          image: "egg.png",
          consistency: "solid",
          name: "egg",
          nameClean: "egg",
          original: "1 egg",
          originalName: "egg",
          amount: 1.0,
          unit: "",
          meta: [],
          measures: {
            us: { amount: 1.0, unitShort: "", unitLong: "" },
            metric: { amount: 1.0, unitShort: "", unitLong: "" },
          },
        },
        {
          id: 20081,
          aisle: "Baking",
          image: "flour.png",
          consistency: "solid",
          name: "flour",
          nameClean: "wheat flour",
          original: "2 cups flour",
          originalName: "flour",
          amount: 2.0,
          unit: "cups",
          meta: [],
          measures: {
            us: { amount: 2.0, unitShort: "cups", unitLong: "cups" },
            metric: {
              amount: 473.176,
              unitShort: "ml",
              unitLong: "milliliters",
            },
          },
        },
        {
          id: 2011,
          aisle: "Spices and Seasonings",
          image: "cloves.jpg",
          consistency: "solid",
          name: "ground cloves",
          nameClean: "ground clove",
          original: "1/4 teaspoon ground cloves",
          originalName: "ground cloves",
          amount: 0.25,
          unit: "teaspoon",
          meta: [],
          measures: {
            us: { amount: 0.25, unitShort: "tsps", unitLong: "teaspoons" },
            metric: { amount: 0.25, unitShort: "tsps", unitLong: "teaspoons" },
          },
        },
        {
          id: 11111111,
          aisle: "Baking",
          image: "vanilla-extract.jpg",
          consistency: "solid",
          name: "maple flavoring",
          nameClean: "maple flavoring",
          original: "1/4 teaspoon maple flavoring",
          originalName: "maple flavoring",
          amount: 0.25,
          unit: "teaspoon",
          meta: [],
          measures: {
            us: { amount: 0.25, unitShort: "tsps", unitLong: "teaspoons" },
            metric: { amount: 0.25, unitShort: "tsps", unitLong: "teaspoons" },
          },
        },
        {
          id: 1077,
          aisle: "Milk, Eggs, Other Dairy",
          image: "milk.png",
          consistency: "liquid",
          name: "milk",
          nameClean: "milk",
          original: "1/4 cup milk",
          originalName: "milk",
          amount: 0.25,
          unit: "cup",
          meta: [],
          measures: {
            us: { amount: 0.25, unitShort: "cups", unitLong: "cups" },
            metric: {
              amount: 59.147,
              unitShort: "ml",
              unitLong: "milliliters",
            },
          },
        },
        {
          id: 2025,
          aisle: "Spices and Seasonings",
          image: "ground-nutmeg.jpg",
          consistency: "solid",
          name: "nutmeg",
          nameClean: "nutmeg",
          original: "1/4 teaspoon nutmeg",
          originalName: "nutmeg",
          amount: 0.25,
          unit: "teaspoon",
          meta: [],
          measures: {
            us: { amount: 0.25, unitShort: "tsps", unitLong: "teaspoons" },
            metric: { amount: 0.25, unitShort: "tsps", unitLong: "teaspoons" },
          },
        },
        {
          id: 19336,
          aisle: "Baking",
          image: "powdered-sugar.jpg",
          consistency: "solid",
          name: "powdered sugar",
          nameClean: "powdered sugar",
          original: "1 cup powdered sugar",
          originalName: "powdered sugar",
          amount: 1.0,
          unit: "cup",
          meta: [],
          measures: {
            us: { amount: 1.0, unitShort: "cup", unitLong: "cup" },
            metric: {
              amount: 236.588,
              unitShort: "ml",
              unitLong: "milliliters",
            },
          },
        },
        {
          id: 2047,
          aisle: "Spices and Seasonings",
          image: "salt.jpg",
          consistency: "solid",
          name: "salt",
          nameClean: "table salt",
          original: "1 teaspoon salt",
          originalName: "salt",
          amount: 1.0,
          unit: "teaspoon",
          meta: [],
          measures: {
            us: { amount: 1.0, unitShort: "tsp", unitLong: "teaspoon" },
            metric: { amount: 1.0, unitShort: "tsp", unitLong: "teaspoon" },
          },
        },
      ],
      id: 650939,
      title: "Maple-Glazed Apple Cookies",
      readyInMinutes: 45,
      servings: 18,
      sourceUrl:
        "http://www.foodista.com/recipe/ZCJS73TL/maple-glazed-apple-cookies",
      image: "https://spoonacular.com/recipeImages/650939-556x370.jpg",
      imageType: "jpg",
      summary:
        'Maple-Glazed Apple Cookies might be just the dessert you are searching for. For <b>21 cents per serving</b>, this recipe <b>covers 3%</b> of your daily requirements of vitamins and minerals. One serving contains <b>181 calories</b>, <b>2g of protein</b>, and <b>6g of fat</b>. This recipe from Foodista has 130 fans. From preparation to the plate, this recipe takes roughly <b>45 minutes</b>. It is a good option if you\'re following a <b>vegetarian</b> diet. A mixture of apple, nutmeg, brown sugar, and a handful of other ingredients are all it takes to make this recipe so scrumptious. All things considered, we decided this recipe <b>deserves a spoonacular score of 16%</b>. This score is not so tremendous. Try <a href="https://spoonacular.com/recipes/maple-glazed-apple-crisp-cookies-621623">Maple-Glazed Apple Crisp Cookies</a>, <a href="https://spoonacular.com/recipes/maple-glazed-apple-pie-435364">Maple-Glazed Apple Pie</a>, and <a href="https://spoonacular.com/recipes/glazed-maple-cookies-141990">Glazed Maple Cookies</a> for similar recipes.',
      cuisines: [],
      dishTypes: [
        "antipasti",
        "starter",
        "snack",
        "appetizer",
        "antipasto",
        "hor d'oeuvre",
      ],
      diets: ["lacto ovo vegetarian"],
      occasions: [],
      winePairing: {},
      instructions:
        "<ol><li>Preheat oven to 400 degrees F.</li><li>Cream 1/2 cup butter and sugar together in a large mixing bowl until light in color, about 1-2 minutes. Add egg and 1/4 cup milk; stir to combine. Add remaining dry ingredients (except apple) and stir just until combined. Gently fold in the apples.  Drop by heaping tablespoons onto a greased baking sheet.</li><li>Bake at 400 for about 10-12 min or until tops don't look wet anymore.</li><li>To make the glaze, whisk together 1 tablespoon melted butter, 1 cup powdered sugar, 1/4 tsp maple flavoring, and 3 tablespoons milk in a small bowl. When the cookies have cooled for a few minutes, drizzle each cookie with glaze.</li></ol>",
      analyzedInstructions: [
        {
          name: "",
          steps: [
            {
              number: 1,
              step: "Preheat oven to 400 degrees F.Cream 1/2 cup butter and sugar together in a large mixing bowl until light in color, about 1-2 minutes.",
              ingredients: [
                {
                  id: 1001,
                  name: "butter",
                  localizedName: "butter",
                  image: "butter-sliced.jpg",
                },
                {
                  id: 1053,
                  name: "cream",
                  localizedName: "cream",
                  image: "fluid-cream.jpg",
                },
                {
                  id: 19335,
                  name: "sugar",
                  localizedName: "sugar",
                  image: "sugar-in-bowl.png",
                },
              ],
              equipment: [
                {
                  id: 405907,
                  name: "mixing bowl",
                  localizedName: "mixing bowl",
                  image: "mixing-bowl.jpg",
                },
                {
                  id: 404784,
                  name: "oven",
                  localizedName: "oven",
                  image: "oven.jpg",
                  temperature: { number: 400.0, unit: "Fahrenheit" },
                },
              ],
              length: { number: 2, unit: "minutes" },
            },
            {
              number: 2,
              step: "Add egg and 1/4 cup milk; stir to combine.",
              ingredients: [
                {
                  id: 1077,
                  name: "milk",
                  localizedName: "milk",
                  image: "milk.png",
                },
                {
                  id: 1123,
                  name: "egg",
                  localizedName: "egg",
                  image: "egg.png",
                },
              ],
              equipment: [],
            },
            {
              number: 3,
              step: "Add remaining dry ingredients (except apple) and stir just until combined. Gently fold in the apples.  Drop by heaping tablespoons onto a greased baking sheet.",
              ingredients: [
                {
                  id: 9003,
                  name: "apple",
                  localizedName: "apple",
                  image: "apple.jpg",
                },
              ],
              equipment: [
                {
                  id: 404727,
                  name: "baking sheet",
                  localizedName: "baking sheet",
                  image: "baking-sheet.jpg",
                },
              ],
            },
            {
              number: 4,
              step: "Bake at 400 for about 10-12 min or until tops don't look wet anymore.To make the glaze, whisk together 1 tablespoon melted butter, 1 cup powdered sugar, 1/4 tsp maple flavoring, and 3 tablespoons milk in a small bowl. When the cookies have cooled for a few minutes, drizzle each cookie with glaze.",
              ingredients: [
                {
                  id: 11111111,
                  name: "maple flavoring",
                  localizedName: "maple flavoring",
                  image: "vanilla-extract.jpg",
                },
                {
                  id: 19336,
                  name: "powdered sugar",
                  localizedName: "powdered sugar",
                  image: "powdered-sugar.jpg",
                },
                {
                  id: 10118192,
                  name: "cookies",
                  localizedName: "cookies",
                  image: "shortbread-cookies.jpg",
                },
                {
                  id: 1001,
                  name: "butter",
                  localizedName: "butter",
                  image: "butter-sliced.jpg",
                },
                { id: 0, name: "glaze", localizedName: "glaze", image: "" },
                {
                  id: 1077,
                  name: "milk",
                  localizedName: "milk",
                  image: "milk.png",
                },
              ],
              equipment: [
                {
                  id: 404784,
                  name: "oven",
                  localizedName: "oven",
                  image: "oven.jpg",
                },
                {
                  id: 404661,
                  name: "whisk",
                  localizedName: "whisk",
                  image: "whisk.png",
                },
                {
                  id: 404783,
                  name: "bowl",
                  localizedName: "bowl",
                  image: "bowl.jpg",
                },
              ],
              length: { number: 12, unit: "minutes" },
            },
          ],
        },
      ],
      originalId: null,
      spoonacularSourceUrl:
        "https://spoonacular.com/maple-glazed-apple-cookies-650939",
    },
  },
  {
    id: 646905,
    value: {
      vegetarian: true,
      vegan: false,
      glutenFree: false,
      dairyFree: false,
      veryHealthy: false,
      cheap: false,
      veryPopular: false,
      sustainable: false,
      weightWatcherSmartPoints: 14,
      gaps: "no",
      lowFodmap: false,
      aggregateLikes: 39,
      spoonacularScore: 29.0,
      healthScore: 2.0,
      creditsText: "Foodista.com – The Cooking Encyclopedia Everyone Can Edit",
      license: "CC BY 3.0",
      sourceName: "Foodista",
      pricePerServing: 37.57,
      extendedIngredients: [
        {
          id: 2001,
          aisle: "Spices and Seasonings",
          image: "allspice-ground.jpg",
          consistency: "solid",
          name: "allspice",
          nameClean: "allspice",
          original: "1/4 tsp Allspice",
          originalName: "Allspice",
          amount: 0.25,
          unit: "tsp",
          meta: [],
          measures: {
            us: { amount: 0.25, unitShort: "tsps", unitLong: "teaspoons" },
            metric: { amount: 0.25, unitShort: "tsps", unitLong: "teaspoons" },
          },
        },
        {
          id: 18371,
          aisle: "Baking",
          image: "white-powder.jpg",
          consistency: "solid",
          name: "baking powder",
          nameClean: "low sodium baking powder",
          original: "1 tsp Baking Powder",
          originalName: "Baking Powder",
          amount: 1.0,
          unit: "tsp",
          meta: [],
          measures: {
            us: { amount: 1.0, unitShort: "tsp", unitLong: "teaspoon" },
            metric: { amount: 1.0, unitShort: "tsp", unitLong: "teaspoon" },
          },
        },
        {
          id: 19334,
          aisle: "Baking",
          image: "dark-brown-sugar.png",
          consistency: "solid",
          name: "brown sugar",
          nameClean: "golden brown sugar",
          original: "1 cup Brown Sugar",
          originalName: "Brown Sugar",
          amount: 1.0,
          unit: "cup",
          meta: [],
          measures: {
            us: { amount: 1.0, unitShort: "cup", unitLong: "cup" },
            metric: {
              amount: 236.588,
              unitShort: "ml",
              unitLong: "milliliters",
            },
          },
        },
        {
          id: 1001,
          aisle: "Milk, Eggs, Other Dairy",
          image: "butter-sliced.jpg",
          consistency: "solid",
          name: "butter",
          nameClean: "butter",
          original: "1 stick Butter",
          originalName: "Butter",
          amount: 1.0,
          unit: "stick",
          meta: [],
          measures: {
            us: { amount: 1.0, unitShort: "stick", unitLong: "stick" },
            metric: { amount: 1.0, unitShort: "stick", unitLong: "stick" },
          },
        },
        {
          id: 2010,
          aisle: "Spices and Seasonings",
          image: "cinnamon.jpg",
          consistency: "solid",
          name: "cinnamon",
          nameClean: "cinnamon",
          original: "1 tsp Cinnamon",
          originalName: "Cinnamon",
          amount: 1.0,
          unit: "tsp",
          meta: [],
          measures: {
            us: { amount: 1.0, unitShort: "tsp", unitLong: "teaspoon" },
            metric: { amount: 1.0, unitShort: "tsp", unitLong: "teaspoon" },
          },
        },
        {
          id: 19165,
          aisle: "Baking",
          image: "cocoa-powder.png",
          consistency: "solid",
          name: "cocoa powder",
          nameClean: "cacao powder",
          original: "2 Tbsp Cocoa Powder (Optional)",
          originalName: "Cocoa Powder (Optional)",
          amount: 2.0,
          unit: "Tbsp",
          meta: ["(Optional)"],
          measures: {
            us: { amount: 2.0, unitShort: "Tbsps", unitLong: "Tbsps" },
            metric: { amount: 2.0, unitShort: "Tbsps", unitLong: "Tbsps" },
          },
        },
        {
          id: 1123,
          aisle: "Milk, Eggs, Other Dairy",
          image: "egg.png",
          consistency: "solid",
          name: "egg",
          nameClean: "egg",
          original: "1 Egg",
          originalName: "Egg",
          amount: 1.0,
          unit: "",
          meta: [],
          measures: {
            us: { amount: 1.0, unitShort: "", unitLong: "" },
            metric: { amount: 1.0, unitShort: "", unitLong: "" },
          },
        },
        {
          id: 20081,
          aisle: "Baking",
          image: "flour.png",
          consistency: "solid",
          name: "flour",
          nameClean: "wheat flour",
          original: "1 1/2 cups Flour",
          originalName: "Flour",
          amount: 1.5,
          unit: "cups",
          meta: [],
          measures: {
            us: { amount: 1.5, unitShort: "cups", unitLong: "cups" },
            metric: {
              amount: 354.882,
              unitShort: "ml",
              unitLong: "milliliters",
            },
          },
        },
        {
          id: 8120,
          aisle: "Cereal",
          image: "rolled-oats.jpg",
          consistency: "solid",
          name: "oats",
          nameClean: "rolled oats",
          original: "1/2 cup Oats",
          originalName: "Oats",
          amount: 0.5,
          unit: "cup",
          meta: [],
          measures: {
            us: { amount: 0.5, unitShort: "cups", unitLong: "cups" },
            metric: {
              amount: 118.294,
              unitShort: "ml",
              unitLong: "milliliters",
            },
          },
        },
        {
          id: 2047,
          aisle: "Spices and Seasonings",
          image: "salt.jpg",
          consistency: "solid",
          name: "salt",
          nameClean: "table salt",
          original: "1/8 tsp Salt",
          originalName: "Salt",
          amount: 0.125,
          unit: "tsp",
          meta: [],
          measures: {
            us: { amount: 0.125, unitShort: "tsps", unitLong: "teaspoons" },
            metric: { amount: 0.125, unitShort: "tsps", unitLong: "teaspoons" },
          },
        },
        {
          id: 2050,
          aisle: "Baking",
          image: "vanilla-extract.jpg",
          consistency: "liquid",
          name: "vanilla",
          nameClean: "vanilla extract",
          original: "1 tsp Vanilla",
          originalName: "Vanilla",
          amount: 1.0,
          unit: "tsp",
          meta: [],
          measures: {
            us: { amount: 1.0, unitShort: "tsp", unitLong: "teaspoon" },
            metric: { amount: 1.0, unitShort: "tsp", unitLong: "teaspoon" },
          },
        },
      ],
      id: 646905,
      title: "Homemade Animal Crackers",
      readyInMinutes: 45,
      servings: 8,
      sourceUrl:
        "http://www.foodista.com/recipe/BPVBYNNB/homemade-animal-crackers",
      image: "https://spoonacular.com/recipeImages/646905-556x370.jpg",
      imageType: "jpg",
      summary:
        'Homemade Animal Crackers might be just the dessert you are searching for. This recipe makes 8 servings with <b>324 calories</b>, <b>4g of protein</b>, and <b>13g of fat</b> each. For <b>38 cents per serving</b>, this recipe <b>covers 7%</b> of your daily requirements of vitamins and minerals. 39 people were impressed by this recipe. Head to the store and pick up allspice, baking powder, butter, and a few other things to make it today. It is a good option if you\'re following a <b>vegetarian</b> diet. From preparation to the plate, this recipe takes approximately <b>45 minutes</b>. All things considered, we decided this recipe <b>deserves a spoonacular score of 30%</b>. This score is rather bad. Try <a href="https://spoonacular.com/recipes/homemade-animal-crackers-205719">Homemade Animal Crackers</a>, <a href="https://spoonacular.com/recipes/animal-crackers-732741">Animal Crackers</a>, and <a href="https://spoonacular.com/recipes/animal-crackers-142292">Animal Crackers</a> for similar recipes.',
      cuisines: [],
      dishTypes: ["side dish"],
      diets: ["lacto ovo vegetarian"],
      occasions: [],
      winePairing: {},
      instructions:
        '<ol><li>Cream together the butter and brown sugar.</li><li>Add in the egg and vanilla and combine well.</li><li>Mix in the cinnamon, allspice, and salt.</li><li>Finally, add in the baking powder, oats, flour, and optional cocoa powder. Cocoa powder should be subbed for flour. Simply add the powder to your measuring cup and then fill the rest of the way up with flour.</li><li>Mix it up good and form into a ball. Store in the fridge for a minimum of one hour and up to overnight.</li><li>When ready, pull dough from fridge, grab off a hunk and roll it out to 1/4" thick.</li><li>Cut out crackers and place on a cookie sheet lined with parchment.</li><li>Bake for 5-7 minutes in an oven preheated to 350 degrees.</li></ol>',
      analyzedInstructions: [
        {
          name: "",
          steps: [
            {
              number: 1,
              step: "Cream together the butter and brown sugar.",
              ingredients: [
                {
                  id: 19334,
                  name: "brown sugar",
                  localizedName: "brown sugar",
                  image: "dark-brown-sugar.png",
                },
                {
                  id: 1001,
                  name: "butter",
                  localizedName: "butter",
                  image: "butter-sliced.jpg",
                },
                {
                  id: 1053,
                  name: "cream",
                  localizedName: "cream",
                  image: "fluid-cream.jpg",
                },
              ],
              equipment: [],
            },
            {
              number: 2,
              step: "Add in the egg and vanilla and combine well.",
              ingredients: [
                {
                  id: 1052050,
                  name: "vanilla",
                  localizedName: "vanilla",
                  image: "vanilla.jpg",
                },
                {
                  id: 1123,
                  name: "egg",
                  localizedName: "egg",
                  image: "egg.png",
                },
              ],
              equipment: [],
            },
            {
              number: 3,
              step: "Mix in the cinnamon, allspice, and salt.Finally, add in the baking powder, oats, flour, and optional cocoa powder. Cocoa powder should be subbed for flour. Simply add the powder to your measuring cup and then fill the rest of the way up with flour.",
              ingredients: [
                {
                  id: 18369,
                  name: "baking powder",
                  localizedName: "baking powder",
                  image: "white-powder.jpg",
                },
                {
                  id: 19165,
                  name: "cocoa powder",
                  localizedName: "cocoa powder",
                  image: "cocoa-powder.png",
                },
                {
                  id: 2001,
                  name: "allspice",
                  localizedName: "allspice",
                  image: "allspice-ground.jpg",
                },
                {
                  id: 2010,
                  name: "cinnamon",
                  localizedName: "cinnamon",
                  image: "cinnamon.jpg",
                },
                {
                  id: 20081,
                  name: "all purpose flour",
                  localizedName: "all purpose flour",
                  image: "flour.png",
                },
                {
                  id: 8120,
                  name: "oats",
                  localizedName: "oats",
                  image: "rolled-oats.jpg",
                },
                {
                  id: 2047,
                  name: "salt",
                  localizedName: "salt",
                  image: "salt.jpg",
                },
              ],
              equipment: [
                {
                  id: 404766,
                  name: "measuring cup",
                  localizedName: "measuring cup",
                  image: "measuring-cup.jpg",
                },
              ],
            },
            {
              number: 4,
              step: 'Mix it up good and form into a ball. Store in the fridge for a minimum of one hour and up to overnight.When ready, pull dough from fridge, grab off a hunk and roll it out to 1/4" thick.',
              ingredients: [
                {
                  id: 0,
                  name: "dough",
                  localizedName: "dough",
                  image: "pizza-dough",
                },
                {
                  id: 0,
                  name: "roll",
                  localizedName: "roll",
                  image: "dinner-yeast-rolls.jpg",
                },
              ],
              equipment: [],
              length: { number: 60, unit: "minutes" },
            },
            {
              number: 5,
              step: "Cut out crackers and place on a cookie sheet lined with parchment.",
              ingredients: [
                {
                  id: 18621,
                  name: "crackers",
                  localizedName: "crackers",
                  image: "crackers.jpg",
                },
                {
                  id: 10118192,
                  name: "cookies",
                  localizedName: "cookies",
                  image: "shortbread-cookies.jpg",
                },
              ],
              equipment: [
                {
                  id: 404727,
                  name: "baking sheet",
                  localizedName: "baking sheet",
                  image: "baking-sheet.jpg",
                },
              ],
            },
            {
              number: 6,
              step: "Bake for 5-7 minutes in an oven preheated to 350 degrees.",
              ingredients: [],
              equipment: [
                {
                  id: 404784,
                  name: "oven",
                  localizedName: "oven",
                  image: "oven.jpg",
                },
              ],
              length: { number: 7, unit: "minutes" },
            },
          ],
        },
      ],
      originalId: null,
      spoonacularSourceUrl:
        "https://spoonacular.com/homemade-animal-crackers-646905",
    },
  },
  {
    id: 715540,
    value: {
      vegetarian: true,
      vegan: true,
      glutenFree: true,
      dairyFree: true,
      veryHealthy: true,
      cheap: false,
      veryPopular: false,
      sustainable: false,
      weightWatcherSmartPoints: 0,
      gaps: "no",
      lowFodmap: false,
      aggregateLikes: 17,
      spoonacularScore: 97.0,
      healthScore: 96.0,
      creditsText: "Jen West",
      sourceName: "Pink When",
      pricePerServing: 175.37,
      extendedIngredients: [
        {
          id: 9003,
          aisle: "Produce",
          image: "apple.jpg",
          consistency: "solid",
          name: "apples",
          nameClean: "apple",
          original: "apples",
          originalName: "apples",
          amount: 1.0,
          unit: "serving",
          meta: [],
          measures: {
            us: { amount: 1.0, unitShort: "serving", unitLong: "serving" },
            metric: { amount: 1.0, unitShort: "serving", unitLong: "serving" },
          },
        },
        {
          id: 9042,
          aisle: "Produce",
          image: "blackberries.jpg",
          consistency: "solid",
          name: "blackberries",
          nameClean: "blackberries",
          original: "blackberries",
          originalName: "blackberries",
          amount: 1.0,
          unit: "serving",
          meta: [],
          measures: {
            us: { amount: 1.0, unitShort: "serving", unitLong: "serving" },
            metric: { amount: 1.0, unitShort: "serving", unitLong: "serving" },
          },
        },
        {
          id: 10111251,
          aisle: "Produce",
          image: "romaine.jpg",
          consistency: "solid",
          name: "romaine lettuce",
          nameClean: "romaine",
          original: "Romaine lettuce",
          originalName: "Romaine lettuce",
          amount: 1.0,
          unit: "serving",
          meta: [],
          measures: {
            us: { amount: 1.0, unitShort: "serving", unitLong: "serving" },
            metric: { amount: 1.0, unitShort: "serving", unitLong: "serving" },
          },
        },
        {
          id: 9316,
          aisle: "Produce",
          image: "strawberries.png",
          consistency: "solid",
          name: "strawberries",
          nameClean: "strawberries",
          original: "strawberries",
          originalName: "strawberries",
          amount: 1.0,
          unit: "serving",
          meta: [],
          measures: {
            us: { amount: 1.0, unitShort: "serving", unitLong: "serving" },
            metric: { amount: 1.0, unitShort: "serving", unitLong: "serving" },
          },
        },
        {
          id: 4135,
          aisle: "Oil, Vinegar, Salad Dressing",
          image: "vinaigrette.jpg",
          consistency: "liquid",
          name: "vinaigrette",
          nameClean: "vinaigrette",
          original: "basalmic vinaigrette",
          originalName: "basalmic vinaigrette",
          amount: 1.0,
          unit: "serving",
          meta: [],
          measures: {
            us: { amount: 1.0, unitShort: "serving", unitLong: "serving" },
            metric: { amount: 1.0, unitShort: "serving", unitLong: "serving" },
          },
        },
      ],
      id: 715540,
      title: "Summer Berry Salad",
      readyInMinutes: 45,
      servings: 1,
      sourceUrl: "http://www.pinkwhen.com/summer-berry-salad/",
      image: "https://spoonacular.com/recipeImages/715540-556x370.jpg",
      imageType: "jpg",
      summary:
        'Summer Berry Salad might be just the side dish you are searching for. Watching your figure? This caveman, gluten free, primal, and vegan recipe has <b>98 calories</b>, <b>2g of protein</b>, and <b>1g of fat</b> per serving. This recipe serves 1 and costs $1.75 per serving. 17 people have tried and liked this recipe. If you have apples, blackberries, romaine lettuce, and a few other ingredients on hand, you can make it. It can be enjoyed any time, but it is especially good for <b>The Fourth Of July</b>. From preparation to the plate, this recipe takes approximately <b>45 minutes</b>. All things considered, we decided this recipe <b>deserves a spoonacular score of 98%</b>. This score is outstanding. Try <a href="https://spoonacular.com/recipes/berry-summer-salad-50848">Berry Summer Salad</a>, <a href="https://spoonacular.com/recipes/summer-berry-salad-485592">Summer Berry Salad</a>, and <a href="https://spoonacular.com/recipes/chicken-berry-summer-salad-769303">Chicken & Berry Summer Salad</a> for similar recipes.',
      cuisines: [],
      dishTypes: ["salad"],
      diets: [
        "gluten free",
        "dairy free",
        "paleolithic",
        "lacto ovo vegetarian",
        "primal",
        "vegan",
      ],
      occasions: ["4th of july", "summer"],
      winePairing: {},
      instructions:
        "Cut up a Granny Smith green apple, strawberries, and add blackberriesMix in with Romaine lettuceToss in some basalmic vinaigrette",
      analyzedInstructions: [
        {
          name: "",
          steps: [
            {
              number: 1,
              step: "Cut up a Granny Smith green apple, strawberries, and add blackberries",
              ingredients: [
                {
                  id: 9042,
                  name: "blackberries",
                  localizedName: "blackberries",
                  image: "blackberries.jpg",
                },
                {
                  id: 9316,
                  name: "strawberries",
                  localizedName: "strawberries",
                  image: "strawberries.png",
                },
                {
                  id: 1069003,
                  name: "green apple",
                  localizedName: "green apple",
                  image: "grannysmith-apple.png",
                },
              ],
              equipment: [],
            },
            {
              number: 2,
              step: "Mix in with Romaine lettuce",
              ingredients: [
                {
                  id: 10111251,
                  name: "romaine",
                  localizedName: "romaine",
                  image: "romaine",
                },
              ],
              equipment: [],
            },
            {
              number: 3,
              step: "Toss in some basalmic vinaigrette",
              ingredients: [
                {
                  id: 4135,
                  name: "vinaigrette",
                  localizedName: "vinaigrette",
                  image: "vinaigrette.jpg",
                },
              ],
              equipment: [],
            },
          ],
        },
      ],
      originalId: null,
      spoonacularSourceUrl: "https://spoonacular.com/summer-berry-salad-715540",
    },
  },
  {
    id: 641435,
    value: {
      vegetarian: true,
      vegan: false,
      glutenFree: false,
      dairyFree: true,
      veryHealthy: false,
      cheap: false,
      veryPopular: false,
      sustainable: false,
      weightWatcherSmartPoints: 15,
      gaps: "no",
      lowFodmap: false,
      aggregateLikes: 49,
      spoonacularScore: 30.0,
      healthScore: 2.0,
      creditsText: "Foodista.com – The Cooking Encyclopedia Everyone Can Edit",
      license: "CC BY 3.0",
      sourceName: "Foodista",
      pricePerServing: 150.42,
      extendedIngredients: [
        {
          id: 20081,
          aisle: "Baking",
          image: "flour.png",
          consistency: "solid",
          name: "all purpose flour",
          nameClean: "wheat flour",
          original: "1 cup all purpose flour",
          originalName: "all purpose flour",
          amount: 1.0,
          unit: "cup",
          meta: [],
          measures: {
            us: {
              amount: 1.0,
              unitShort: "cup",
              unitLong: "cup",
            },
            metric: {
              amount: 236.588,
              unitShort: "ml",
              unitLong: "milliliters",
            },
          },
        },
        {
          id: 4582,
          aisle: "Oil, Vinegar, Salad Dressing",
          image: "vegetable-oil.jpg",
          consistency: "liquid",
          name: "canola oil",
          nameClean: "cooking oil",
          original: "Canola oil for frying",
          originalName: "Canola oil for frying",
          amount: 6.0,
          unit: "servings",
          meta: ["for frying"],
          measures: {
            us: {
              amount: 6.0,
              unitShort: "servings",
              unitLong: "servings",
            },
            metric: {
              amount: 6.0,
              unitShort: "servings",
              unitLong: "servings",
            },
          },
        },
        {
          id: 2010,
          aisle: "Spices and Seasonings",
          image: "cinnamon.jpg",
          consistency: "solid",
          name: "cinnamon",
          nameClean: "cinnamon",
          original: "1/2 tsp cinnamon",
          originalName: "cinnamon",
          amount: 0.5,
          unit: "tsp",
          meta: [],
          measures: {
            us: {
              amount: 0.5,
              unitShort: "tsps",
              unitLong: "teaspoons",
            },
            metric: {
              amount: 0.5,
              unitShort: "tsps",
              unitLong: "teaspoons",
            },
          },
        },
        {
          id: 19350,
          aisle: "Baking",
          image: "corn-syrup.png",
          consistency: "solid",
          name: "corn syrup",
          nameClean: "corn syrup",
          original: "1/2 cup corn syrup",
          originalName: "corn syrup",
          amount: 0.5,
          unit: "cup",
          meta: [],
          measures: {
            us: {
              amount: 0.5,
              unitShort: "cups",
              unitLong: "cups",
            },
            metric: {
              amount: 118.294,
              unitShort: "ml",
              unitLong: "milliliters",
            },
          },
        },
        {
          id: 1124,
          aisle: "Milk, Eggs, Other Dairy",
          image: "egg-white.jpg",
          consistency: "solid",
          name: "egg white",
          nameClean: "egg whites",
          original: "1 large egg white",
          originalName: "egg white",
          amount: 1.0,
          unit: "large",
          meta: [],
          measures: {
            us: {
              amount: 1.0,
              unitShort: "large",
              unitLong: "large",
            },
            metric: {
              amount: 1.0,
              unitShort: "large",
              unitLong: "large",
            },
          },
        },
        {
          id: 1089003,
          aisle: "Produce",
          image: "grannysmith-apple.png",
          consistency: "solid",
          name: "granny smith apples",
          nameClean: "granny smith apple",
          original: "6 large Granny Smith apples, peeled",
          originalName: "Granny Smith apples, peeled",
          amount: 6.0,
          unit: "large",
          meta: ["peeled"],
          measures: {
            us: {
              amount: 6.0,
              unitShort: "large",
              unitLong: "larges",
            },
            metric: {
              amount: 6.0,
              unitShort: "large",
              unitLong: "larges",
            },
          },
        },
        {
          id: 2047,
          aisle: "Spices and Seasonings",
          image: "salt.jpg",
          consistency: "solid",
          name: "salt",
          nameClean: "table salt",
          original: "1/4 teaspoon salt",
          originalName: "salt",
          amount: 0.25,
          unit: "teaspoon",
          meta: [],
          measures: {
            us: {
              amount: 0.25,
              unitShort: "tsps",
              unitLong: "teaspoons",
            },
            metric: {
              amount: 0.25,
              unitShort: "tsps",
              unitLong: "teaspoons",
            },
          },
        },
        {
          id: 19335,
          aisle: "Baking",
          image: "sugar-in-bowl.png",
          consistency: "solid",
          name: "sugar",
          nameClean: "sugar",
          original: "1 cup sugar",
          originalName: "sugar",
          amount: 1.0,
          unit: "cup",
          meta: [],
          measures: {
            us: {
              amount: 1.0,
              unitShort: "cup",
              unitLong: "cup",
            },
            metric: {
              amount: 236.588,
              unitShort: "ml",
              unitLong: "milliliters",
            },
          },
        },
        {
          id: 2050,
          aisle: "Baking",
          image: "vanilla-extract.jpg",
          consistency: "liquid",
          name: "vanilla",
          nameClean: "vanilla extract",
          original: "1 tablespoon vanilla",
          originalName: "vanilla",
          amount: 1.0,
          unit: "tablespoon",
          meta: [],
          measures: {
            us: {
              amount: 1.0,
              unitShort: "Tbsp",
              unitLong: "Tbsp",
            },
            metric: {
              amount: 1.0,
              unitShort: "Tbsp",
              unitLong: "Tbsp",
            },
          },
        },
        {
          id: 14412,
          aisle: "Beverages",
          image: "water.png",
          consistency: "liquid",
          name: "water",
          nameClean: "water",
          original: "1 cup water",
          originalName: "water",
          amount: 1.0,
          unit: "cup",
          meta: [],
          measures: {
            us: {
              amount: 1.0,
              unitShort: "cup",
              unitLong: "cup",
            },
            metric: {
              amount: 236.588,
              unitShort: "ml",
              unitLong: "milliliters",
            },
          },
        },
      ],
      id: 641435,
      title: "Dessert Apple Rings With Cinnamon Cream Syrup",
      readyInMinutes: 45,
      servings: 6,
      sourceUrl:
        "http://www.foodista.com/recipe/DXMVKPRX/dessert-apple-rings-with-cinnamon-cream-syrup",
      image: "https://spoonacular.com/recipeImages/641435-556x370.jpg",
      imageType: "jpg",
      summary:
        'Dessert Apple Rings With Cinnamon Cream Syrup might be just the dessert you are searching for. This recipe makes 6 servings with <b>402 calories</b>, <b>3g of protein</b>, and <b>2g of fat</b> each. For <b>$1.32 per serving</b>, this recipe <b>covers 6%</b> of your daily requirements of vitamins and minerals. This recipe from Foodista has 49 fans. A mixture of all purpose flour, canolan oil, egg white, and a handful of other ingredients are all it takes to make this recipe so tasty. It is a good option if you\'re following a <b>dairy free and vegetarian</b> diet. From preparation to the plate, this recipe takes about <b>45 minutes</b>. All things considered, we decided this recipe <b>deserves a spoonacular score of 29%</b>. This score is rather bad. Try <a href="https://spoonacular.com/recipes/whole-wheat-apple-cinnamon-pancakes-with-cinnamon-syrup-548079">Whole Wheat Apple Cinnamon Pancakes with Cinnamon Syrup</a>, <a href="https://spoonacular.com/recipes/cinnamon-cornbread-waffles-with-apple-cinnamon-syrup-165951">Cinnamon-Cornbread Waffles with Apple-Cinnamon Syrup</a>, and <a href="https://spoonacular.com/recipes/apple-cinnamon-waffles-with-cinnamon-syrup-568719">Apple Cinnamon Waffles with Cinnamon Syrup</a> for similar recipes.',
      cuisines: [],
      dishTypes: ["dessert"],
      diets: ["dairy free", "lacto ovo vegetarian"],
      occasions: [],
      winePairing: {},
      instructions:
        "<ol><li>Whisk egg until frothy and the whisk in water and vanilla. Whisk in flour and salt and let sit while slicing apples.</li><li>Slice peeled apples into 1/2 inch thick slices (you will get about 4 slices per apple).</li><li>Using varying sized biscuit cutters, cut rings out of apple slices, discarding smallest circle containing core.</li><li>Heat oil to 375 degrees.</li><li>Dip apple rings into batter, letting excess drip off.</li><li>Cook in oil in small batches, turning frequently to monitor browning.</li><li>When the rings turn golden brown, remove to a plate and while still hot sprinkle generously with cinnamon sugar.</li><li>Serve immediately with warm drizzled sauce.</li><li>Makes 16 apple rings  serves 4 to 6.</li><li>CINNAMON CREAM SYRUP</li><li>In a small saucepan, combine 1 cup sugar, 1/2 cup corn syrup and 1/2 teaspoon cinnamon. Bring to a boil, stirring for 3 minutes. Remove from heat and cool for 5 minutes. Stir in 1/2 cup evaporated milk. Serve warm.</li></ol>",
      analyzedInstructions: [
        {
          name: "",
          steps: [
            {
              number: 1,
              step: "Whisk egg until frothy and the whisk in water and vanilla.",
              ingredients: [
                {
                  id: 1052050,
                  name: "vanilla",
                  localizedName: "vanilla",
                  image: "vanilla.jpg",
                },
                {
                  id: 14412,
                  name: "water",
                  localizedName: "water",
                  image: "water.png",
                },
                {
                  id: 1123,
                  name: "egg",
                  localizedName: "egg",
                  image: "egg.png",
                },
              ],
              equipment: [
                {
                  id: 404661,
                  name: "whisk",
                  localizedName: "whisk",
                  image: "whisk.png",
                },
              ],
            },
            {
              number: 2,
              step: "Whisk in flour and salt and let sit while slicing apples.Slice peeled apples into 1/2 inch thick slices (you will get about 4 slices per apple).Using varying sized biscuit cutters, cut rings out of apple slices, discarding smallest circle containing core.",
              ingredients: [
                {
                  id: 18009,
                  name: "biscuits",
                  localizedName: "biscuits",
                  image: "buttermilk-biscuits.jpg",
                },
                {
                  id: 9003,
                  name: "apple",
                  localizedName: "apple",
                  image: "apple.jpg",
                },
                {
                  id: 20081,
                  name: "all purpose flour",
                  localizedName: "all purpose flour",
                  image: "flour.png",
                },
                {
                  id: 2047,
                  name: "salt",
                  localizedName: "salt",
                  image: "salt.jpg",
                },
              ],
              equipment: [
                {
                  id: 404661,
                  name: "whisk",
                  localizedName: "whisk",
                  image: "whisk.png",
                },
              ],
            },
            {
              number: 3,
              step: "Heat oil to 375 degrees.Dip apple rings into batter, letting excess drip off.Cook in oil in small batches, turning frequently to monitor browning.When the rings turn golden brown, remove to a plate and while still hot sprinkle generously with cinnamon sugar.",
              ingredients: [
                {
                  id: 10219335,
                  name: "cinnamon sugar",
                  localizedName: "cinnamon sugar",
                  image: "cinnamon-sugar.png",
                },
                {
                  id: 9003,
                  name: "apple",
                  localizedName: "apple",
                  image: "apple.jpg",
                },
                {
                  id: 0,
                  name: "dip",
                  localizedName: "dip",
                  image: "",
                },
                {
                  id: 4582,
                  name: "cooking oil",
                  localizedName: "cooking oil",
                  image: "vegetable-oil.jpg",
                },
              ],
              equipment: [],
            },
            {
              number: 4,
              step: "Serve immediately with warm drizzled sauce.Makes 16 apple rings  serves 4 to 6.CINNAMON CREAM SYRUPIn a small saucepan, combine 1 cup sugar, 1/2 cup corn syrup and 1/2 teaspoon cinnamon. Bring to a boil, stirring for 3 minutes.",
              ingredients: [
                {
                  id: 19350,
                  name: "corn syrup",
                  localizedName: "corn syrup",
                  image: "corn-syrup.png",
                },
                {
                  id: 2010,
                  name: "cinnamon",
                  localizedName: "cinnamon",
                  image: "cinnamon.jpg",
                },
                {
                  id: 9003,
                  name: "apple",
                  localizedName: "apple",
                  image: "apple.jpg",
                },
                {
                  id: 1053,
                  name: "cream",
                  localizedName: "cream",
                  image: "fluid-cream.jpg",
                },
                {
                  id: 0,
                  name: "sauce",
                  localizedName: "sauce",
                  image: "",
                },
                {
                  id: 19335,
                  name: "sugar",
                  localizedName: "sugar",
                  image: "sugar-in-bowl.png",
                },
              ],
              equipment: [
                {
                  id: 404669,
                  name: "sauce pan",
                  localizedName: "sauce pan",
                  image: "sauce-pan.jpg",
                },
              ],
              length: {
                number: 3,
                unit: "minutes",
              },
            },
            {
              number: 5,
              step: "Remove from heat and cool for 5 minutes. Stir in 1/2 cup evaporated milk.",
              ingredients: [
                {
                  id: 1214,
                  name: "evaporated milk",
                  localizedName: "evaporated milk",
                  image: "evaporated-milk.png",
                },
              ],
              equipment: [],
              length: {
                number: 5,
                unit: "minutes",
              },
            },
            {
              number: 6,
              step: "Serve warm.",
              ingredients: [],
              equipment: [],
            },
          ],
        },
      ],
      originalId: null,
      spoonacularSourceUrl:
        "https://spoonacular.com/dessert-apple-rings-with-cinnamon-cream-syrup-641435",
    },
  },
  {
    id: 648709,
    value: {
      vegetarian: true,
      vegan: false,
      glutenFree: true,
      dairyFree: false,
      veryHealthy: false,
      cheap: false,
      veryPopular: false,
      sustainable: false,
      weightWatcherSmartPoints: 4,
      gaps: "no",
      lowFodmap: false,
      aggregateLikes: 15,
      spoonacularScore: 58.0,
      healthScore: 11.0,
      creditsText: "Foodista.com – The Cooking Encyclopedia Everyone Can Edit",
      license: "CC BY 3.0",
      sourceName: "Foodista",
      pricePerServing: 68.53,
      extendedIngredients: [
        {
          id: 11233,
          aisle: "Produce",
          image: "kale.jpg",
          consistency: "solid",
          name: "kale",
          nameClean: "kale",
          original:
            "1/2 a large bunch of kale, cooked in salted boiling water for 5 or 10 minutes, till soft but still bright green.",
          originalName:
            "1/2 a of kale, cooked in salted boiling water for 5 or 10 minutes, till soft but still bright green",
          amount: 1.0,
          unit: "large",
          meta: [
            "salted",
            "boiling",
            "soft",
            "cooked",
            "for 5 or 10 minutes, till  but still bright green.",
          ],
          measures: {
            us: {
              amount: 1.0,
              unitShort: "large",
              unitLong: "large",
            },
            metric: {
              amount: 1.0,
              unitShort: "large",
              unitLong: "large",
            },
          },
        },
        {
          id: 16058,
          aisle: "Canned and Jarred",
          image: "chickpeas.png",
          consistency: "solid",
          name: "canned chickpeas",
          nameClean: "canned chickpeas",
          original: "1 cup chickpeas (I used canned, so rinsed and drained)",
          originalName: "chickpeas (I used canned, so rinsed and drained)",
          amount: 1.0,
          unit: "cup",
          meta: ["canned", "rinsed", "drained", "(I used , so and )"],
          measures: {
            us: {
              amount: 1.0,
              unitShort: "cup",
              unitLong: "cup",
            },
            metric: {
              amount: 236.588,
              unitShort: "ml",
              unitLong: "milliliters",
            },
          },
        },
        {
          id: 11507,
          aisle: "Produce",
          image: "sweet-potato.png",
          consistency: "solid",
          name: "sweet potatoes",
          nameClean: "sweet potato",
          original:
            "2 medium sweet potatoes, peeled and cut into 1/3 inch dice",
          originalName: "sweet potatoes, peeled and cut into 1/3 inch dice",
          amount: 2.0,
          unit: "medium",
          meta: ["peeled", "cut into 1/3 inch dice"],
          measures: {
            us: {
              amount: 2.0,
              unitShort: "medium",
              unitLong: "mediums",
            },
            metric: {
              amount: 2.0,
              unitShort: "medium",
              unitLong: "mediums",
            },
          },
        },
        {
          id: 4053,
          aisle: "Oil, Vinegar, Salad Dressing",
          image: "olive-oil.jpg",
          consistency: "liquid",
          name: "olive oil",
          nameClean: "olive oil",
          original: "Olive oil",
          originalName: "Olive oil",
          amount: 1.0,
          unit: "serving",
          meta: [],
          measures: {
            us: {
              amount: 1.0,
              unitShort: "serving",
              unitLong: "serving",
            },
            metric: {
              amount: 1.0,
              unitShort: "serving",
              unitLong: "serving",
            },
          },
        },
        {
          id: 11677,
          aisle: "Produce",
          image: "shallots.jpg",
          consistency: "solid",
          name: "shallot",
          nameClean: "shallot",
          original: "1 shallot – finely diced",
          originalName: "shallot – finely diced",
          amount: 1.0,
          unit: "",
          meta: ["diced", "finely"],
          measures: {
            us: {
              amount: 1.0,
              unitShort: "",
              unitLong: "",
            },
            metric: {
              amount: 1.0,
              unitShort: "",
              unitLong: "",
            },
          },
        },
        {
          id: 11215,
          aisle: "Produce",
          image: "garlic.png",
          consistency: "solid",
          name: "garlic",
          nameClean: "garlic",
          original: "1 large clove garlic – minced",
          originalName: "garlic – minced",
          amount: 1.0,
          unit: "large clove",
          meta: ["minced"],
          measures: {
            us: {
              amount: 1.0,
              unitShort: "large clove",
              unitLong: "large clove",
            },
            metric: {
              amount: 1.0,
              unitShort: "large clove",
              unitLong: "large clove",
            },
          },
        },
        {
          id: 2044,
          aisle: "Produce",
          image: "fresh-basil.jpg",
          consistency: "solid",
          name: "basil",
          nameClean: "fresh basil",
          original: "1 t. basil",
          originalName: "basil",
          amount: 1.0,
          unit: "t",
          meta: [],
          measures: {
            us: {
              amount: 1.0,
              unitShort: "tsp",
              unitLong: "teaspoon",
            },
            metric: {
              amount: 1.0,
              unitShort: "tsp",
              unitLong: "teaspoon",
            },
          },
        },
        {
          id: 1032009,
          aisle: "Spices and Seasonings",
          image: "red-pepper-flakes.jpg",
          consistency: "solid",
          name: "red pepper flakes",
          nameClean: "red pepper flakes",
          original: "1/2 t. red pepper flakes (or to taste)",
          originalName: "red pepper flakes (or to taste)",
          amount: 0.5,
          unit: "t",
          meta: ["red", "to taste", "(or )"],
          measures: {
            us: {
              amount: 0.5,
              unitShort: "tsps",
              unitLong: "teaspoons",
            },
            metric: {
              amount: 0.5,
              unitShort: "tsps",
              unitLong: "teaspoons",
            },
          },
        },
        {
          id: 14003,
          aisle: "Alcoholic Beverages",
          image: "beer.jpg",
          consistency: "liquid",
          name: "beer",
          nameClean: "beer",
          original: "1/2 cup beer",
          originalName: "beer",
          amount: 0.5,
          unit: "cup",
          meta: [],
          measures: {
            us: {
              amount: 0.5,
              unitShort: "cups",
              unitLong: "cups",
            },
            metric: {
              amount: 118.294,
              unitShort: "ml",
              unitLong: "milliliters",
            },
          },
        },
        {
          id: 9297,
          aisle: "Dried Fruits;Produce;Baking",
          image: "golden-raisins.jpg",
          consistency: "solid",
          name: "golden raisins",
          nameClean: "golden raisins",
          original: "2 T golden raisins, soaked till soft and chopped",
          originalName: "golden raisins, soaked till soft and chopped",
          amount: 2.0,
          unit: "T",
          meta: ["soft", "chopped"],
          measures: {
            us: {
              amount: 2.0,
              unitShort: "Tbsps",
              unitLong: "Tbsps",
            },
            metric: {
              amount: 2.0,
              unitShort: "Tbsps",
              unitLong: "Tbsps",
            },
          },
        },
        {
          id: 1012028,
          aisle: "Spices and Seasonings",
          image: "paprika.jpg",
          consistency: "solid",
          name: "smoked paprika",
          nameClean: "smoked paprika",
          original: "1 t. smoked paprika",
          originalName: "smoked paprika",
          amount: 1.0,
          unit: "t",
          meta: ["smoked"],
          measures: {
            us: {
              amount: 1.0,
              unitShort: "tsp",
              unitLong: "teaspoon",
            },
            metric: {
              amount: 1.0,
              unitShort: "tsp",
              unitLong: "teaspoon",
            },
          },
        },
        {
          id: 1002014,
          aisle: "Spices and Seasonings",
          image: "ground-cumin.jpg",
          consistency: "solid",
          name: "cumin",
          nameClean: "cumin",
          original: "1 t. cumin",
          originalName: "cumin",
          amount: 1.0,
          unit: "t",
          meta: [],
          measures: {
            us: {
              amount: 1.0,
              unitShort: "tsp",
              unitLong: "teaspoon",
            },
            metric: {
              amount: 1.0,
              unitShort: "tsp",
              unitLong: "teaspoon",
            },
          },
        },
        {
          id: 1001,
          aisle: "Milk, Eggs, Other Dairy",
          image: "butter-sliced.jpg",
          consistency: "solid",
          name: "butter",
          nameClean: "butter",
          original: "Tbsp of butter",
          originalName: "butter",
          amount: 1.0,
          unit: "Tbsp",
          meta: [],
          measures: {
            us: {
              amount: 1.0,
              unitShort: "Tbsp",
              unitLong: "Tbsp",
            },
            metric: {
              amount: 1.0,
              unitShort: "Tbsp",
              unitLong: "Tbsp",
            },
          },
        },
        {
          id: 9160,
          aisle: "Produce",
          image: "lime-juice.png",
          consistency: "liquid",
          name: "juice of lime",
          nameClean: "lime juice",
          original: "juice of 1 lime",
          originalName: "juice of lime",
          amount: 1.0,
          unit: "",
          meta: [],
          measures: {
            us: {
              amount: 1.0,
              unitShort: "",
              unitLong: "",
            },
            metric: {
              amount: 1.0,
              unitShort: "",
              unitLong: "",
            },
          },
        },
        {
          id: 1102047,
          aisle: "Spices and Seasonings",
          image: "salt-and-pepper.jpg",
          consistency: "solid",
          name: "Salt & Pepper",
          nameClean: "salt and pepper",
          original: "salt & pepper",
          originalName: "salt & pepper",
          amount: 1.0,
          unit: "serving",
          meta: [],
          measures: {
            us: {
              amount: 1.0,
              unitShort: "serving",
              unitLong: "serving",
            },
            metric: {
              amount: 1.0,
              unitShort: "serving",
              unitLong: "serving",
            },
          },
        },
      ],
      id: 648709,
      title: "Kale & chickpea stew with cumin, smoked paprika and lime",
      readyInMinutes: 45,
      servings: 6,
      sourceUrl:
        "https://www.foodista.com/recipe/XQZSJ4W6/kale-chickpea-stew-with-cumin-smoked-paprika-and-lime",
      image: "https://spoonacular.com/recipeImages/648709-556x370.jpg",
      imageType: "jpg",
      summary:
        'If you have roughly <b>roughly 45 minutes</b> to spend in the kitchen, Kale & chickpea stew with cumin, smoked paprikan and lime might be an amazing <b>gluten free and lacto ovo vegetarian</b> recipe to try. One portion of this dish contains about <b>4g of protein</b>, <b>5g of fat</b>, and a total of <b>162 calories</b>. For <b>69 cents per serving</b>, you get a soup that serves 6. 15 people were glad they tried this recipe. It is brought to you by Foodista. <b>Autumn</b> will be even more special with this recipe. A mixture of 2 a bunch of kale, beer, olive oil, and a handful of other ingredients are all it takes to make this recipe so scrumptious. Overall, this recipe earns a <b>solid spoonacular score of 57%</b>. Similar recipes include <a href="https://spoonacular.com/recipes/mexican-black-bean-salad-with-cumin-lime-and-smoked-paprika-dressing-vegan-628029">Mexican Black Bean Salad with Cumin, Lime and Smoked Paprika dressing {vegan}</a>, <a href="https://spoonacular.com/recipes/one-pot-cumin-smoked-paprika-chicken-with-potatoes-584593">One-Pot Cumin & Smoked Paprika Chicken with Potatoes</a>, and <a href="https://spoonacular.com/recipes/moorish-style-salad-with-cumin-and-smoked-paprika-ensalada-morisca-747">Moorish-Style Salad with Cumin and Smoked Paprika (Ensalada Morisca)</a>.',
      cuisines: [],
      dishTypes: ["soup"],
      diets: ["gluten free", "lacto ovo vegetarian"],
      occasions: ["fall", "winter"],
      winePairing: {
        pairedWines: ["cabernet sauvignon", "chablis", "malbec"],
        pairingText:
          "Cabernet Sauvignon, Chablis, and Malbec are great choices for Stew. Full-bodied red wines like malbec and cabernet sauvignon are the perfect accompaniment for beef stew. Fish stew probably calls for a white wine, such as chablis. The Eisele Vineyard Cabernet Sauvignon with a 4.4 out of 5 star rating seems like a good match. It costs about 500 dollars per bottle.",
        productMatches: [
          {
            id: 464700,
            title: "Eisele Vineyard Cabernet Sauvignon",
            description:
              "The 2013 Cabernet Sauvignon is pure Eisele. In the cellar, the wines revealed themselves with practically no need to intervene. The secret of the vintage was to be gentle on the fruit and not overdo it. The natural concentration and depth of the vintage are combined with exquisite elegance, precision and finesse, which are hallmarks of this terroir. The 2013 Eisele Cabernet opens up on notes of dried rose petals and spices with a hint of boysenberries. On the palate, the multiple dimensions of the texture and the expression of black and blue fruit combine with a sense of extraordinary purity. The refined and tightly-knit tannins give way to a very long, deliciously mineral, almost saline finish.",
            price: "$499.99",
            imageUrl:
              "https://spoonacular.com/productImages/464700-312x231.jpg",
            averageRating: 0.8800000000000001,
            ratingCount: 7.0,
            score: 0.8345454545454547,
            link: "https://click.linksynergy.com/deeplink?id=*QCiIS6t4gA&mid=2025&murl=https%3A%2F%2Fwww.wine.com%2Fproduct%2Feisele-vineyard-cabernet-sauvignon-2013%2F165361",
          },
        ],
      },
      instructions:
        "Warm a few tablespoons of olive oil in a large frying pan over medium heat. Add the shallots, garlic, red pepper and basil and cook till the shallots and garlic start to brown.\nAdd the sweet potatoes and cook till they start to brown and soften. Add the beer. Cook till its thick and syrupy.\nAdd the chickpeas, paprika, cumin, raisins and about 2 cups of water. Bring to a boil and reduce heat and simmer till the sweet potato is nice and soft. You might need to add a cup or two more water as you go along, to keep it a consistency that you like.\nChop the kale into small pieces and add to the stew. Cook until everything is mixed and hot through.\nAdd the butter and lime juice and season with salt and pepper.",
      analyzedInstructions: [
        {
          name: "",
          steps: [
            {
              number: 1,
              step: "Warm a few tablespoons of olive oil in a large frying pan over medium heat.",
              ingredients: [
                {
                  id: 4053,
                  name: "olive oil",
                  localizedName: "olive oil",
                  image: "olive-oil.jpg",
                },
              ],
              equipment: [
                {
                  id: 404645,
                  name: "frying pan",
                  localizedName: "frying pan",
                  image: "pan.png",
                },
              ],
            },
            {
              number: 2,
              step: "Add the shallots, garlic, red pepper and basil and cook till the shallots and garlic start to brown.",
              ingredients: [
                {
                  id: 11821,
                  name: "red pepper",
                  localizedName: "red pepper",
                  image: "red-pepper.jpg",
                },
                {
                  id: 11677,
                  name: "shallot",
                  localizedName: "shallot",
                  image: "shallots.jpg",
                },
                {
                  id: 11215,
                  name: "garlic",
                  localizedName: "garlic",
                  image: "garlic.png",
                },
                {
                  id: 2044,
                  name: "basil",
                  localizedName: "basil",
                  image: "basil.jpg",
                },
              ],
              equipment: [],
            },
            {
              number: 3,
              step: "Add the sweet potatoes and cook till they start to brown and soften.",
              ingredients: [
                {
                  id: 11507,
                  name: "sweet potato",
                  localizedName: "sweet potato",
                  image: "sweet-potato.png",
                },
              ],
              equipment: [],
            },
            {
              number: 4,
              step: "Add the beer. Cook till its thick and syrupy.",
              ingredients: [
                {
                  id: 14003,
                  name: "beer",
                  localizedName: "beer",
                  image: "beer.jpg",
                },
              ],
              equipment: [],
            },
            {
              number: 5,
              step: "Add the chickpeas, paprika, cumin, raisins and about 2 cups of water. Bring to a boil and reduce heat and simmer till the sweet potato is nice and soft. You might need to add a cup or two more water as you go along, to keep it a consistency that you like.",
              ingredients: [
                {
                  id: 11507,
                  name: "sweet potato",
                  localizedName: "sweet potato",
                  image: "sweet-potato.png",
                },
                {
                  id: 16057,
                  name: "chickpeas",
                  localizedName: "chickpeas",
                  image: "chickpeas.png",
                },
                {
                  id: 2028,
                  name: "paprika",
                  localizedName: "paprika",
                  image: "paprika.jpg",
                },
                {
                  id: 9299,
                  name: "raisins",
                  localizedName: "raisins",
                  image: "raisins.jpg",
                },
                {
                  id: 1002014,
                  name: "cumin",
                  localizedName: "cumin",
                  image: "ground-cumin.jpg",
                },
                {
                  id: 14412,
                  name: "water",
                  localizedName: "water",
                  image: "water.png",
                },
              ],
              equipment: [],
            },
            {
              number: 6,
              step: "Chop the kale into small pieces and add to the stew. Cook until everything is mixed and hot through.",
              ingredients: [
                {
                  id: 11233,
                  name: "kale",
                  localizedName: "kale",
                  image: "kale.jpg",
                },
                {
                  id: 0,
                  name: "stew",
                  localizedName: "stew",
                  image: "",
                },
              ],
              equipment: [],
            },
            {
              number: 7,
              step: "Add the butter and lime juice and season with salt and pepper.",
              ingredients: [
                {
                  id: 1102047,
                  name: "salt and pepper",
                  localizedName: "salt and pepper",
                  image: "salt-and-pepper.jpg",
                },
                {
                  id: 9160,
                  name: "lime juice",
                  localizedName: "lime juice",
                  image: "lime-juice.png",
                },
                {
                  id: 1001,
                  name: "butter",
                  localizedName: "butter",
                  image: "butter-sliced.jpg",
                },
              ],
              equipment: [],
            },
          ],
        },
      ],
      originalId: null,
      spoonacularSourceUrl:
        "https://spoonacular.com/kale-chickpea-stew-with-cumin-smoked-paprika-and-lime-648709",
    },
  },
  {
    id: 638819,
    value: {
      vegetarian: true,
      vegan: false,
      glutenFree: false,
      dairyFree: true,
      veryHealthy: false,
      cheap: false,
      veryPopular: false,
      sustainable: false,
      weightWatcherSmartPoints: 12,
      gaps: "no",
      lowFodmap: false,
      aggregateLikes: 62,
      spoonacularScore: 48.0,
      healthScore: 5.0,
      creditsText: "Foodista.com – The Cooking Encyclopedia Everyone Can Edit",
      license: "CC BY 3.0",
      sourceName: "Foodista",
      pricePerServing: 85.6,
      extendedIngredients: [
        {
          id: 11011,
          aisle: "Produce",
          image: "asparagus.png",
          consistency: "solid",
          name: "asparagus",
          nameClean: "asparagus",
          original: "2 cups grated fresh asparagus (about 1 pound), drained",
          originalName: "cups grated fresh asparagus (about , drained",
          amount: 1.0,
          unit: "pound",
          meta: ["fresh", "grated", "drained"],
          measures: {
            us: {
              amount: 1.0,
              unitShort: "lb",
              unitLong: "pound",
            },
            metric: {
              amount: 453.592,
              unitShort: "g",
              unitLong: "grams",
            },
          },
        },
        {
          id: 18372,
          aisle: "Baking",
          image: "white-powder.jpg",
          consistency: "solid",
          name: "baking soda",
          nameClean: "baking soda",
          original: "1 teaspoon baking soda",
          originalName: "baking soda",
          amount: 1.0,
          unit: "teaspoon",
          meta: [],
          measures: {
            us: {
              amount: 1.0,
              unitShort: "tsp",
              unitLong: "teaspoon",
            },
            metric: {
              amount: 1.0,
              unitShort: "tsp",
              unitLong: "teaspoon",
            },
          },
        },
        {
          id: 19165,
          aisle: "Baking",
          image: "cocoa-powder.png",
          consistency: "solid",
          name: "cocoa powder",
          nameClean: "cacao powder",
          original: "1/3 cup cocoa powder",
          originalName: "cocoa powder",
          amount: 0.3333333333333333,
          unit: "cup",
          meta: [],
          measures: {
            us: {
              amount: 0.333,
              unitShort: "cups",
              unitLong: "cups",
            },
            metric: {
              amount: 78.863,
              unitShort: "ml",
              unitLong: "milliliters",
            },
          },
        },
        {
          id: 1123,
          aisle: "Milk, Eggs, Other Dairy",
          image: "egg.png",
          consistency: "solid",
          name: "eggs",
          nameClean: "egg",
          original: "3 eggs, beaten",
          originalName: "eggs, beaten",
          amount: 3.0,
          unit: "",
          meta: ["beaten"],
          measures: {
            us: {
              amount: 3.0,
              unitShort: "",
              unitLong: "",
            },
            metric: {
              amount: 3.0,
              unitShort: "",
              unitLong: "",
            },
          },
        },
        {
          id: 20081,
          aisle: "Baking",
          image: "flour.png",
          consistency: "solid",
          name: "flour",
          nameClean: "wheat flour",
          original: "2 cups flour",
          originalName: "flour",
          amount: 2.0,
          unit: "cups",
          meta: [],
          measures: {
            us: {
              amount: 2.0,
              unitShort: "cups",
              unitLong: "cups",
            },
            metric: {
              amount: 473.176,
              unitShort: "ml",
              unitLong: "milliliters",
            },
          },
        },
        {
          id: 1012010,
          aisle: "Spices and Seasonings",
          image: "cinnamon.jpg",
          consistency: "solid",
          name: "ground cinnamon",
          nameClean: "ground cinnamon",
          original: "1 teaspoon ground cinnamon",
          originalName: "ground cinnamon",
          amount: 1.0,
          unit: "teaspoon",
          meta: [],
          measures: {
            us: {
              amount: 1.0,
              unitShort: "tsp",
              unitLong: "teaspoon",
            },
            metric: {
              amount: 1.0,
              unitShort: "tsp",
              unitLong: "teaspoon",
            },
          },
        },
        {
          id: 9216,
          aisle: "Produce",
          image: "orange-zest.png",
          consistency: "solid",
          name: "orange peel",
          nameClean: "orange zest",
          original: "1 to 2 tablespoons grated orange peel",
          originalName: "grated orange peel",
          amount: 1.0,
          unit: "tablespoons",
          meta: ["grated"],
          measures: {
            us: {
              amount: 1.0,
              unitShort: "Tbsp",
              unitLong: "Tbsp",
            },
            metric: {
              amount: 1.0,
              unitShort: "Tbsp",
              unitLong: "Tbsp",
            },
          },
        },
        {
          id: 12142,
          aisle: "Nuts;Baking",
          image: "pecans.jpg",
          consistency: "solid",
          name: "pecans",
          nameClean: "pecans",
          original: "1 cup chopped pecans",
          originalName: "chopped pecans",
          amount: 1.0,
          unit: "cup",
          meta: ["chopped"],
          measures: {
            us: {
              amount: 1.0,
              unitShort: "cup",
              unitLong: "cup",
            },
            metric: {
              amount: 236.588,
              unitShort: "ml",
              unitLong: "milliliters",
            },
          },
        },
        {
          id: 2047,
          aisle: "Spices and Seasonings",
          image: "salt.jpg",
          consistency: "solid",
          name: "salt",
          nameClean: "table salt",
          original: "1/2 teaspoon Salt",
          originalName: "Salt",
          amount: 0.5,
          unit: "teaspoon",
          meta: [],
          measures: {
            us: {
              amount: 0.5,
              unitShort: "tsps",
              unitLong: "teaspoons",
            },
            metric: {
              amount: 0.5,
              unitShort: "tsps",
              unitLong: "teaspoons",
            },
          },
        },
        {
          id: 19335,
          aisle: "Baking",
          image: "sugar-in-bowl.png",
          consistency: "solid",
          name: "sugar",
          nameClean: "sugar",
          original: "3/4 cup sugar",
          originalName: "sugar",
          amount: 0.75,
          unit: "cup",
          meta: [],
          measures: {
            us: {
              amount: 0.75,
              unitShort: "cups",
              unitLong: "cups",
            },
            metric: {
              amount: 177.441,
              unitShort: "ml",
              unitLong: "milliliters",
            },
          },
        },
        {
          id: 2050,
          aisle: "Baking",
          image: "vanilla-extract.jpg",
          consistency: "liquid",
          name: "vanilla extract",
          nameClean: "vanilla extract",
          original: "2 teaspoons vanilla extract",
          originalName: "vanilla extract",
          amount: 2.0,
          unit: "teaspoons",
          meta: [],
          measures: {
            us: {
              amount: 2.0,
              unitShort: "tsps",
              unitLong: "teaspoons",
            },
            metric: {
              amount: 2.0,
              unitShort: "tsps",
              unitLong: "teaspoons",
            },
          },
        },
        {
          id: 4513,
          aisle: null,
          image: null,
          consistency: null,
          name: "vegetable oil",
          nameClean: null,
          original: "1/2 cup vegetable oil",
          originalName: "vegetable oil",
          amount: 0.5,
          unit: "cup",
          meta: [],
          measures: {
            us: {
              amount: 0.5,
              unitShort: "cups",
              unitLong: "cups",
            },
            metric: {
              amount: 118.294,
              unitShort: "ml",
              unitLong: "milliliters",
            },
          },
        },
      ],
      id: 638819,
      title: "Chocolate Asparagus Bundt Cake",
      readyInMinutes: 45,
      servings: 12,
      sourceUrl: "http://www.foodista.com/recipe/T6ZM4BQ6/asparagus-cake",
      image: "https://spoonacular.com/recipeImages/638819-556x370.jpg",
      imageType: "jpg",
      summary:
        'This recipe makes 12 servings with <b>291 calories</b>, <b>6g of protein</b>, and <b>17g of fat</b> each. For <b>86 cents per serving</b>, this recipe <b>covers 10%</b> of your daily requirements of vitamins and minerals. Head to the store and pick up orange peel, eggs, cocoa powder, and a few other things to make it today. 62 people were impressed by this recipe. From preparation to the plate, this recipe takes approximately <b>45 minutes</b>. It is a good option if you\'re following a <b>dairy free and vegetarian</b> diet. All things considered, we decided this recipe <b>deserves a spoonacular score of 50%</b>. This score is good. Similar recipes include <a href="https://spoonacular.com/recipes/confession-109-i-buy-too-much-chocolate-strawberry-bundt-cake-with-white-chocolate-ganache-542461">Confession #109: I Buy Too Much Chocolate… Strawberry Bundt Cake with White Chocolate Ganache</a>, <a href="https://spoonacular.com/recipes/pumpkin-chocolate-chip-bundt-cake-with-chocolate-ganache-520099">Pumpkin Chocolate Chip Bundt Cake with Chocolate Ganache</a>, and <a href="https://spoonacular.com/recipes/chocolate-chip-bundt-cake-optional-chocolate-glaze-106784">Chocolate Chip Bundt Cake (Optional Chocolate Glaze)</a>.',
      cuisines: [],
      dishTypes: ["side dish"],
      diets: ["dairy free", "lacto ovo vegetarian"],
      occasions: [],
      winePairing: {},
      instructions:
        "<ol><li>Preheat oven to 350 F.</li><li>In a large bowl, combine flour, sugar, baking soda, cinnamon, cocoa powder, and salt.</li><li>Add oil, eggs, asparagus, orange peel and vanilla; mix well.</li><li>Fold in pecans.</li><li>Pour into a greased and floured 10-in. bundt pan. Bake for 1 hour or until a toothpick inserted comes out clean. Cool for 10 minutes; remove from pan to a wire rack to cool completely.</li></ol>",
      analyzedInstructions: [
        {
          name: "",
          steps: [
            {
              number: 1,
              step: "Preheat oven to 350 F.In a large bowl, combine flour, sugar, baking soda, cinnamon, cocoa powder, and salt.",
              ingredients: [
                {
                  id: 19165,
                  name: "cocoa powder",
                  localizedName: "cocoa powder",
                  image: "cocoa-powder.png",
                },
                {
                  id: 18372,
                  name: "baking soda",
                  localizedName: "baking soda",
                  image: "white-powder.jpg",
                },
                {
                  id: 2010,
                  name: "cinnamon",
                  localizedName: "cinnamon",
                  image: "cinnamon.jpg",
                },
                {
                  id: 20081,
                  name: "all purpose flour",
                  localizedName: "all purpose flour",
                  image: "flour.png",
                },
                {
                  id: 19335,
                  name: "sugar",
                  localizedName: "sugar",
                  image: "sugar-in-bowl.png",
                },
                {
                  id: 2047,
                  name: "salt",
                  localizedName: "salt",
                  image: "salt.jpg",
                },
              ],
              equipment: [
                {
                  id: 404783,
                  name: "bowl",
                  localizedName: "bowl",
                  image: "bowl.jpg",
                },
                {
                  id: 404784,
                  name: "oven",
                  localizedName: "oven",
                  image: "oven.jpg",
                  temperature: {
                    number: 350.0,
                    unit: "Fahrenheit",
                  },
                },
              ],
            },
            {
              number: 2,
              step: "Add oil, eggs, asparagus, orange peel and vanilla; mix well.Fold in pecans.",
              ingredients: [
                {
                  id: 9216,
                  name: "orange zest",
                  localizedName: "orange zest",
                  image: "orange-zest.png",
                },
                {
                  id: 11011,
                  name: "asparagus",
                  localizedName: "asparagus",
                  image: "asparagus.png",
                },
                {
                  id: 1052050,
                  name: "vanilla",
                  localizedName: "vanilla",
                  image: "vanilla.jpg",
                },
                {
                  id: 12142,
                  name: "pecans",
                  localizedName: "pecans",
                  image: "pecans.jpg",
                },
                {
                  id: 1123,
                  name: "egg",
                  localizedName: "egg",
                  image: "egg.png",
                },
                {
                  id: 4582,
                  name: "cooking oil",
                  localizedName: "cooking oil",
                  image: "vegetable-oil.jpg",
                },
              ],
              equipment: [],
            },
            {
              number: 3,
              step: "Pour into a greased and floured 10-in. bundt pan.",
              ingredients: [],
              equipment: [
                {
                  id: 404748,
                  name: "kugelhopf pan",
                  localizedName: "kugelhopf pan",
                  image: "bundt-cake-pan.jpg",
                },
              ],
            },
            {
              number: 4,
              step: "Bake for 1 hour or until a toothpick inserted comes out clean. Cool for 10 minutes; remove from pan to a wire rack to cool completely.",
              ingredients: [],
              equipment: [
                {
                  id: 404644,
                  name: "toothpicks",
                  localizedName: "toothpicks",
                  image: "toothpicks.jpg",
                },
                {
                  id: 405900,
                  name: "wire rack",
                  localizedName: "wire rack",
                  image: "wire-rack.jpg",
                },
                {
                  id: 404784,
                  name: "oven",
                  localizedName: "oven",
                  image: "oven.jpg",
                },
                {
                  id: 404645,
                  name: "frying pan",
                  localizedName: "frying pan",
                  image: "pan.png",
                },
              ],
              length: {
                number: 70,
                unit: "minutes",
              },
            },
          ],
        },
      ],
      originalId: null,
      spoonacularSourceUrl:
        "https://spoonacular.com/chocolate-asparagus-bundt-cake-638819",
    },
  },
  {
    id: 631823,
    value: {
      vegetarian: true,
      vegan: false,
      glutenFree: false,
      dairyFree: false,
      veryHealthy: false,
      cheap: false,
      veryPopular: false,
      sustainable: false,
      weightWatcherSmartPoints: 12,
      gaps: "no",
      lowFodmap: false,
      aggregateLikes: 15,
      spoonacularScore: 59.0,
      healthScore: 11.0,
      creditsText: "Foodista.com – The Cooking Encyclopedia Everyone Can Edit",
      license: "CC BY 3.0",
      sourceName: "Foodista",
      pricePerServing: 146.33,
      extendedIngredients: [
        {
          id: 93828,
          aisle: "Canned and Jarred",
          image: "artichoke-hearts.png",
          consistency: "solid",
          name: "artichoke hearts",
          nameClean: "marinated artichokes",
          original:
            "(12 oz) jar or can of artichoke hearts drained, coarsely chopped",
          originalName: "or can of artichoke hearts drained, coarsely chopped",
          amount: 12.0,
          unit: "oz",
          meta: ["drained", "coarsely chopped", "canned"],
          measures: {
            us: {
              amount: 12.0,
              unitShort: "oz",
              unitLong: "ounces",
            },
            metric: {
              amount: 340.194,
              unitShort: "g",
              unitLong: "grams",
            },
          },
        },
        {
          id: 6172,
          aisle: "Canned and Jarred",
          image: "chicken-broth.png",
          consistency: "liquid",
          name: "chicken stock",
          nameClean: "chicken stock",
          original: "1/4 c. chicken stock",
          originalName: "chicken stock",
          amount: 0.25,
          unit: "c",
          meta: [],
          measures: {
            us: {
              amount: 0.25,
              unitShort: "cups",
              unitLong: "cups",
            },
            metric: {
              amount: 59.147,
              unitShort: "ml",
              unitLong: "milliliters",
            },
          },
        },
        {
          id: 20081,
          aisle: "Baking",
          image: "flour.png",
          consistency: "solid",
          name: "flour",
          nameClean: "wheat flour",
          original: "1/4 c. all-purpose flour",
          originalName: "all-purpose flour",
          amount: 0.25,
          unit: "c",
          meta: ["all-purpose"],
          measures: {
            us: {
              amount: 0.25,
              unitShort: "cups",
              unitLong: "cups",
            },
            metric: {
              amount: 59.147,
              unitShort: "ml",
              unitLong: "milliliters",
            },
          },
        },
        {
          id: 11463,
          aisle: "Frozen",
          image: "spinach-frozen.jpg",
          consistency: "solid",
          name: "frozen spinach",
          nameClean: "frozen spinach",
          original: "2 (10 oz) boxes frozen spinach, thawed",
          originalName: "boxes frozen spinach, thawed",
          amount: 20.0,
          unit: "oz",
          meta: ["frozen", "thawed"],
          measures: {
            us: {
              amount: 20.0,
              unitShort: "oz",
              unitLong: "ounces",
            },
            metric: {
              amount: 566.99,
              unitShort: "g",
              unitLong: "grams",
            },
          },
        },
        {
          id: 11215,
          aisle: "Produce",
          image: "garlic.png",
          consistency: "solid",
          name: "garlic",
          nameClean: "garlic",
          original: "1 T minced fresh garlic",
          originalName: "minced fresh garlic",
          amount: 1.0,
          unit: "T",
          meta: ["fresh", "minced"],
          measures: {
            us: {
              amount: 1.0,
              unitShort: "Tbsp",
              unitLong: "Tbsp",
            },
            metric: {
              amount: 1.0,
              unitShort: "Tbsp",
              unitLong: "Tbsp",
            },
          },
        },
        {
          id: 1053,
          aisle: "Milk, Eggs, Other Dairy",
          image: "fluid-cream.jpg",
          consistency: "liquid",
          name: "heavy cream",
          nameClean: "cream",
          original: "1 cup - Heavy Cream",
          originalName: "Heavy Cream",
          amount: 1.0,
          unit: "cup",
          meta: [],
          measures: {
            us: {
              amount: 1.0,
              unitShort: "cup",
              unitLong: "cup",
            },
            metric: {
              amount: 236.588,
              unitShort: "ml",
              unitLong: "milliliters",
            },
          },
        },
        {
          id: 6168,
          aisle: "Condiments",
          image: "hot-sauce-or-tabasco.png",
          consistency: "liquid",
          name: "hot sauce",
          nameClean: "hot sauce",
          original: "1/2 t. hot sauce",
          originalName: "hot sauce",
          amount: 0.5,
          unit: "t",
          meta: [],
          measures: {
            us: {
              amount: 0.5,
              unitShort: "tsps",
              unitLong: "teaspoons",
            },
            metric: {
              amount: 0.5,
              unitShort: "tsps",
              unitLong: "teaspoons",
            },
          },
        },
        {
          id: 9152,
          aisle: "Produce",
          image: "lemon-juice.jpg",
          consistency: "liquid",
          name: "lemon juice",
          nameClean: "lemon juice",
          original: "2 t. fresh lemon juice",
          originalName: "fresh lemon juice",
          amount: 2.0,
          unit: "t",
          meta: ["fresh"],
          measures: {
            us: {
              amount: 2.0,
              unitShort: "tsps",
              unitLong: "teaspoons",
            },
            metric: {
              amount: 2.0,
              unitShort: "tsps",
              unitLong: "teaspoons",
            },
          },
        },
        {
          id: 11282,
          aisle: "Produce",
          image: "brown-onion.png",
          consistency: "solid",
          name: "onion",
          nameClean: "onion",
          original: "1/2 onion, chopped",
          originalName: "onion, chopped",
          amount: 0.5,
          unit: "",
          meta: ["chopped"],
          measures: {
            us: {
              amount: 0.5,
              unitShort: "",
              unitLong: "",
            },
            metric: {
              amount: 0.5,
              unitShort: "",
              unitLong: "",
            },
          },
        },
        {
          id: 1038,
          aisle: "Cheese",
          image: "parmesan.jpg",
          consistency: "solid",
          name: "pecorino romano cheese",
          nameClean: "pecorino romano",
          original: "2/3 c. fresh grated Pecorino Romano cheese",
          originalName: "fresh grated Pecorino Romano cheese",
          amount: 0.6666666666666666,
          unit: "c",
          meta: ["fresh", "grated"],
          measures: {
            us: {
              amount: 0.667,
              unitShort: "cups",
              unitLong: "cups",
            },
            metric: {
              amount: 157.725,
              unitShort: "ml",
              unitLong: "milliliters",
            },
          },
        },
        {
          id: 2047,
          aisle: "Spices and Seasonings",
          image: "salt.jpg",
          consistency: "solid",
          name: "salt",
          nameClean: "table salt",
          original: "1/2 teaspoon salt",
          originalName: "salt",
          amount: 0.5,
          unit: "teaspoon",
          meta: [],
          measures: {
            us: {
              amount: 0.5,
              unitShort: "tsps",
              unitLong: "teaspoons",
            },
            metric: {
              amount: 0.5,
              unitShort: "tsps",
              unitLong: "teaspoons",
            },
          },
        },
        {
          id: 1056,
          aisle: "Milk, Eggs, Other Dairy",
          image: "sour-cream.jpg",
          consistency: "solid",
          name: "sour cream",
          nameClean: "sour cream",
          original: "1/4 c. sour cream",
          originalName: "sour cream",
          amount: 0.25,
          unit: "c",
          meta: ["sour"],
          measures: {
            us: {
              amount: 0.25,
              unitShort: "cups",
              unitLong: "cups",
            },
            metric: {
              amount: 59.147,
              unitShort: "ml",
              unitLong: "milliliters",
            },
          },
        },
        {
          id: 1145,
          aisle: "Milk, Eggs, Other Dairy",
          image: "butter-sliced.jpg",
          consistency: "solid",
          name: "unsalted butter",
          nameClean: "unsalted butter",
          original: "6 Tbs. - Unsalted Butter",
          originalName: "Unsalted Butter",
          amount: 6.0,
          unit: "Tbs",
          meta: ["unsalted"],
          measures: {
            us: {
              amount: 6.0,
              unitShort: "Tbs",
              unitLong: "Tbs",
            },
            metric: {
              amount: 6.0,
              unitShort: "Tbs",
              unitLong: "Tbs",
            },
          },
        },
        {
          id: 1011009,
          aisle: "Cheese",
          image: "cheddar-block.jpg",
          consistency: "solid",
          name: "white cheddar cheese",
          nameClean: "white cheddar cheese",
          original: "1/2 c. shredded white cheddar cheese",
          originalName: "shredded white cheddar cheese",
          amount: 0.5,
          unit: "c",
          meta: ["shredded", "white"],
          measures: {
            us: {
              amount: 0.5,
              unitShort: "cups",
              unitLong: "cups",
            },
            metric: {
              amount: 118.294,
              unitShort: "ml",
              unitLong: "milliliters",
            },
          },
        },
      ],
      id: 631823,
      title: "(Houston's) Spinach Dip",
      readyInMinutes: 45,
      servings: 8,
      sourceUrl:
        "http://www.foodista.com/recipe/4C85F47H/houston-s-spinach-dip",
      image: "https://spoonacular.com/recipeImages/631823-556x370.png",
      imageType: "png",
      summary:
        'Need a <b>vegetarian hor d\'oeuvre</b>? (Houston\'s) Spinach Dip could be a tremendous recipe to try. This recipe makes 8 servings with <b>374 calories</b>, <b>11g of protein</b>, and <b>33g of fat</b> each. For <b>$1.59 per serving</b>, this recipe <b>covers 20%</b> of your daily requirements of vitamins and minerals. This recipe from Foodista has 15 fans. It will be a hit at your <b>The Super Bowl</b> event. A mixture of heavy cream, cream, spinach, and a handful of other ingredients are all it takes to make this recipe so flavorful. From preparation to the plate, this recipe takes about <b>45 minutes</b>. All things considered, we decided this recipe <b>deserves a spoonacular score of 64%</b>. This score is solid. Similar recipes include <a href="https://spoonacular.com/recipes/houstons-walnut-apple-cobbler-no-one-makes-food-like-houstons-601381">Houston’s Walnut Apple Cobbler – no one makes food like Houston’s</a>, <a href="https://spoonacular.com/recipes/houstons-artichoke-spinach-dip-600422">Houston’s Artichoke Spinach Dip</a>, and <a href="https://spoonacular.com/recipes/baked-spinach-artichoke-dip-928247">Baked Spinach & Artichoke Dip</a>.',
      cuisines: [],
      dishTypes: ["condiment", "dip", "spread"],
      diets: ["lacto ovo vegetarian"],
      occasions: ["super bowl"],
      winePairing: {},
      instructions:
        "<ol><li>Strain spinach and squeeze through a cheesecloth to remove as much liquid as possible.</li><li>In heavy saucepan over medium heat, saute garlic and onions in butter until golden, about 3-5 minutes. Stir in flour and cook for 1 minute.</li><li>Slowly whisk in cream and stock and continue cooking until boiling.</li><li>Once boiling, stir in lemon juice, hot sauce, salt and Romano cheese; stir until cheese has melted.</li><li>Remove from heat and allow to cool for 5 minutes.</li><li>Stir in sour cream, then fold in dry spinach and artichoke hearts.</li><li>Pour in large ovenproof/microwave proof dish. Or smaller ramekins (as shown.) Sprinkle cheddar evenly on top.</li><li>Heat in microwave or bake in oven until cheese on top is melted.</li><li>Serve hot with tortilla chips, sour cream and salsa for dipping.</li></ol>",
      analyzedInstructions: [
        {
          name: "",
          steps: [
            {
              number: 1,
              step: "Strain spinach and squeeze through a cheesecloth to remove as much liquid as possible.In heavy saucepan over medium heat, saute garlic and onions in butter until golden, about 3-5 minutes. Stir in flour and cook for 1 minute.Slowly whisk in cream and stock and continue cooking until boiling.Once boiling, stir in lemon juice, hot sauce, salt and Romano cheese; stir until cheese has melted.",
              ingredients: [
                {
                  id: 1038,
                  name: "romano cheese",
                  localizedName: "romano cheese",
                  image: "parmesan.jpg",
                },
                {
                  id: 9152,
                  name: "lemon juice",
                  localizedName: "lemon juice",
                  image: "lemon-juice.jpg",
                },
                {
                  id: 6168,
                  name: "hot sauce",
                  localizedName: "hot sauce",
                  image: "hot-sauce-or-tabasco.png",
                },
                {
                  id: 10011457,
                  name: "spinach",
                  localizedName: "spinach",
                  image: "spinach.jpg",
                },
                {
                  id: 1001,
                  name: "butter",
                  localizedName: "butter",
                  image: "butter-sliced.jpg",
                },
                {
                  id: 1041009,
                  name: "cheese",
                  localizedName: "cheese",
                  image: "cheddar-cheese.png",
                },
                {
                  id: 11215,
                  name: "garlic",
                  localizedName: "garlic",
                  image: "garlic.png",
                },
                {
                  id: 11282,
                  name: "onion",
                  localizedName: "onion",
                  image: "brown-onion.png",
                },
                {
                  id: 1053,
                  name: "cream",
                  localizedName: "cream",
                  image: "fluid-cream.jpg",
                },
                {
                  id: 20081,
                  name: "all purpose flour",
                  localizedName: "all purpose flour",
                  image: "flour.png",
                },
                {
                  id: 1006615,
                  name: "stock",
                  localizedName: "stock",
                  image: "chicken-broth.png",
                },
                {
                  id: 2047,
                  name: "salt",
                  localizedName: "salt",
                  image: "salt.jpg",
                },
              ],
              equipment: [
                {
                  id: 404647,
                  name: "cheesecloth",
                  localizedName: "cheesecloth",
                  image: "cheesecloth.jpg",
                },
                {
                  id: 404669,
                  name: "sauce pan",
                  localizedName: "sauce pan",
                  image: "sauce-pan.jpg",
                },
                {
                  id: 404661,
                  name: "whisk",
                  localizedName: "whisk",
                  image: "whisk.png",
                },
              ],
              length: {
                number: 6,
                unit: "minutes",
              },
            },
            {
              number: 2,
              step: "Remove from heat and allow to cool for 5 minutes.Stir in sour cream, then fold in dry spinach and artichoke hearts.",
              ingredients: [
                {
                  id: 99242,
                  name: "artichoke hearts",
                  localizedName: "artichoke hearts",
                  image: "artichoke-hearts.png",
                },
                {
                  id: 1056,
                  name: "sour cream",
                  localizedName: "sour cream",
                  image: "sour-cream.jpg",
                },
                {
                  id: 10011457,
                  name: "spinach",
                  localizedName: "spinach",
                  image: "spinach.jpg",
                },
              ],
              equipment: [],
              length: {
                number: 5,
                unit: "minutes",
              },
            },
            {
              number: 3,
              step: "Pour in large ovenproof/microwave proof dish. Or smaller ramekins (as shown.)",
              ingredients: [],
              equipment: [
                {
                  id: 404762,
                  name: "microwave",
                  localizedName: "microwave",
                  image: "microwave.jpg",
                },
                {
                  id: 404781,
                  name: "ramekin",
                  localizedName: "ramekin",
                  image: "ramekin.jpg",
                },
              ],
            },
            {
              number: 4,
              step: "Sprinkle cheddar evenly on top.",
              ingredients: [
                {
                  id: 1009,
                  name: "cheddar cheese",
                  localizedName: "cheddar cheese",
                  image: "cheddar-cheese.png",
                },
              ],
              equipment: [],
            },
            {
              number: 5,
              step: "Heat in microwave or bake in oven until cheese on top is melted.",
              ingredients: [
                {
                  id: 1041009,
                  name: "cheese",
                  localizedName: "cheese",
                  image: "cheddar-cheese.png",
                },
              ],
              equipment: [
                {
                  id: 404762,
                  name: "microwave",
                  localizedName: "microwave",
                  image: "microwave.jpg",
                },
                {
                  id: 404784,
                  name: "oven",
                  localizedName: "oven",
                  image: "oven.jpg",
                },
              ],
            },
            {
              number: 6,
              step: "Serve hot with tortilla chips, sour cream and salsa for dipping.",
              ingredients: [
                {
                  id: 19056,
                  name: "tortilla chips",
                  localizedName: "tortilla chips",
                  image: "tortilla-chips.jpg",
                },
                {
                  id: 1056,
                  name: "sour cream",
                  localizedName: "sour cream",
                  image: "sour-cream.jpg",
                },
                {
                  id: 6164,
                  name: "salsa",
                  localizedName: "salsa",
                  image: "salsa.png",
                },
              ],
              equipment: [],
            },
          ],
        },
      ],
      originalId: null,
      spoonacularSourceUrl:
        "https://spoonacular.com/houstons-spinach-dip-631823",
    },
  },
  {
    id: 642554,
    value: {
      vegetarian: true,
      vegan: false,
      glutenFree: true,
      dairyFree: false,
      veryHealthy: false,
      cheap: false,
      veryPopular: false,
      sustainable: false,
      weightWatcherSmartPoints: 3,
      gaps: "no",
      lowFodmap: false,
      aggregateLikes: 8,
      spoonacularScore: 11.0,
      healthScore: 0.0,
      creditsText: "Foodista.com – The Cooking Encyclopedia Everyone Can Edit",
      license: "CC BY 3.0",
      sourceName: "Foodista",
      pricePerServing: 68.18,
      extendedIngredients: [
        {
          id: 2048,
          aisle: "Oil, Vinegar, Salad Dressing",
          image: "apple-cider-vinegar.jpg",
          consistency: "liquid",
          name: "apple cider vinegar",
          nameClean: "apple cider vinegar",
          original: "1/4 cup apple cider vinegar",
          originalName: "apple cider vinegar",
          amount: 0.25,
          unit: "cup",
          meta: [],
          measures: {
            us: {
              amount: 0.25,
              unitShort: "cups",
              unitLong: "cups",
            },
            metric: {
              amount: 59.147,
              unitShort: "ml",
              unitLong: "milliliters",
            },
          },
        },
        {
          id: 9016,
          aisle: "Beverages",
          image: "apple-juice.jpg",
          consistency: "liquid",
          name: "apple juice",
          nameClean: "apple juice",
          original: "1/4 cup apple juice",
          originalName: "apple juice",
          amount: 0.25,
          unit: "cup",
          meta: [],
          measures: {
            us: {
              amount: 0.25,
              unitShort: "cups",
              unitLong: "cups",
            },
            metric: {
              amount: 59.147,
              unitShort: "ml",
              unitLong: "milliliters",
            },
          },
        },
        {
          id: 9003,
          aisle: "Produce",
          image: "apple.jpg",
          consistency: "solid",
          name: "apples",
          nameClean: "apple",
          original: "2 Honeycrisp apples, cored and diced",
          originalName: "Honeycrisp apples, cored and diced",
          amount: 2.0,
          unit: "",
          meta: ["diced", "cored"],
          measures: {
            us: {
              amount: 2.0,
              unitShort: "",
              unitLong: "",
            },
            metric: {
              amount: 2.0,
              unitShort: "",
              unitLong: "",
            },
          },
        },
        {
          id: 19334,
          aisle: "Baking",
          image: "dark-brown-sugar.png",
          consistency: "solid",
          name: "brown sugar",
          nameClean: "golden brown sugar",
          original: "¼ cup brown sugar",
          originalName: "brown sugar",
          amount: 0.25,
          unit: "cup",
          meta: [],
          measures: {
            us: {
              amount: 0.25,
              unitShort: "cups",
              unitLong: "cups",
            },
            metric: {
              amount: 59.147,
              unitShort: "ml",
              unitLong: "milliliters",
            },
          },
        },
        {
          id: 1001,
          aisle: "Milk, Eggs, Other Dairy",
          image: "butter-sliced.jpg",
          consistency: "solid",
          name: "butter",
          nameClean: "butter",
          original: "¼ stick butter",
          originalName: "butter",
          amount: 0.25,
          unit: "stick",
          meta: [],
          measures: {
            us: {
              amount: 0.25,
              unitShort: "stick",
              unitLong: "sticks",
            },
            metric: {
              amount: 0.25,
              unitShort: "stick",
              unitLong: "sticks",
            },
          },
        },
        {
          id: 1002010,
          aisle: "Spices and Seasonings",
          image: "cinnamon.jpg",
          consistency: "solid",
          name: "cinnamon stick",
          nameClean: "cinnamon stick",
          original: "1 cinnamon stick",
          originalName: "cinnamon stick",
          amount: 1.0,
          unit: "",
          meta: [],
          measures: {
            us: {
              amount: 1.0,
              unitShort: "",
              unitLong: "",
            },
            metric: {
              amount: 1.0,
              unitShort: "",
              unitLong: "",
            },
          },
        },
        {
          id: 93822,
          aisle: "Dried Fruits;Produce",
          image: "cherries-dried.jpg",
          consistency: "solid",
          name: "dried cherries",
          nameClean: "dried cherries",
          original: "1/2 cup dried cherries, chopped",
          originalName: "dried cherries, chopped",
          amount: 0.5,
          unit: "cup",
          meta: ["dried", "chopped"],
          measures: {
            us: {
              amount: 0.5,
              unitShort: "cups",
              unitLong: "cups",
            },
            metric: {
              amount: 118.294,
              unitShort: "ml",
              unitLong: "milliliters",
            },
          },
        },
        {
          id: 9252,
          aisle: "Produce",
          image: "pears-bosc.jpg",
          consistency: "solid",
          name: "pears",
          nameClean: "pear",
          original: "2 pears, cored and diced",
          originalName: "pears, cored and diced",
          amount: 2.0,
          unit: "",
          meta: ["diced", "cored"],
          measures: {
            us: {
              amount: 2.0,
              unitShort: "",
              unitLong: "",
            },
            metric: {
              amount: 2.0,
              unitShort: "",
              unitLong: "",
            },
          },
        },
      ],
      id: 642554,
      title: "Fall Fruit Compote",
      readyInMinutes: 45,
      servings: 8,
      sourceUrl: "http://www.foodista.com/recipe/WKXKPMZ8/fall-fruit-compote",
      image: "https://spoonacular.com/recipeImages/642554-556x370.jpg",
      imageType: "jpg",
      summary:
        'Fall Fruit Compote might be just the sauce you are searching for. This recipe makes 8 servings with <b>131 calories</b>, <b>1g of protein</b>, and <b>3g of fat</b> each. For <b>68 cents per serving</b>, this recipe <b>covers 2%</b> of your daily requirements of vitamins and minerals. It can be enjoyed any time, but it is especially good for <b>Autumn</b>. If you have apple cider vinegar, cinnamon stick, cherries, and a few other ingredients on hand, you can make it. 7 people have made this recipe and would make it again. It is a good option if you\'re following a <b>gluten free and vegetarian</b> diet. From preparation to the plate, this recipe takes around <b>45 minutes</b>. All things considered, we decided this recipe <b>deserves a spoonacular score of 12%</b>. This score is not so amazing. Try <a href="https://spoonacular.com/recipes/fall-fruit-compote-57602">Fall Fruit Compote</a>, <a href="https://spoonacular.com/recipes/sunday-brunch-fall-fruit-compote-50308">Sunday Brunch: Fall Fruit Compote</a>, and <a href="https://spoonacular.com/recipes/angel-food-cake-with-fall-fruit-compote-59222">Angel Food Cake with Fall Fruit Compote</a> for similar recipes.',
      cuisines: [],
      dishTypes: ["side dish"],
      diets: ["gluten free", "lacto ovo vegetarian"],
      occasions: ["fall"],
      winePairing: {},
      instructions:
        "<ol><li>Melt the butter in a medium saucepan over high heat. Add the diced apples, pears, cherries, vinegar, apple juice, brown sugar, and cinnamon stick. Cook for 5 minutes. Lower the heat to medium and cook a few minutes more, until the fruit is tender and the liquid has boiled away. Add a bit more apple juice to keep the fruit from scorching. The compote will keep for a week, refrigerated. Serve warm with potato latkes.</li></ol>",
      analyzedInstructions: [
        {
          name: "",
          steps: [
            {
              number: 1,
              step: "Melt the butter in a medium saucepan over high heat.",
              ingredients: [
                {
                  id: 1001,
                  name: "butter",
                  localizedName: "butter",
                  image: "butter-sliced.jpg",
                },
              ],
              equipment: [
                {
                  id: 404669,
                  name: "sauce pan",
                  localizedName: "sauce pan",
                  image: "sauce-pan.jpg",
                },
              ],
            },
            {
              number: 2,
              step: "Add the diced apples, pears, cherries, vinegar, apple juice, brown sugar, and cinnamon stick. Cook for 5 minutes. Lower the heat to medium and cook a few minutes more, until the fruit is tender and the liquid has boiled away.",
              ingredients: [
                {
                  id: 1002010,
                  name: "cinnamon stick",
                  localizedName: "cinnamon stick",
                  image: "cinnamon.jpg",
                },
                {
                  id: 9016,
                  name: "apple juice",
                  localizedName: "apple juice",
                  image: "apple-juice.jpg",
                },
                {
                  id: 19334,
                  name: "brown sugar",
                  localizedName: "brown sugar",
                  image: "dark-brown-sugar.png",
                },
                {
                  id: 9070,
                  name: "cherries",
                  localizedName: "cherries",
                  image: "cherries.jpg",
                },
                {
                  id: 2053,
                  name: "vinegar",
                  localizedName: "vinegar",
                  image: "vinegar-(white).jpg",
                },
                {
                  id: 9003,
                  name: "apple",
                  localizedName: "apple",
                  image: "apple.jpg",
                },
                {
                  id: 9431,
                  name: "fruit",
                  localizedName: "fruit",
                  image: "mixed-fresh-fruit.jpg",
                },
                {
                  id: 9252,
                  name: "pear",
                  localizedName: "pear",
                  image: "pears-bosc.jpg",
                },
              ],
              equipment: [],
              length: {
                number: 5,
                unit: "minutes",
              },
            },
            {
              number: 3,
              step: "Add a bit more apple juice to keep the fruit from scorching. The compote will keep for a week, refrigerated.",
              ingredients: [
                {
                  id: 9016,
                  name: "apple juice",
                  localizedName: "apple juice",
                  image: "apple-juice.jpg",
                },
                {
                  id: 0,
                  name: "compote",
                  localizedName: "compote",
                  image: "",
                },
                {
                  id: 9431,
                  name: "fruit",
                  localizedName: "fruit",
                  image: "mixed-fresh-fruit.jpg",
                },
              ],
              equipment: [],
            },
            {
              number: 4,
              step: "Serve warm with potato latkes.",
              ingredients: [
                {
                  id: 11352,
                  name: "potato",
                  localizedName: "potato",
                  image: "potatoes-yukon-gold.png",
                },
              ],
              equipment: [],
            },
          ],
        },
      ],
      originalId: null,
      spoonacularSourceUrl: "https://spoonacular.com/fall-fruit-compote-642554",
    },
  },
  {
    id: 637794,
    value: {
      vegetarian: true,
      vegan: false,
      glutenFree: false,
      dairyFree: false,
      veryHealthy: false,
      cheap: false,
      veryPopular: false,
      sustainable: false,
      weightWatcherSmartPoints: 14,
      gaps: "no",
      lowFodmap: false,
      aggregateLikes: 7,
      spoonacularScore: 22.0,
      healthScore: 2.0,
      creditsText: "Foodista.com – The Cooking Encyclopedia Everyone Can Edit",
      license: "CC BY 3.0",
      sourceName: "Foodista",
      pricePerServing: 120.16,
      extendedIngredients: [
        {
          id: 19912,
          aisle: "Ethnic Foods;Health Foods",
          image: "agave.png",
          consistency: "liquid",
          name: "agave",
          nameClean: "agave",
          original: "3 1/2 tablespoons of agave",
          originalName: "agave",
          amount: 3.5,
          unit: "tablespoons",
          meta: [],
          measures: {
            us: {
              amount: 3.5,
              unitShort: "Tbsps",
              unitLong: "Tbsps",
            },
            metric: {
              amount: 3.5,
              unitShort: "Tbsps",
              unitLong: "Tbsps",
            },
          },
        },
        {
          id: 19912,
          aisle: "Ethnic Foods;Health Foods",
          image: "agave.png",
          consistency: "liquid",
          name: "agave nectar",
          nameClean: "agave",
          original:
            "1/4 cup agave nectar (again, not needed if your fruit is sweet)",
          originalName:
            "agave nectar (again, not needed if your fruit is sweet)",
          amount: 0.25,
          unit: "cup",
          meta: ["sweet", "(again, not needed if your fruit is )"],
          measures: {
            us: {
              amount: 0.25,
              unitShort: "cups",
              unitLong: "cups",
            },
            metric: {
              amount: 59.147,
              unitShort: "ml",
              unitLong: "milliliters",
            },
          },
        },
        {
          id: 93740,
          aisle: "Gluten Free;Health Foods",
          image: "almond-meal-or-almond-flour.jpg",
          consistency: "solid",
          name: "almond flour",
          nameClean: "almond meal",
          original: "1/2 cup almond flour",
          originalName: "almond flour",
          amount: 0.5,
          unit: "cup",
          meta: [],
          measures: {
            us: {
              amount: 0.5,
              unitShort: "cups",
              unitLong: "cups",
            },
            metric: {
              amount: 118.294,
              unitShort: "ml",
              unitLong: "milliliters",
            },
          },
        },
        {
          id: 1009054,
          aisle: "Produce",
          image: "berries-mixed.jpg",
          consistency: "solid",
          name: "berries",
          nameClean: "berries",
          original: "8 ounces frozen package of mixed berries, thawed",
          originalName: "frozen package of mixed berries, thawed",
          amount: 8.0,
          unit: "ounces",
          meta: ["mixed", "frozen", "thawed"],
          measures: {
            us: {
              amount: 8.0,
              unitShort: "oz",
              unitLong: "ounces",
            },
            metric: {
              amount: 226.796,
              unitShort: "g",
              unitLong: "grams",
            },
          },
        },
        {
          id: 1001,
          aisle: "Milk, Eggs, Other Dairy",
          image: "butter-sliced.jpg",
          consistency: "solid",
          name: "butter",
          nameClean: "butter",
          original:
            "2 sticks of very cold butter (I freeze mine), cut into cubes",
          originalName: "very cold butter (I freeze mine), cut into cubes",
          amount: 2.0,
          unit: "sticks",
          meta: ["very cold", "cut into cubes", "(I freeze mine)"],
          measures: {
            us: {
              amount: 2.0,
              unitShort: "sticks",
              unitLong: "sticks",
            },
            metric: {
              amount: 2.0,
              unitShort: "sticks",
              unitLong: "sticks",
            },
          },
        },
        {
          id: 9070,
          aisle: "Produce",
          image: "cherries.jpg",
          consistency: "solid",
          name: "cherries",
          nameClean: "cherries",
          original: "16 ounces frozen packages of cherries, thawed",
          originalName: "frozen packages of cherries, thawed",
          amount: 16.0,
          unit: "ounces",
          meta: ["frozen", "thawed"],
          measures: {
            us: {
              amount: 16.0,
              unitShort: "oz",
              unitLong: "ounces",
            },
            metric: {
              amount: 453.592,
              unitShort: "g",
              unitLong: "grams",
            },
          },
        },
        {
          id: 93747,
          aisle: "Gluten Free;Health Foods;Baking",
          image: "coconut-flour-or-other-gluten-free-flour.jpg",
          consistency: "solid",
          name: "coconut flour",
          nameClean: "coconut flour",
          original: "1/4 cup coconut flour, sifted",
          originalName: "coconut flour, sifted",
          amount: 0.25,
          unit: "cup",
          meta: ["sifted"],
          measures: {
            us: {
              amount: 0.25,
              unitShort: "cups",
              unitLong: "cups",
            },
            metric: {
              amount: 59.147,
              unitShort: "ml",
              unitLong: "milliliters",
            },
          },
        },
        {
          id: 20081,
          aisle: "Baking",
          image: "flour.png",
          consistency: "solid",
          name: "flour",
          nameClean: "wheat flour",
          original: "1 cup all-purpose flour",
          originalName: "all-purpose flour",
          amount: 1.0,
          unit: "cup",
          meta: ["all-purpose"],
          measures: {
            us: {
              amount: 1.0,
              unitShort: "cup",
              unitLong: "cup",
            },
            metric: {
              amount: 236.588,
              unitShort: "ml",
              unitLong: "milliliters",
            },
          },
        },
        {
          id: 9152,
          aisle: "Produce",
          image: "lemon-juice.jpg",
          consistency: "liquid",
          name: "lemon juice",
          nameClean: "lemon juice",
          original: "3 tablespoons freshly squeezed lemon juice",
          originalName: "freshly squeezed lemon juice",
          amount: 3.0,
          unit: "tablespoons",
          meta: ["freshly squeezed"],
          measures: {
            us: {
              amount: 3.0,
              unitShort: "Tbsps",
              unitLong: "Tbsps",
            },
            metric: {
              amount: 3.0,
              unitShort: "Tbsps",
              unitLong: "Tbsps",
            },
          },
        },
        {
          id: 12511111,
          aisle: "Baking",
          image: "extract.png",
          consistency: "liquid",
          name: "orange extract",
          nameClean: "orange extract",
          original: "1/2 teaspoon fiore di Sicilia or orange extract",
          originalName: "fiore di Sicilia or orange extract",
          amount: 0.5,
          unit: "teaspoon",
          meta: [],
          measures: {
            us: {
              amount: 0.5,
              unitShort: "tsps",
              unitLong: "teaspoons",
            },
            metric: {
              amount: 0.5,
              unitShort: "tsps",
              unitLong: "teaspoons",
            },
          },
        },
        {
          id: 93696,
          aisle: "Ethnic Foods;Health Foods;Baking",
          image: "white-powder.jpg",
          consistency: "solid",
          name: "tapioca flour",
          nameClean: "tapioca starch",
          original: "3 tablespoons tapioca flour (or corn starch or arrowroot)",
          originalName: "tapioca flour (or corn starch or arrowroot)",
          amount: 3.0,
          unit: "tablespoons",
          meta: ["(or corn starch or arrowroot)"],
          measures: {
            us: {
              amount: 3.0,
              unitShort: "Tbsps",
              unitLong: "Tbsps",
            },
            metric: {
              amount: 3.0,
              unitShort: "Tbsps",
              unitLong: "Tbsps",
            },
          },
        },
        {
          id: 10020080,
          aisle: "Baking",
          image: "flour.png",
          consistency: "solid",
          name: "whole wheat pastry flour",
          nameClean: "whole wheat pastry flour",
          original: "3/4 cup whole wheat pastry flour",
          originalName: "whole wheat pastry flour",
          amount: 0.75,
          unit: "cup",
          meta: ["whole wheat"],
          measures: {
            us: {
              amount: 0.75,
              unitShort: "cups",
              unitLong: "cups",
            },
            metric: {
              amount: 177.441,
              unitShort: "ml",
              unitLong: "milliliters",
            },
          },
        },
      ],
      id: 637794,
      title: "Cherry-Berry Pie With Agave Nectar All-Butter Crust",
      readyInMinutes: 180,
      servings: 10,
      sourceUrl:
        "http://www.foodista.com/recipe/KPLBL8TL/cherry-berry-pie-with-agave-nectar-all-butter-crust",
      image: "https://spoonacular.com/recipeImages/637794-556x370.jpg",
      imageType: "jpg",
      summary:
        'Need a <b>vegetarian dessert</b>? Cherry-Berry Pie With Agave Nectar All-Butter Crust could be an excellent recipe to try. One serving contains <b>371 calories</b>, <b>5g of protein</b>, and <b>22g of fat</b>. This recipe serves 10 and costs $1.2 per serving. 7 people have made this recipe and would make it again. A mixture of pastry flour, lemon juice, flour, and a handful of other ingredients are all it takes to make this recipe so yummy. From preparation to the plate, this recipe takes approximately <b>3 hours</b>. All things considered, we decided this recipe <b>deserves a spoonacular score of 23%</b>. This score is not so awesome. Try <a href="https://spoonacular.com/recipes/homemade-agave-nectar-ketchup-82572">Homemade Agave Nectar Ketchup</a>, <a href="https://spoonacular.com/recipes/seeded-agave-nectar-mustard-16866">Seeded Agave Nectar Mustard</a>, and <a href="https://spoonacular.com/recipes/blended-agave-nectar-margarita-145746">Blended Agave Nectar Margarita</a> for similar recipes.',
      cuisines: [],
      dishTypes: ["side dish"],
      diets: ["lacto ovo vegetarian"],
      occasions: [],
      winePairing: {},
      instructions:
        "<ol><li>Make the crust:</li><li>Pulse the dry ingredients 5-6 times.</li><li>Add 2 sticks of very cold butter (I freeze mine), cut into cubes. Pulse until the ingredients resemble very coarse meal.</li><li>Adding the agave nectar and fiore di Sicilia flavoring (can substitute orange extract) one tablespoon at a time.</li><li>Watch to see the dough just comes together.</li><li>Divide the dough into two parts, one larger than the other.</li><li>Form each into a flat, round shape.</li><li>Wrap each disk in plastic and refrigerate for at least 2 hours.</li><li>While the dough is chilling, make the filling.</li><li>In a large bowl, combine all the filling ingredients.</li><li>Mix until well incorporated (it will be very soupy).</li><li>Take the dough out of the fridge.</li><li>Let it warm enough to be able to roll it out.</li><li>Roll out the crust to fit it to your pie dish.</li><li>You may need to patch some, but none will show to your eaters.</li><li>Wrap the pie dish in plastic and chill for 30 minutes.</li><li>Pour the filling into the crust.</li><li>Again, wrap the pie in plastic and chill.</li><li>Roll out the other dough disk.</li><li>Use your favorite cookie cutters to cut pieces for the top crust.</li><li>Take the pie out of the fridge and decorate the top.</li><li>Just remember to leave spots for steam to escape.</li><li>Cover the edges with foil and bake at 325 degrees F for 40 minutes.</li><li>Remove foil and bake until golden brown top and the filling is bubbling.</li><li>Let cool and enjoy!</li></ol>",
      analyzedInstructions: [
        {
          name: "",
          steps: [
            {
              number: 1,
              step: "Make the crust:Pulse the dry ingredients 5-6 times.",
              ingredients: [
                {
                  id: 0,
                  name: "crust",
                  localizedName: "crust",
                  image: "",
                },
              ],
              equipment: [],
            },
            {
              number: 2,
              step: "Add 2 sticks of very cold butter (I freeze mine), cut into cubes. Pulse until the ingredients resemble very coarse meal.",
              ingredients: [
                {
                  id: 1001,
                  name: "butter",
                  localizedName: "butter",
                  image: "butter-sliced.jpg",
                },
              ],
              equipment: [],
            },
            {
              number: 3,
              step: "Adding the agave nectar and fiore di Sicilia flavoring (can substitute orange extract) one tablespoon at a time.Watch to see the dough just comes together.Divide the dough into two parts, one larger than the other.Form each into a flat, round shape.Wrap each disk in plastic and refrigerate for at least 2 hours.While the dough is chilling, make the filling.In a large bowl, combine all the filling ingredients.",
              ingredients: [
                {
                  id: 12511111,
                  name: "orange extract",
                  localizedName: "orange extract",
                  image: "extract.png",
                },
                {
                  id: 19912,
                  name: "agave",
                  localizedName: "agave",
                  image: "agave.png",
                },
                {
                  id: 0,
                  name: "dough",
                  localizedName: "dough",
                  image: "pizza-dough",
                },
                {
                  id: 10018364,
                  name: "wrap",
                  localizedName: "wrap",
                  image: "flour-tortilla.jpg",
                },
              ],
              equipment: [
                {
                  id: 404783,
                  name: "bowl",
                  localizedName: "bowl",
                  image: "bowl.jpg",
                },
              ],
              length: {
                number: 120,
                unit: "minutes",
              },
            },
            {
              number: 4,
              step: "Mix until well incorporated (it will be very soupy).Take the dough out of the fridge.",
              ingredients: [
                {
                  id: 0,
                  name: "dough",
                  localizedName: "dough",
                  image: "pizza-dough",
                },
              ],
              equipment: [],
            },
            {
              number: 5,
              step: "Let it warm enough to be able to roll it out.",
              ingredients: [
                {
                  id: 0,
                  name: "roll",
                  localizedName: "roll",
                  image: "dinner-yeast-rolls.jpg",
                },
              ],
              equipment: [],
            },
            {
              number: 6,
              step: "Roll out the crust to fit it to your pie dish.You may need to patch some, but none will show to your eaters.Wrap the pie dish in plastic and chill for 30 minutes.",
              ingredients: [
                {
                  id: 0,
                  name: "crust",
                  localizedName: "crust",
                  image: "",
                },
                {
                  id: 0,
                  name: "roll",
                  localizedName: "roll",
                  image: "dinner-yeast-rolls.jpg",
                },
                {
                  id: 10018364,
                  name: "wrap",
                  localizedName: "wrap",
                  image: "flour-tortilla.jpg",
                },
              ],
              equipment: [
                {
                  id: 405915,
                  name: "pie form",
                  localizedName: "pie form",
                  image: "pie-pan.png",
                },
              ],
              length: {
                number: 30,
                unit: "minutes",
              },
            },
            {
              number: 7,
              step: "Pour the filling into the crust.Again, wrap the pie in plastic and chill.",
              ingredients: [
                {
                  id: 0,
                  name: "crust",
                  localizedName: "crust",
                  image: "",
                },
                {
                  id: 10018364,
                  name: "wrap",
                  localizedName: "wrap",
                  image: "flour-tortilla.jpg",
                },
              ],
              equipment: [],
            },
            {
              number: 8,
              step: "Roll out the other dough disk.Use your favorite cookie cutters to cut pieces for the top crust.Take the pie out of the fridge and decorate the top.Just remember to leave spots for steam to escape.Cover the edges with foil and bake at 325 degrees F for 40 minutes.",
              ingredients: [
                {
                  id: 10118192,
                  name: "cookies",
                  localizedName: "cookies",
                  image: "shortbread-cookies.jpg",
                },
                {
                  id: 0,
                  name: "crust",
                  localizedName: "crust",
                  image: "",
                },
                {
                  id: 0,
                  name: "dough",
                  localizedName: "dough",
                  image: "pizza-dough",
                },
                {
                  id: 0,
                  name: "roll",
                  localizedName: "roll",
                  image: "dinner-yeast-rolls.jpg",
                },
              ],
              equipment: [
                {
                  id: 221429,
                  name: "cookie cutter",
                  localizedName: "cookie cutter",
                  image: "cookie-cutters.jpg",
                },
                {
                  id: 404784,
                  name: "oven",
                  localizedName: "oven",
                  image: "oven.jpg",
                  temperature: {
                    number: 325.0,
                    unit: "Fahrenheit",
                  },
                },
                {
                  id: 404765,
                  name: "aluminum foil",
                  localizedName: "aluminum foil",
                  image: "aluminum-foil.png",
                },
              ],
              length: {
                number: 40,
                unit: "minutes",
              },
            },
            {
              number: 9,
              step: "Remove foil and bake until golden brown top and the filling is bubbling.",
              ingredients: [],
              equipment: [
                {
                  id: 404784,
                  name: "oven",
                  localizedName: "oven",
                  image: "oven.jpg",
                },
                {
                  id: 404765,
                  name: "aluminum foil",
                  localizedName: "aluminum foil",
                  image: "aluminum-foil.png",
                },
              ],
            },
            {
              number: 10,
              step: "Let cool and enjoy!",
              ingredients: [],
              equipment: [],
            },
          ],
        },
      ],
      originalId: null,
      spoonacularSourceUrl:
        "https://spoonacular.com/cherry-berry-pie-with-agave-nectar-all-butter-crust-637794",
    },
  },
  {
    id: 662515,
    value: {
      vegetarian: true,
      vegan: false,
      glutenFree: false,
      dairyFree: false,
      veryHealthy: false,
      cheap: false,
      veryPopular: false,
      sustainable: false,
      weightWatcherSmartPoints: 16,
      gaps: "no",
      lowFodmap: false,
      aggregateLikes: 6,
      spoonacularScore: 21.0,
      healthScore: 1.0,
      creditsText: "Foodista.com – The Cooking Encyclopedia Everyone Can Edit",
      license: "CC BY 3.0",
      sourceName: "Foodista",
      pricePerServing: 45.81,
      extendedIngredients: [
        {
          id: 20081,
          aisle: "Baking",
          image: "flour.png",
          consistency: "solid",
          name: "flour",
          nameClean: "wheat flour",
          original: "3 cups all-purpose flour",
          originalName: "all-purpose flour",
          amount: 3.0,
          unit: "cups",
          meta: ["all-purpose"],
          measures: {
            us: {
              amount: 3.0,
              unitShort: "cups",
              unitLong: "cups",
            },
            metric: {
              amount: 709.764,
              unitShort: "ml",
              unitLong: "milliliters",
            },
          },
        },
        {
          id: 18371,
          aisle: "Baking",
          image: "white-powder.jpg",
          consistency: "solid",
          name: "baking powder",
          nameClean: "low sodium baking powder",
          original: "1/2 teaspoon baking powder",
          originalName: "baking powder",
          amount: 0.5,
          unit: "teaspoon",
          meta: [],
          measures: {
            us: {
              amount: 0.5,
              unitShort: "tsps",
              unitLong: "teaspoons",
            },
            metric: {
              amount: 0.5,
              unitShort: "tsps",
              unitLong: "teaspoons",
            },
          },
        },
        {
          id: 18372,
          aisle: "Baking",
          image: "white-powder.jpg",
          consistency: "solid",
          name: "baking soda",
          nameClean: "baking soda",
          original: "1/2 teaspoon baking soda",
          originalName: "baking soda",
          amount: 0.5,
          unit: "teaspoon",
          meta: [],
          measures: {
            us: {
              amount: 0.5,
              unitShort: "tsps",
              unitLong: "teaspoons",
            },
            metric: {
              amount: 0.5,
              unitShort: "tsps",
              unitLong: "teaspoons",
            },
          },
        },
        {
          id: 2047,
          aisle: "Spices and Seasonings",
          image: "salt.jpg",
          consistency: "solid",
          name: "salt",
          nameClean: "table salt",
          original: "1/2 teaspoon salt",
          originalName: "salt",
          amount: 0.5,
          unit: "teaspoon",
          meta: [],
          measures: {
            us: {
              amount: 0.5,
              unitShort: "tsps",
              unitLong: "teaspoons",
            },
            metric: {
              amount: 0.5,
              unitShort: "tsps",
              unitLong: "teaspoons",
            },
          },
        },
        {
          id: 1230,
          aisle: "Milk, Eggs, Other Dairy",
          image: "buttermilk.jpg",
          consistency: "solid",
          name: "buttermilk",
          nameClean: "buttermilk",
          original: "3/4 cup buttermilk, at room temperature",
          originalName: "buttermilk, at room temperature",
          amount: 0.75,
          unit: "cup",
          meta: ["at room temperature"],
          measures: {
            us: {
              amount: 0.75,
              unitShort: "cups",
              unitLong: "cups",
            },
            metric: {
              amount: 177.441,
              unitShort: "ml",
              unitLong: "milliliters",
            },
          },
        },
        {
          id: 9206,
          aisle: "Beverages",
          image: "orange-juice.jpg",
          consistency: "liquid",
          name: "orange juice",
          nameClean: "orange juice",
          original: "1/2 cup freshly squeezed orange juice",
          originalName: "freshly squeezed orange juice",
          amount: 0.5,
          unit: "cup",
          meta: ["freshly squeezed"],
          measures: {
            us: {
              amount: 0.5,
              unitShort: "cups",
              unitLong: "cups",
            },
            metric: {
              amount: 118.294,
              unitShort: "ml",
              unitLong: "milliliters",
            },
          },
        },
        {
          id: 2050,
          aisle: "Baking",
          image: "vanilla-extract.jpg",
          consistency: "liquid",
          name: "vanilla extract",
          nameClean: "vanilla extract",
          original: "2 teaspoons pure vanilla extract",
          originalName: "pure vanilla extract",
          amount: 2.0,
          unit: "teaspoons",
          meta: ["pure"],
          measures: {
            us: {
              amount: 2.0,
              unitShort: "tsps",
              unitLong: "teaspoons",
            },
            metric: {
              amount: 2.0,
              unitShort: "tsps",
              unitLong: "teaspoons",
            },
          },
        },
        {
          id: 1145,
          aisle: "Milk, Eggs, Other Dairy",
          image: "butter-sliced.jpg",
          consistency: "solid",
          name: "unsalted butter",
          nameClean: "unsalted butter",
          original: "1/2 pound (2 sticks) unsalted butter",
          originalName: "(2 sticks) unsalted butter",
          amount: 0.5,
          unit: "pound",
          meta: ["unsalted", "(2 sticks)"],
          measures: {
            us: {
              amount: 0.5,
              unitShort: "lb",
              unitLong: "pounds",
            },
            metric: {
              amount: 226.796,
              unitShort: "g",
              unitLong: "grams",
            },
          },
        },
        {
          id: 19335,
          aisle: "Baking",
          image: "sugar-in-bowl.png",
          consistency: "solid",
          name: "sugar",
          nameClean: "sugar",
          original: "2 cups sugar",
          originalName: "sugar",
          amount: 2.0,
          unit: "cups",
          meta: [],
          measures: {
            us: {
              amount: 2.0,
              unitShort: "cups",
              unitLong: "cups",
            },
            metric: {
              amount: 473.176,
              unitShort: "ml",
              unitLong: "milliliters",
            },
          },
        },
        {
          id: 1123,
          aisle: "Milk, Eggs, Other Dairy",
          image: "egg.png",
          consistency: "solid",
          name: "eggs",
          nameClean: "egg",
          original: "4 eggs, at room temperature",
          originalName: "eggs, at room temperature",
          amount: 4.0,
          unit: "",
          meta: ["at room temperature"],
          measures: {
            us: {
              amount: 4.0,
              unitShort: "",
              unitLong: "",
            },
            metric: {
              amount: 4.0,
              unitShort: "",
              unitLong: "",
            },
          },
        },
        {
          id: 9216,
          aisle: "Produce",
          image: "orange-zest.png",
          consistency: "solid",
          name: "orange zest",
          nameClean: "orange zest",
          original: "1/4 cup orange zest",
          originalName: "orange zest",
          amount: 0.25,
          unit: "cup",
          meta: [],
          measures: {
            us: {
              amount: 0.25,
              unitShort: "cups",
              unitLong: "cups",
            },
            metric: {
              amount: 59.147,
              unitShort: "ml",
              unitLong: "milliliters",
            },
          },
        },
        {
          id: 19334,
          aisle: "Baking",
          image: "dark-brown-sugar.png",
          consistency: "solid",
          name: "brown sugar",
          nameClean: "golden brown sugar",
          original: "1/2 cup brown sugar",
          originalName: "brown sugar",
          amount: 0.5,
          unit: "cup",
          meta: [],
          measures: {
            us: {
              amount: 0.5,
              unitShort: "cups",
              unitLong: "cups",
            },
            metric: {
              amount: 118.294,
              unitShort: "ml",
              unitLong: "milliliters",
            },
          },
        },
        {
          id: 9200,
          aisle: "Produce",
          image: "orange.png",
          consistency: "solid",
          name: "oranges",
          nameClean: "orange",
          original: "Note: I used 4 whole small oranges for this recipe.",
          originalName: "Note: I used 4 whole oranges for this recipe",
          amount: 1.0,
          unit: "small",
          meta: ["whole", "for this recipe."],
          measures: {
            us: {
              amount: 1.0,
              unitShort: "small",
              unitLong: "small",
            },
            metric: {
              amount: 1.0,
              unitShort: "small",
              unitLong: "small",
            },
          },
        },
      ],
      id: 662515,
      title: "Sweet Florida Orange Breakfast Bread",
      readyInMinutes: 45,
      servings: 16,
      sourceUrl:
        "https://www.foodista.com/recipe/26QJRFWL/sweet-florida-orange-breakfast-bread",
      image: "https://spoonacular.com/recipeImages/662515-556x370.jpg",
      imageType: "jpg",
      summary:
        'Sweet Floridan Orange Breakfast Bread requires roughly <b>roughly 45 minutes</b> from start to finish. This recipe makes 16 servings with <b>345 calories</b>, <b>4g of protein</b>, and <b>13g of fat</b> each. For <b>46 cents per serving</b>, this recipe <b>covers 6%</b> of your daily requirements of vitamins and minerals. 6 people found this recipe to be yummy and satisfying. A mixture of butter, orange juice, vanillan extract, and a handful of other ingredients are all it takes to make this recipe so scrumptious. It is a good option if you\'re following a <b>lacto ovo vegetarian</b> diet. It is brought to you by Foodista. Only a few people really liked this breakfast. Overall, this recipe earns a <b>not so super spoonacular score of 16%</b>. If you like this recipe, take a look at these similar recipes: <a href="https://spoonacular.com/recipes/crispy-pan-seared-florida-snapper-with-passion-fruit-cream-and-florida-citrus-and-shaved-fennel-salad-garnished-with-sauteed-florida-gulf-shrimp-and-spicy-green-mango-jam-740791">Crispy Pan Seared Florida Snapper with Passion Fruit Cream and Florida Citrus and Shaved Fennel Salad, Garnished with Sauteed Florida Gulf Shrimp and Spicy Green Mango Jam</a>, <a href="https://spoonacular.com/recipes/florida-orange-cake-401320">Floridan Orange Cake</a>, and <a href="https://spoonacular.com/recipes/orange-rhubarb-breakfast-bread-430770">Orange-Rhubarb Breakfast Bread</a>.',
      cuisines: [],
      dishTypes: ["morning meal", "brunch", "breakfast"],
      diets: ["lacto ovo vegetarian"],
      occasions: [],
      winePairing: {},
      instructions:
        "Preheat oven to 350F.\nGrease and lightly flour loaf pans.\nIn a medium bowl, whisk together flour, baking powder, baking soda, and salt. Set aside.\nMeasure buttermilk, orange juice, and vanilla into a measuring cup. Set aside.\nIn a large bowl, use a mixer to beat the butter until creamy.\nBlend in sugar and beat for a few minutes until light and fluffy.\nMix in eggs, one at a time, and orange zest, and beat until well incorporated.\nWith mixer on low, slowly pour in 1/3 of the flour mixture.\nMix in half of the buttermilk mixture.\nBlend in another 1/3 of the flour mixture and remaining buttermilk mixture.\nAdd remaining flour mixture and mix until just blended.\nDivide batter between prepared pans, filling about 3/4 full, and bake for 30 to 35 minutes (45 minutes if using a large loaf pan) or until a toothpick inserted in center comes out clean.\nWhile loaves bake, prepare orange simple syrup.\nStir together 1/2 cup orange juice and 1/2 cup brown sugar in a small pot. Bring to a boil over medium heat while occasionally stirring, then reduce heat and simmer for a few minutes. Remove pot from heat and set aside to cool.\nWhen cakes are done, cool for 10 minutes before turning out onto wire rack. Set rack over a sheet pan or piece of foil, and using a brush or a spoon, soak each cake with simple syrup. Allow to cool completely.\nStore in an airtight container or wrap tightly.",
      analyzedInstructions: [
        {
          name: "",
          steps: [
            {
              number: 1,
              step: "Preheat oven to 350F.",
              ingredients: [],
              equipment: [
                {
                  id: 404784,
                  name: "oven",
                  localizedName: "oven",
                  image: "oven.jpg",
                  temperature: {
                    number: 350.0,
                    unit: "Fahrenheit",
                  },
                },
              ],
            },
            {
              number: 2,
              step: "Grease and lightly flour loaf pans.",
              ingredients: [
                {
                  id: 20081,
                  name: "all purpose flour",
                  localizedName: "all purpose flour",
                  image: "flour.png",
                },
              ],
              equipment: [
                {
                  id: 404715,
                  name: "loaf pan",
                  localizedName: "loaf pan",
                  image: "loaf-pan.png",
                },
              ],
            },
            {
              number: 3,
              step: "In a medium bowl, whisk together flour, baking powder, baking soda, and salt. Set aside.",
              ingredients: [
                {
                  id: 18369,
                  name: "baking powder",
                  localizedName: "baking powder",
                  image: "white-powder.jpg",
                },
                {
                  id: 18372,
                  name: "baking soda",
                  localizedName: "baking soda",
                  image: "white-powder.jpg",
                },
                {
                  id: 20081,
                  name: "all purpose flour",
                  localizedName: "all purpose flour",
                  image: "flour.png",
                },
                {
                  id: 2047,
                  name: "salt",
                  localizedName: "salt",
                  image: "salt.jpg",
                },
              ],
              equipment: [
                {
                  id: 404661,
                  name: "whisk",
                  localizedName: "whisk",
                  image: "whisk.png",
                },
                {
                  id: 404783,
                  name: "bowl",
                  localizedName: "bowl",
                  image: "bowl.jpg",
                },
              ],
            },
            {
              number: 4,
              step: "Measure buttermilk, orange juice, and vanilla into a measuring cup. Set aside.",
              ingredients: [
                {
                  id: 9206,
                  name: "orange juice",
                  localizedName: "orange juice",
                  image: "orange-juice.jpg",
                },
                {
                  id: 1230,
                  name: "buttermilk",
                  localizedName: "buttermilk",
                  image: "buttermilk.jpg",
                },
                {
                  id: 1052050,
                  name: "vanilla",
                  localizedName: "vanilla",
                  image: "vanilla.jpg",
                },
              ],
              equipment: [
                {
                  id: 404766,
                  name: "measuring cup",
                  localizedName: "measuring cup",
                  image: "measuring-cup.jpg",
                },
              ],
            },
            {
              number: 5,
              step: "In a large bowl, use a mixer to beat the butter until creamy.",
              ingredients: [
                {
                  id: 1001,
                  name: "butter",
                  localizedName: "butter",
                  image: "butter-sliced.jpg",
                },
              ],
              equipment: [
                {
                  id: 404726,
                  name: "blender",
                  localizedName: "blender",
                  image: "blender.png",
                },
                {
                  id: 404783,
                  name: "bowl",
                  localizedName: "bowl",
                  image: "bowl.jpg",
                },
              ],
            },
            {
              number: 6,
              step: "Blend in sugar and beat for a few minutes until light and fluffy.",
              ingredients: [
                {
                  id: 19335,
                  name: "sugar",
                  localizedName: "sugar",
                  image: "sugar-in-bowl.png",
                },
              ],
              equipment: [],
            },
            {
              number: 7,
              step: "Mix in eggs, one at a time, and orange zest, and beat until well incorporated.",
              ingredients: [
                {
                  id: 9216,
                  name: "orange zest",
                  localizedName: "orange zest",
                  image: "orange-zest.png",
                },
                {
                  id: 1123,
                  name: "egg",
                  localizedName: "egg",
                  image: "egg.png",
                },
              ],
              equipment: [],
            },
            {
              number: 8,
              step: "With mixer on low, slowly pour in 1/3 of the flour mixture.",
              ingredients: [
                {
                  id: 20081,
                  name: "all purpose flour",
                  localizedName: "all purpose flour",
                  image: "flour.png",
                },
              ],
              equipment: [
                {
                  id: 404726,
                  name: "blender",
                  localizedName: "blender",
                  image: "blender.png",
                },
              ],
            },
            {
              number: 9,
              step: "Mix in half of the buttermilk mixture.",
              ingredients: [
                {
                  id: 1230,
                  name: "buttermilk",
                  localizedName: "buttermilk",
                  image: "buttermilk.jpg",
                },
              ],
              equipment: [],
            },
            {
              number: 10,
              step: "Blend in another 1/3 of the flour mixture and remaining buttermilk mixture.",
              ingredients: [
                {
                  id: 1230,
                  name: "buttermilk",
                  localizedName: "buttermilk",
                  image: "buttermilk.jpg",
                },
                {
                  id: 20081,
                  name: "all purpose flour",
                  localizedName: "all purpose flour",
                  image: "flour.png",
                },
              ],
              equipment: [],
            },
            {
              number: 11,
              step: "Add remaining flour mixture and mix until just blended.",
              ingredients: [
                {
                  id: 20081,
                  name: "all purpose flour",
                  localizedName: "all purpose flour",
                  image: "flour.png",
                },
              ],
              equipment: [],
            },
            {
              number: 12,
              step: "Divide batter between prepared pans, filling about 3/4 full, and bake for 30 to 35 minutes (45 minutes if using a large loaf pan) or until a toothpick inserted in center comes out clean.",
              ingredients: [],
              equipment: [
                {
                  id: 404644,
                  name: "toothpicks",
                  localizedName: "toothpicks",
                  image: "toothpicks.jpg",
                },
                {
                  id: 404784,
                  name: "oven",
                  localizedName: "oven",
                  image: "oven.jpg",
                },
                {
                  id: 404715,
                  name: "loaf pan",
                  localizedName: "loaf pan",
                  image: "loaf-pan.png",
                },
              ],
              length: {
                number: 75,
                unit: "minutes",
              },
            },
            {
              number: 13,
              step: "While loaves bake, prepare orange simple syrup.",
              ingredients: [
                {
                  id: 90480,
                  name: "simple syrup",
                  localizedName: "simple syrup",
                  image: "simple-syrup.jpg",
                },
                {
                  id: 9200,
                  name: "orange",
                  localizedName: "orange",
                  image: "orange.png",
                },
              ],
              equipment: [
                {
                  id: 404784,
                  name: "oven",
                  localizedName: "oven",
                  image: "oven.jpg",
                },
              ],
            },
            {
              number: 14,
              step: "Stir together 1/2 cup orange juice and 1/2 cup brown sugar in a small pot. Bring to a boil over medium heat while occasionally stirring, then reduce heat and simmer for a few minutes.",
              ingredients: [
                {
                  id: 9206,
                  name: "orange juice",
                  localizedName: "orange juice",
                  image: "orange-juice.jpg",
                },
                {
                  id: 19334,
                  name: "brown sugar",
                  localizedName: "brown sugar",
                  image: "dark-brown-sugar.png",
                },
              ],
              equipment: [
                {
                  id: 404752,
                  name: "pot",
                  localizedName: "pot",
                  image: "stock-pot.jpg",
                },
              ],
            },
            {
              number: 15,
              step: "Remove pot from heat and set aside to cool.",
              ingredients: [],
              equipment: [
                {
                  id: 404752,
                  name: "pot",
                  localizedName: "pot",
                  image: "stock-pot.jpg",
                },
              ],
            },
            {
              number: 16,
              step: "When cakes are done, cool for 10 minutes before turning out onto wire rack. Set rack over a sheet pan or piece of foil, and using a brush or a spoon, soak each cake with simple syrup. Allow to cool completely.",
              ingredients: [
                {
                  id: 90480,
                  name: "simple syrup",
                  localizedName: "simple syrup",
                  image: "simple-syrup.jpg",
                },
              ],
              equipment: [
                {
                  id: 405900,
                  name: "wire rack",
                  localizedName: "wire rack",
                  image: "wire-rack.jpg",
                },
                {
                  id: 404765,
                  name: "aluminum foil",
                  localizedName: "aluminum foil",
                  image: "aluminum-foil.png",
                },
                {
                  id: 404645,
                  name: "frying pan",
                  localizedName: "frying pan",
                  image: "pan.png",
                },
              ],
              length: {
                number: 10,
                unit: "minutes",
              },
            },
            {
              number: 17,
              step: "Store in an airtight container or wrap tightly.",
              ingredients: [
                {
                  id: 10018364,
                  name: "wrap",
                  localizedName: "wrap",
                  image: "flour-tortilla.jpg",
                },
              ],
              equipment: [],
            },
          ],
        },
      ],
      originalId: null,
      spoonacularSourceUrl:
        "https://spoonacular.com/sweet-florida-orange-breakfast-bread-662515",
    },
  },
  {
    id: 646868,
    value: {
      vegetarian: true,
      vegan: false,
      glutenFree: true,
      dairyFree: false,
      veryHealthy: false,
      cheap: false,
      veryPopular: false,
      sustainable: false,
      weightWatcherSmartPoints: 23,
      gaps: "no",
      lowFodmap: false,
      aggregateLikes: 23,
      spoonacularScore: 32.0,
      healthScore: 2.0,
      creditsText: "Foodista.com – The Cooking Encyclopedia Everyone Can Edit",
      license: "CC BY 3.0",
      sourceName: "Foodista",
      pricePerServing: 101.05,
      extendedIngredients: [
        {
          id: 1053,
          aisle: "Milk, Eggs, Other Dairy",
          image: "fluid-cream.jpg",
          consistency: "liquid",
          name: "cream",
          nameClean: "cream",
          original: "2 cups cream",
          originalName: "cream",
          amount: 2.0,
          unit: "cups",
          meta: [],
          measures: {
            us: {
              amount: 2.0,
              unitShort: "cups",
              unitLong: "cups",
            },
            metric: {
              amount: 473.176,
              unitShort: "ml",
              unitLong: "milliliters",
            },
          },
        },
        {
          id: 1125,
          aisle: "Milk, Eggs, Other Dairy",
          image: "egg-yolk.jpg",
          consistency: "solid",
          name: "egg yolks",
          nameClean: "egg yolk",
          original: "6 egg yolks",
          originalName: "egg yolks",
          amount: 6.0,
          unit: "",
          meta: [],
          measures: {
            us: {
              amount: 6.0,
              unitShort: "",
              unitLong: "",
            },
            metric: {
              amount: 6.0,
              unitShort: "",
              unitLong: "",
            },
          },
        },
        {
          id: 14214,
          aisle: "Tea and Coffee",
          image: "instant-coffee-or-instant-espresso.png",
          consistency: "solid",
          name: "instant coffee granules",
          nameClean: "instant coffee",
          original: "2 Tbs instant coffee granules",
          originalName: "instant coffee granules",
          amount: 2.0,
          unit: "Tbs",
          meta: [],
          measures: {
            us: {
              amount: 2.0,
              unitShort: "Tbs",
              unitLong: "Tbs",
            },
            metric: {
              amount: 2.0,
              unitShort: "Tbs",
              unitLong: "Tbs",
            },
          },
        },
        {
          id: 1077,
          aisle: "Milk, Eggs, Other Dairy",
          image: "milk.png",
          consistency: "liquid",
          name: "milk",
          nameClean: "milk",
          original: "2 cups milk",
          originalName: "milk",
          amount: 2.0,
          unit: "cups",
          meta: [],
          measures: {
            us: {
              amount: 2.0,
              unitShort: "cups",
              unitLong: "cups",
            },
            metric: {
              amount: 473.176,
              unitShort: "ml",
              unitLong: "milliliters",
            },
          },
        },
        {
          id: 19335,
          aisle: "Baking",
          image: "sugar-in-bowl.png",
          consistency: "solid",
          name: "sugar",
          nameClean: "sugar",
          original: "¾ cup sugar",
          originalName: "sugar",
          amount: 0.75,
          unit: "cup",
          meta: [],
          measures: {
            us: {
              amount: 0.75,
              unitShort: "cups",
              unitLong: "cups",
            },
            metric: {
              amount: 177.441,
              unitShort: "ml",
              unitLong: "milliliters",
            },
          },
        },
        {
          id: 2050,
          aisle: "Baking",
          image: "vanilla-extract.jpg",
          consistency: "liquid",
          name: "vanilla extract",
          nameClean: "vanilla extract",
          original: "1 Tbs vanilla extract",
          originalName: "vanilla extract",
          amount: 1.0,
          unit: "Tbs",
          meta: [],
          measures: {
            us: {
              amount: 1.0,
              unitShort: "Tbs",
              unitLong: "Tb",
            },
            metric: {
              amount: 1.0,
              unitShort: "Tbs",
              unitLong: "Tb",
            },
          },
        },
      ],
      id: 646868,
      title: "Home made coffee ice cream",
      readyInMinutes: 45,
      servings: 6,
      sourceUrl:
        "http://www.foodista.com/recipe/4P6G3RHZ/home-made-coffee-ice-cream",
      image: "https://spoonacular.com/recipeImages/646868-556x370.jpg",
      imageType: "jpg",
      summary:
        'Home made coffee ice cream might be just the dessert you are searching for. This recipe serves 6 and costs $1.01 per serving. One serving contains <b>490 calories</b>, <b>7g of protein</b>, and <b>37g of fat</b>. It can be enjoyed any time, but it is especially good for <b>Summer</b>. A couple people made this recipe, and 23 would say it hit the spot. If you have cream, egg yolks, milk, and a few other ingredients on hand, you can make it. It is a good option if you\'re following a <b>gluten free and vegetarian</b> diet. From preparation to the plate, this recipe takes about <b>45 minutes</b>. All things considered, we decided this recipe <b>deserves a spoonacular score of 33%</b>. This score is not so spectacular. Try <a href="https://spoonacular.com/recipes/french-coffee-cake-prepare-home-made-coffee-cake-easily-at-home-600775">French Coffee Cake- prepare home made coffee cake easily at home</a>, <a href="https://spoonacular.com/recipes/home-made-ice-cream-600938">Home Made Ice Cream</a>, and <a href="https://spoonacular.com/recipes/home-made-irish-cream-553413">Home made Irish cream</a> for similar recipes.',
      cuisines: [],
      dishTypes: ["side dish"],
      diets: ["gluten free", "lacto ovo vegetarian"],
      occasions: ["summer"],
      winePairing: {},
      instructions:
        "<ol><li>Combine the cream, milk, sugar, and coffee in a medium, heavy saucepan</li><li>Bring to a gentle boil over medium heat; remove from the heat and set aside.</li><li>Beat the egg yolks in a medium bowl.</li><li>Whisk 1 cup of the hot cream into the egg yolks.</li><li>Add the vanilla extract.</li><li>Gradually add the egg mixture in a slow, steady stream, to the hot cream</li><li>Cook over low heat, stirring constantly until slightly thickened, about 4-5 minutes.</li><li>Remove from the heat and strain through a fine mesh strainer into a clean container.</li><li>Cover with plastic wrap, pressing down against the surface to keep a skin from forming.</li><li>Chill in the refrigerator for at least 2 hours.</li><li>Pour the mixture into an ice cream machine and churn until frozen (according to the manufacturer's instructions).</li><li>Transfer to plastic container and place in the freezer for a few hours before serving.</li><li>Serving: take it out of the freezer for 5-10 minutes before serving, or longer, so it comes to the right scooping temperature.</li><li>Easy suggestion: ice cream is best served in chilled glass or porcelain bowls. Scoop it with a hot, but dry, ice-cream spoon (soak it in boiling water, then wipe dry).</li></ol>",
      analyzedInstructions: [
        {
          name: "",
          steps: [
            {
              number: 1,
              step: "Combine the cream, milk, sugar, and coffee in a medium, heavy saucepan",
              ingredients: [
                {
                  id: 14209,
                  name: "coffee",
                  localizedName: "coffee",
                  image: "brewed-coffee.jpg",
                },
                {
                  id: 1053,
                  name: "cream",
                  localizedName: "cream",
                  image: "fluid-cream.jpg",
                },
                {
                  id: 19335,
                  name: "sugar",
                  localizedName: "sugar",
                  image: "sugar-in-bowl.png",
                },
                {
                  id: 1077,
                  name: "milk",
                  localizedName: "milk",
                  image: "milk.png",
                },
              ],
              equipment: [
                {
                  id: 404669,
                  name: "sauce pan",
                  localizedName: "sauce pan",
                  image: "sauce-pan.jpg",
                },
              ],
            },
            {
              number: 2,
              step: "Bring to a gentle boil over medium heat; remove from the heat and set aside.Beat the egg yolks in a medium bowl.",
              ingredients: [
                {
                  id: 1125,
                  name: "egg yolk",
                  localizedName: "egg yolk",
                  image: "egg-yolk.jpg",
                },
              ],
              equipment: [
                {
                  id: 404783,
                  name: "bowl",
                  localizedName: "bowl",
                  image: "bowl.jpg",
                },
              ],
            },
            {
              number: 3,
              step: "Whisk 1 cup of the hot cream into the egg yolks.",
              ingredients: [
                {
                  id: 1125,
                  name: "egg yolk",
                  localizedName: "egg yolk",
                  image: "egg-yolk.jpg",
                },
                {
                  id: 1053,
                  name: "cream",
                  localizedName: "cream",
                  image: "fluid-cream.jpg",
                },
              ],
              equipment: [
                {
                  id: 404661,
                  name: "whisk",
                  localizedName: "whisk",
                  image: "whisk.png",
                },
              ],
            },
            {
              number: 4,
              step: "Add the vanilla extract.Gradually add the egg mixture in a slow, steady stream, to the hot cream",
              ingredients: [
                {
                  id: 2050,
                  name: "vanilla extract",
                  localizedName: "vanilla extract",
                  image: "vanilla-extract.jpg",
                },
                {
                  id: 1053,
                  name: "cream",
                  localizedName: "cream",
                  image: "fluid-cream.jpg",
                },
                {
                  id: 1123,
                  name: "egg",
                  localizedName: "egg",
                  image: "egg.png",
                },
              ],
              equipment: [],
            },
            {
              number: 5,
              step: "Cook over low heat, stirring constantly until slightly thickened, about 4-5 minutes.",
              ingredients: [],
              equipment: [],
              length: {
                number: 5,
                unit: "minutes",
              },
            },
            {
              number: 6,
              step: "Remove from the heat and strain through a fine mesh strainer into a clean container.Cover with plastic wrap, pressing down against the surface to keep a skin from forming.Chill in the refrigerator for at least 2 hours.",
              ingredients: [
                {
                  id: 10018364,
                  name: "wrap",
                  localizedName: "wrap",
                  image: "flour-tortilla.jpg",
                },
              ],
              equipment: [
                {
                  id: 405600,
                  name: "sieve",
                  localizedName: "sieve",
                  image: "strainer.png",
                },
                {
                  id: 404730,
                  name: "plastic wrap",
                  localizedName: "plastic wrap",
                  image: "plastic-wrap.jpg",
                },
              ],
              length: {
                number: 120,
                unit: "minutes",
              },
            },
            {
              number: 7,
              step: "Pour the mixture into an ice cream machine and churn until frozen (according to the manufacturer's instructions).",
              ingredients: [
                {
                  id: 19095,
                  name: "ice cream",
                  localizedName: "ice cream",
                  image: "vanilla-ice-cream.png",
                },
              ],
              equipment: [
                {
                  id: 404791,
                  name: "ice cream machine",
                  localizedName: "ice cream machine",
                  image: "ice-cream-machine.jpg",
                },
              ],
            },
            {
              number: 8,
              step: "Transfer to plastic container and place in the freezer for a few hours before serving.Serving: take it out of the freezer for 5-10 minutes before serving, or longer, so it comes to the right scooping temperature.Easy suggestion: ice cream is best served in chilled glass or porcelain bowls. Scoop it with a hot, but dry, ice-cream spoon (soak it in boiling water, then wipe dry).",
              ingredients: [
                {
                  id: 19095,
                  name: "ice cream",
                  localizedName: "ice cream",
                  image: "vanilla-ice-cream.png",
                },
                {
                  id: 1053,
                  name: "cream",
                  localizedName: "cream",
                  image: "fluid-cream.jpg",
                },
                {
                  id: 14412,
                  name: "water",
                  localizedName: "water",
                  image: "water.png",
                },
                {
                  id: 10014412,
                  name: "ice",
                  localizedName: "ice",
                  image: "ice-cubes.png",
                },
              ],
              equipment: [
                {
                  id: 404783,
                  name: "bowl",
                  localizedName: "bowl",
                  image: "bowl.jpg",
                },
              ],
              length: {
                number: 10,
                unit: "minutes",
              },
            },
          ],
        },
      ],
      originalId: null,
      spoonacularSourceUrl:
        "https://spoonacular.com/home-made-coffee-ice-cream-646868",
    },
  },
  {
    id: 635418,
    value: {
      vegetarian: true,
      vegan: false,
      glutenFree: false,
      dairyFree: false,
      veryHealthy: false,
      cheap: false,
      veryPopular: false,
      sustainable: false,
      weightWatcherSmartPoints: 21,
      gaps: "no",
      lowFodmap: false,
      aggregateLikes: 25,
      spoonacularScore: 61.0,
      healthScore: 11.0,
      creditsText: "Foodista.com – The Cooking Encyclopedia Everyone Can Edit",
      license: "CC BY 3.0",
      sourceName: "Foodista",
      pricePerServing: 226.97,
      extendedIngredients: [
        {
          id: 18372,
          aisle: "Baking",
          image: "white-powder.jpg",
          consistency: "solid",
          name: "baking soda",
          nameClean: "baking soda",
          original: "1/2 teaspoon baking soda",
          originalName: "baking soda",
          amount: 0.5,
          unit: "teaspoon",
          meta: [],
          measures: {
            us: {
              amount: 0.5,
              unitShort: "tsps",
              unitLong: "teaspoons",
            },
            metric: {
              amount: 0.5,
              unitShort: "tsps",
              unitLong: "teaspoons",
            },
          },
        },
        {
          id: 9040,
          aisle: "Produce",
          image: "bananas.jpg",
          consistency: "solid",
          name: "banana",
          nameClean: "ripe banana",
          original: "½ cups Banana, Mashed, Divided",
          originalName: "Banana, Mashed, Divided",
          amount: 0.5,
          unit: "cups",
          meta: ["divided", "mashed"],
          measures: {
            us: {
              amount: 0.5,
              unitShort: "cups",
              unitLong: "cups",
            },
            metric: {
              amount: 118.294,
              unitShort: "ml",
              unitLong: "milliliters",
            },
          },
        },
        {
          id: 9050,
          aisle: "Produce",
          image: "blueberries.jpg",
          consistency: "solid",
          name: "blueberries",
          nameClean: "blueberries",
          original: "Fresh blueberries",
          originalName: "Fresh blueberries",
          amount: 2.0,
          unit: "servings",
          meta: ["fresh"],
          measures: {
            us: {
              amount: 2.0,
              unitShort: "servings",
              unitLong: "servings",
            },
            metric: {
              amount: 2.0,
              unitShort: "servings",
              unitLong: "servings",
            },
          },
        },
        {
          id: 1124,
          aisle: "Milk, Eggs, Other Dairy",
          image: "egg-white.jpg",
          consistency: "solid",
          name: "egg whites",
          nameClean: "egg whites",
          original: "½ cups Egg Whites",
          originalName: "Egg Whites",
          amount: 0.5,
          unit: "cups",
          meta: [],
          measures: {
            us: {
              amount: 0.5,
              unitShort: "cups",
              unitLong: "cups",
            },
            metric: {
              amount: 118.294,
              unitShort: "ml",
              unitLong: "milliliters",
            },
          },
        },
        {
          id: 1001256,
          aisle: "Milk, Eggs, Other Dairy",
          image: "white-cream.png",
          consistency: "liquid",
          name: "plain greek yogurt",
          nameClean: "plain greek yogurt",
          original: "½ cups Greek Yogurt, Plain",
          originalName: "Greek Yogurt, Plain",
          amount: 0.5,
          unit: "cups",
          meta: ["plain"],
          measures: {
            us: {
              amount: 0.5,
              unitShort: "cups",
              unitLong: "cups",
            },
            metric: {
              amount: 118.294,
              unitShort: "ml",
              unitLong: "milliliters",
            },
          },
        },
        {
          id: 2047,
          aisle: "Spices and Seasonings",
          image: "salt.jpg",
          consistency: "solid",
          name: "salt",
          nameClean: "table salt",
          original: "1 teaspoon salt",
          originalName: "salt",
          amount: 1.0,
          unit: "teaspoon",
          meta: [],
          measures: {
            us: {
              amount: 1.0,
              unitShort: "tsp",
              unitLong: "teaspoon",
            },
            metric: {
              amount: 1.0,
              unitShort: "tsp",
              unitLong: "teaspoon",
            },
          },
        },
        {
          id: 19335,
          aisle: "Baking",
          image: "sugar-in-bowl.png",
          consistency: "solid",
          name: "sugar",
          nameClean: "sugar",
          original: "3/4 cup sugar",
          originalName: "sugar",
          amount: 0.75,
          unit: "cup",
          meta: [],
          measures: {
            us: {
              amount: 0.75,
              unitShort: "cups",
              unitLong: "cups",
            },
            metric: {
              amount: 177.441,
              unitShort: "ml",
              unitLong: "milliliters",
            },
          },
        },
        {
          id: 2050,
          aisle: "Baking",
          image: "vanilla-extract.jpg",
          consistency: "liquid",
          name: "vanilla extract",
          nameClean: "vanilla extract",
          original: "1 teaspoon vanilla extract",
          originalName: "vanilla extract",
          amount: 1.0,
          unit: "teaspoon",
          meta: [],
          measures: {
            us: {
              amount: 1.0,
              unitShort: "tsp",
              unitLong: "teaspoon",
            },
            metric: {
              amount: 1.0,
              unitShort: "tsp",
              unitLong: "teaspoon",
            },
          },
        },
        {
          id: 10020080,
          aisle: "Baking",
          image: "flour.png",
          consistency: "solid",
          name: "whole wheat pastry flour",
          nameClean: "whole wheat pastry flour",
          original: "½ cups Whole Wheat Pastry Flour",
          originalName: "Whole Wheat Pastry Flour",
          amount: 0.5,
          unit: "cups",
          meta: ["whole wheat"],
          measures: {
            us: {
              amount: 0.5,
              unitShort: "cups",
              unitLong: "cups",
            },
            metric: {
              amount: 118.294,
              unitShort: "ml",
              unitLong: "milliliters",
            },
          },
        },
      ],
      id: 635418,
      title: "Blueberry Banana Pancakes",
      readyInMinutes: 45,
      servings: 2,
      sourceUrl:
        "http://www.foodista.com/recipe/QNQXL7YN/blueberry-banana-pancakes",
      image: "https://spoonacular.com/recipeImages/635418-556x370.jpg",
      imageType: "jpg",
      summary:
        'You can never have too many morn meal recipes, so give Blueberry Banana Pancakes a try. This recipe serves 2 and costs $2.29 per serving. Watching your figure? This vegetarian recipe has <b>594 calories</b>, <b>17g of protein</b>, and <b>2g of fat</b> per serving. If you have vanillan extract, banana, pastry flour, and a few other ingredients on hand, you can make it. A couple people made this recipe, and 25 would say it hit the spot. From preparation to the plate, this recipe takes around <b>45 minutes</b>. All things considered, we decided this recipe <b>deserves a spoonacular score of 65%</b>. This score is good. Try <a href="https://spoonacular.com/recipes/blueberry-banana-pancakes-51549">Blueberry-banana Pancakes</a>, <a href="https://spoonacular.com/recipes/blueberry-banana-pancakes-51632">Blueberry-Banana Pancakes</a>, and <a href="https://spoonacular.com/recipes/banana-blueberry-pancakes-534677">Banana Blueberry Pancakes</a> for similar recipes.',
      cuisines: [],
      dishTypes: ["lunch", "main course", "main dish", "dinner"],
      diets: ["lacto ovo vegetarian"],
      occasions: [],
      winePairing: {},
      instructions:
        "<ol><li>Mix greek yogurt, 1/4 cup banana, egg whites & vanilla extract into a small bowl</li><li>In a separate bowl combine flour, baking soda, sugar, & salt</li><li>Combine and whisk till evenly mixed</li><li>Fold in 1/2 cup blueberries</li><li>Place 1/4-cup batter onto non-stick skillet and cook till bubbles start appearing through the top of the pancake and then flip. NOTE: Cook on medium heat and I flattened out my batter with the spatula to cook more evenly.</li><li>About 1-2 minutes on each side</li><li>For the blueberry sauce:</li><li>In a sauce pan, add remaining banana and blueberries and stir until thick, mashing blueberries, about 5-7 minutes. Pour over top of pancakes.</li><li>Note: I used frozen blueberries for sauce and fresh for pancakes.</li><li>Makes  8 pancakes total  serving size 2</li><li>Calorie per serving (4 pancakes total)  231, Fat: .08, Cholesterol: 0, Sodium: 391, Potassium: 304, Carbs: 42, Fiber: 6.6, Sugar: 12, Protein: 14.3</li></ol>",
      analyzedInstructions: [
        {
          name: "",
          steps: [
            {
              number: 1,
              step: "Mix greek yogurt, 1/4 cup banana, egg whites & vanilla extract into a small bowl",
              ingredients: [
                {
                  id: 2050,
                  name: "vanilla extract",
                  localizedName: "vanilla extract",
                  image: "vanilla-extract.jpg",
                },
                {
                  id: 1256,
                  name: "greek yogurt",
                  localizedName: "greek yogurt",
                  image: "plain-yogurt.jpg",
                },
                {
                  id: 1124,
                  name: "egg whites",
                  localizedName: "egg whites",
                  image: "egg-white.jpg",
                },
                {
                  id: 9040,
                  name: "banana",
                  localizedName: "banana",
                  image: "bananas.jpg",
                },
              ],
              equipment: [
                {
                  id: 404783,
                  name: "bowl",
                  localizedName: "bowl",
                  image: "bowl.jpg",
                },
              ],
            },
            {
              number: 2,
              step: "In a separate bowl combine flour, baking soda, sugar, & salt",
              ingredients: [
                {
                  id: 18372,
                  name: "baking soda",
                  localizedName: "baking soda",
                  image: "white-powder.jpg",
                },
                {
                  id: 20081,
                  name: "all purpose flour",
                  localizedName: "all purpose flour",
                  image: "flour.png",
                },
                {
                  id: 19335,
                  name: "sugar",
                  localizedName: "sugar",
                  image: "sugar-in-bowl.png",
                },
                {
                  id: 2047,
                  name: "salt",
                  localizedName: "salt",
                  image: "salt.jpg",
                },
              ],
              equipment: [
                {
                  id: 404783,
                  name: "bowl",
                  localizedName: "bowl",
                  image: "bowl.jpg",
                },
              ],
            },
            {
              number: 3,
              step: "Combine and whisk till evenly mixed",
              ingredients: [],
              equipment: [
                {
                  id: 404661,
                  name: "whisk",
                  localizedName: "whisk",
                  image: "whisk.png",
                },
              ],
            },
            {
              number: 4,
              step: "Fold in 1/2 cup blueberries",
              ingredients: [
                {
                  id: 9050,
                  name: "blueberries",
                  localizedName: "blueberries",
                  image: "blueberries.jpg",
                },
              ],
              equipment: [],
            },
            {
              number: 5,
              step: "Place 1/4-cup batter onto non-stick skillet and cook till bubbles start appearing through the top of the pancake and then flip. NOTE: Cook on medium heat and I flattened out my batter with the spatula to cook more evenly.About 1-2 minutes on each side",
              ingredients: [],
              equipment: [
                {
                  id: 404645,
                  name: "frying pan",
                  localizedName: "frying pan",
                  image: "pan.png",
                },
                {
                  id: 404642,
                  name: "spatula",
                  localizedName: "spatula",
                  image: "spatula-or-turner.jpg",
                },
              ],
              length: {
                number: 2,
                unit: "minutes",
              },
            },
            {
              number: 6,
              step: "For the blueberry sauce:In a sauce pan, add remaining banana and blueberries and stir until thick, mashing blueberries, about 5-7 minutes.",
              ingredients: [
                {
                  id: 9050,
                  name: "blueberries",
                  localizedName: "blueberries",
                  image: "blueberries.jpg",
                },
                {
                  id: 9040,
                  name: "banana",
                  localizedName: "banana",
                  image: "bananas.jpg",
                },
                {
                  id: 0,
                  name: "sauce",
                  localizedName: "sauce",
                  image: "",
                },
              ],
              equipment: [
                {
                  id: 404669,
                  name: "sauce pan",
                  localizedName: "sauce pan",
                  image: "sauce-pan.jpg",
                },
              ],
              length: {
                number: 7,
                unit: "minutes",
              },
            },
            {
              number: 7,
              step: "Pour over top of pancakes.Note: I used frozen blueberries for sauce and fresh for pancakes.Makes  8 pancakes total  serving size 2Calorie per serving (4 pancakes total)  231, Fat: .08, Cholesterol: 0, Sodium: 391, Potassium: 304, Carbs: 42, Fiber: 6.6, Sugar: 12, Protein: 14.3",
              ingredients: [
                {
                  id: 9050,
                  name: "blueberries",
                  localizedName: "blueberries",
                  image: "blueberries.jpg",
                },
                {
                  id: 0,
                  name: "sauce",
                  localizedName: "sauce",
                  image: "",
                },
                {
                  id: 19335,
                  name: "sugar",
                  localizedName: "sugar",
                  image: "sugar-in-bowl.png",
                },
              ],
              equipment: [],
            },
          ],
        },
      ],
      originalId: null,
      spoonacularSourceUrl:
        "https://spoonacular.com/blueberry-banana-pancakes-635418",
    },
  },
];
